import { CurrencyType } from '../../config/common/currency';

const common = {
  CountryList: {
    "Afghanistan": "Afghanistan",
    "ÅlandIslands": "Åland Islands",
    "Albania": "Albania",
    "Algeria": "Algeria",
    "AmericanSamoa": "American Samoa",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Anguilla": "Anguilla",
    "Antarctica": "Antarctica",
    "AntiguaandBarbuda": "Antigua and Barbuda",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Aruba": "Aruba",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaijan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belarus": "Belarus",
    "Belgium": "Belgium",
    "Belize": "Belize",
    "Benin": "Benin",
    "Bermuda": "Bermuda",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivia",
    "BosniaandHerzegovina": "Bosnia and Herzegovina",
    "Botswana": "Botswana",
    "BouvetIsland": "Bouvet Island",
    "Brazil": "Brazil",
    "BritishIndianOceanTerritory": "British Indian Ocean Territory",
    "BruneiDarussalam": "Brunei Darussalam",
    "Bulgaria": "Bulgaria",
    "BurkinaFaso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodia": "Cambodia",
    "Cameroon": "Cameroon",
    "Canada": "Canada",
    "CapeVerde": "Cape Verde",
    "CaymanIslands": "Cayman Islands",
    "CentralAfricanRepublic": "Central African Republic",
    "Chad": "Chad",
    "Chile": "Chile",
    "China": "China",
    "ChristmasIsland": "Christmas Island",
    "CocosKeelingIslands": "Cocos (Keeling) Islands",
    "Colombia": "Colombia",
    "Comoros": "Comoros",
    "Congo": "Congo",
    "CongoTheDemocraticRepublicofthe": "Congo, The Democratic Republic of the",
    "CookIslands": "Cook Islands",
    "CostaRica": "Costa Rica",
    "CoteDIvoire": "Cote D'Ivoire",
    "Croatia": "Croatia",
    "Cuba": "Cuba",
    "Cyprus": "Cyprus",
    "CzechRepublic": "Czech Republic",
    "Denmark": "Denmark",
    "Djibouti": "Djibouti",
    "Dominica": "Dominica",
    "DominicanRepublic": "Dominican Republic",
    "Ecuador": "Ecuador",
    "Egypt": "Egypt",
    "ElSalvador": "El Salvador",
    "EquatorialGuinea": "Equatorial Guinea",
    "Eritrea": "Eritrea",
    "Estonia": "Estonia",
    "Ethiopia": "Ethiopia",
    "FalklandIslandsMalvinas": "Falkland Islands (Malvinas)",
    "FaroeIslands": "Faroe Islands",
    "Fiji": "Fiji",
    "Finland": "Finland",
    "France": "France",
    "FrenchGuiana": "French Guiana",
    "FrenchPolynesia": "French Polynesia",
    "FrenchSouthernTerritories": "French Southern Territories",
    "Gabon": "Gabon",
    "Gambia": "Gambia",
    "Georgia": "Georgia",
    "Germany": "Germany",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Greece": "Greece",
    "Greenland": "Greenland",
    "Grenada": "Grenada",
    "Guadeloupe": "Guadeloupe",
    "Guam": "Guam",
    "Guatemala": "Guatemala",
    "Guernsey": "Guernsey",
    "Guinea": "Guinea",
    "GuineaBissau": "Guinea-Bissau",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "HeardIslandandMcDonaldIslands": "Heard Island and McDonald Islands",
    "VaticanCityState": "Vatican City State",
    "Honduras": "Honduras",
    "HongKong": "Hong Kong",
    "Hungary": "Hungary",
    "Iceland": "Iceland",
    "India": "India",
    "Indonesia": "Indonesia",
    "IranIslamicRepublicOf": "Iran, Islamic Republic Of",
    "Iraq": "Iraq",
    "Ireland": "Ireland",
    "IsleofMan": "Isle of Man",
    "Israel": "Israel",
    "Italy": "Italy",
    "Jamaica": "Jamaica",
    "Japan": "Japan",
    "Jersey": "Jersey",
    "Jordan": "Jordan",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kiribati": "Kiribati",
    "KoreaDemocraticPeopleRepublicof": "Korea, Democratic People's Republic of",
    "KoreaRepublicof": "Korea, Republic of",
    "Kosovo": "Kosovo",
    "Kuwait": "Kuwait",
    "Kyrgyzstan": "Kyrgyzstan",
    "LaoPeopleDemocraticRepublic": "Lao People's Democratic Republic",
    "Latvia": "Latvia",
    "Lebanon": "Lebanon",
    "Lesotho": "Lesotho",
    "Liberia": "Liberia",
    "LibyanArabJamahiriya": "Libyan Arab Jamahiriya",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lithuania",
    "Luxembourg": "Luxembourg",
    "Macao": "Macao",
    "MacedoniaTheFormerYugoslavRepublicof": "North Macedonia",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaysia": "Malaysia",
    "Maldives": "Maldives",
    "Mali": "Mali",
    "Malta": "Malta",
    "MarshalIslands": "Marshall Islands",
    "Martinique": "Martinique",
    "Mauritania": "Mauritania",
    "Mauritius": "Mauritius",
    "Mayotte": "Mayotte",
    "Mexico": "Mexico",
    "MicronesiaFederatedStatesof": "Micronesia, Federated States of",
    "MoldovaRepublicof": "Moldova, Republic of",
    "Monaco": "Monaco",
    "Mongolia": "Mongolia",
    "Montserrat": "Montserrat",
    "Morocco": "Morocco",
    "Mozambique": "Mozambique",
    "Myanmar": "Myanmar",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Netherlands": "Netherlands",
    "NetherlandsAntilles": "Netherlands Antilles",
    "NewCaledonia": "New Caledonia",
    "NewZealand": "New Zealand",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "Niue": "Niue",
    "NorfolkIsland": "Norfolk Island",
    "NorthernMarianaIslands": "Northern Mariana Islands",
    "Norway": "Norway",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "PalestinianTerritoryOccupied": "Palestinian Territory, Occupied",
    "Panama": "Panama",
    "PapuaNewGuinea": "Papua New Guinea",
    "Paraguay": "Paraguay",
    "Peru": "Peru",
    "Philippines": "Philippines",
    "Pitcairn": "Pitcairn",
    "Poland": "Poland",
    "Portugal": "Portugal",
    "PuertoRico": "Puerto Rico",
    "Qatar": "Qatar",
    "Reunion": "Reunion",
    "Romania": "Romania",
    "RussianFederation": "Russian Federation",
    "Rwanda": "Rwanda",
    "SaintHelena": "Saint Helena",
    "SaintKittsandNevis": "Saint Kitts and Nevis",
    "SaintLucia": "Saint Lucia",
    "SaintPierreandMiquelon": "Saint Pierre and Miquelon",
    "SaintVincentandtheGrenadines": "Saint Vincent and the Grenadines",
    "Samoa": "Samoa",
    "SanMarino": "San Marino",
    "SaoTomeandPrincipe": "Sao Tome and Principe",
    "SaudiArabia": "Saudi Arabia",
    "Senegal": "Senegal",
    "SerbiaandMontenegro": "Serbia and Montenegro",
    "Seychelles": "Seychelles",
    "SierraLeone": "Sierra Leone",
    "Singapore": "Singapore",
    "Slovakia": "Slovakia",
    "Slovenia": "Slovenia",
    "SolomonIslands": "Solomon Islands",
    "Somalia": "Somalia",
    "SouthAfrica": "South Africa",
    "SouthGeorgiaandtheSouthSandwichIslands": "South Georgia and the South Sandwich Islands",
    "Spain": "Spain",
    "SriLanka": "Sri Lanka",
    "Sudan": "Sudan",
    "Suriname": "Suriname",
    "SvalbardandJanMayen": "Svalbard and Jan Mayen",
    "Swaziland": "Swaziland",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "SyrianArabRepublic": "Syrian Arab Republic",
    "TaiwanProvinceofChina": "Taiwan, Province of China",
    "Tajikistan": "Tajikistan",
    "TanzaniaUnitedRepublicof": "Tanzania, United Republic of",
    "Thailand": "Thailand",
    "TimorLeste": "Timor-Leste",
    "Togo": "Togo",
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "TrinidadandTobago": "Trinidad and Tobago",
    "Tunisia": "Tunisia",
    "Turkey": "Turkey",
    "Turkmenistan": "Turkmenistan",
    "TurksandCaicosIslands": "Turks and Caicos Islands",
    "Tuvalu": "Tuvalu",
    "Uganda": "Uganda",
    "Ukraine": "Ukraine",
    "UnitedArabEmirates": "United Arab Emirates",
    "UnitedKingdom": "United Kingdom",
    "UnitedStates": "United States",
    "UnitedStatesMinorOutlyingIslands": "United States Minor Outlying Islands",
    "Uruguay": "Uruguay",
    "Uzbekistan": "Uzbekistan",
    "Vanuatu": "Vanuatu",
    "Venezuela": "Venezuela",
    "VietNam": "Viet Nam",
    "VirginIslandsBritish": "Virgin Islands, British",
    "VirginIslandsUS": "Virgin Islands, U.S.",
    "WallisandFutuna": "Wallis and Futuna",
    "WesternSahara": "Western Sahara",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabwe"
  },
  fallback: {
    'Something_Went_Wrong': 'Sorry,Something Went Wrong!',
    'We_are_on_it_will_fix_it_asap':
      'We are on it, will fix it as soon as possible',
    'Go_Back': 'Go Back',
  },

  // Try New UI
  'Try New UI': 'Try New UI',

  //status

  'NEW': 'NEW',
  'SUBMITTED': 'SUBMITTED',
  'APPROVED': 'APPROVED',
  'REJECTED': 'REJECTED',
  // feeback form
  'Share Your Feedback': "Share Your Feedback on New UI",
  'Feedback Form': "New UI Feedback",
  'Subject': "Subject",
  'Please input your subject!': "Please input your subject!",
  'Enter Your Message': "Enter Your Message",
  'Please input your query!': "Please input your query!",
  "Try out our New Das Gateway Features. For Older Version": "You are experiencing the New Gateway UI. For Old Gateway UI",
  "Feel free to share your valuable feedbacks.": "To report any issue, feedback or suggestion on New UI",
  "Click Here": "Click Here",

  // Legacy Notice
  "Notice": "Notice",
  "Legacy Transaction Notice": "Legacy Transaction (V2) is decommissioned as we already migrated to V3 Transaction in September, 2022. Although we would be supporting this Legacy Transaction for Refund & Dispute for designated duration. And therefore you may not find some fresh arrival functionality here in Legacy Transaction (V2).",
  "Legacy Statement Notice": "Legacy Statement (V2) is decommissioned as we already migrated to V3 Statement in September, 2022. Although we would be supporting this Legacy Statement until payout closure. And therefore you may not find some fresh arrival functionality here in Legacy Statement (V2).",
  "Legacy Chargeback Notice": "Legacy Dispute Management (V2) is decommissioned as we already migrated to V3 Dispute Management in September, 2022. Although we would be supporting this Legacy Dispute Management for Chargeback for designated period. And therefore you may not find some fresh arrival functionality here in Legacy Dispute Management (V2).",

  // Timestamp Datepicker
  'ABSOLUTE': 'ABSOLUTE',
  'RELATIVE': 'RELATIVE',
  'Start': 'Start',
  'End': 'End',
  'OK': 'OK',
  'Days': 'Days',



  // login page 
  'Sign in to': 'Sign in to',
  'Payment Options': 'Payment Options',
  'Email Address': 'Email Address',
  'Password': 'Password',
  'Forgot Password?': 'Forgot Password?',
  'Not registered yet?': 'Not registered yet?',
  'Create an Account': 'Create an Account',
  'Merchant Email Address': 'Please enter email address of Merchant',

  //  ValidationSchema
  'Invalid email': 'Invalid email',
  'Required': 'Required',

  // button
  'Login': 'Sign in',
  // Swiper_Login
  'Simplifying Payments,': 'Simplifying Payments,',
  'Enable Growth': 'Enable Growth',
  'Your all-in-one digital payment solutions provider, built to accelerate your business growth.': 'Your all-in-one digital payment solutions provider, built to accelerate your business growth.',
  'Solution Provider,': 'Solution Provider,',
  'Payment Methods': 'Payment Methods',
  'Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.': 'Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.',
  'Fastening Payments,': 'Fastening Payments,',
  'Empowering Growth': 'Empowering Growth',
  'Instantly accept online payments on your website or collect payments using our no code solutions.': 'Instantly accept online payments on your website or collect payments using our no code solutions.',
  // forgot page 
  'Forgot Your Password': 'Forgot Your Password',
  'We will send you help, just enter your email below to receive password instructions.': 'We will send you help, just enter your email below to receive password instructions.',
  //button
  'Submit': 'Submit',
  'Submitting': 'Submitting',
  'Back To Login': 'Back To Sign in',
  // Reset Password
  'Reset Password': 'Reset Password',
  'Enter New Password': 'Enter New Password',
  "Enter Current Password": "Enter Current Password",
  'Confirm New Password': 'Confirm New Password',
  'Password is required': 'Password is required',
  'Password is too short - should be 14 characters minimum.': 'Password is too short - should be 14 characters minimum.',
  'Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.': 'Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.',
  'Passwords must match': 'Passwords must match',

  // ResetPasswordSuccessfull
  'Congratulations': 'Congratulations',
  'Your Password has been successfully changed.': 'Your Password has been successfully changed.',

  // Onboading info and buttons
  'Back': "Back",
  'Next': "Next",
  'Overall Percentage': "Overall Percentage",

  //Create Password
  'Create Password': 'Create Password',
  'CREATE ACCOUNT': 'CREATE ACCOUNT',
  'Password Requirements': 'Password Requirements',
  'Minimum password length should be 14 characters': 'Minimum password length should be 14 characters.',
  "password_req_heading_two": "Password Length: Passwords must be at least 14 characters long.",
  "password_req_heading_three": "Password Complexity: Passwords must contain at least:",
  'should contain a letter.': 'One lowercase letter.',
  'should contain a number.': 'One number.',
  'should contain a uppercase.': 'One uppercase letter.',
  'and should contain a special character.': 'One special character.',
  'Supported Special characters': 'Supported Special characters: ',
  'You’re on the last step of registration!': 'You’re on the last step of registration!',
  'Set your account’s password.': 'Set your account’s password.',
  'I agree with the': 'I agree with the',
  'Terms and Conditions': 'Terms and Conditions',
  'Privacy Policy': 'Privacy Policy',
  'and': 'and',
  "I/We warrant that": "I/We warrant that:",

  // ChooseAccount
  'Choose an Account': 'Choose an Account',
  'What type of account you want to create?': 'What type of account you want to create?',
  'I’m a Merchant': 'I’m a Merchant',
  'I’m a Partner': 'I’m a Partner',
  'Already have an account?': 'Already have an account?',
  'Sign In': 'Sign In',

  // Notification
  'Notifications': 'Notifications',
  'No updates yet': 'No updates yet',
  'Your password is going to expire in': 'Your password is going to expire in',
  'days on': 'days on',
  'To change your password': 'To change your password',
  'Your password has expired': 'Your password has expired',

  //AccountsTab
  'Continue': 'Continue',

  //Create Account Page
  'Create your': 'Create your',
  'Merchant Account': 'Merchant Account',
  'Complete all required fields': 'Complete all required fields',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Business Location': 'Business Location',
  'Phone Number': 'Phone Number',
  'Verify': 'Verify',
  'Verified': 'Verified',
  'Partner Account': 'Partner Account',
  'Partner': 'Partner',
  //OTP Modal
  'Please enter OTP to verify your account': 'Please enter OTP to verify your account',
  'Please check your email account for the verification code we just sent you and enter that code in the box below': 'Please check your email account for the verification code we just sent you and enter that code in the box below',
  'OTP': 'OTP',
  'Didn’t receive code?': 'Didn’t receive code?',
  'Resend OTP': 'Resend OTP',
  'VERIFY': 'VERIFY',
  //Risk Management Page
  'Risk Configuration': 'Risk Configuration',
  'Add Risk Configuration': 'Add Risk Configuration',
  'Choose File': 'Choose File',
  'Add Risk Rule': 'Add Risk Rule',
  'Prohibited': 'Prohibited',
  'Entity Risk Rule': 'Entity Risk Rule',
  'List': 'List',
  'Select_All': "Select All",
  "default": "Default",

  // Add Risk Rule 
  'Prohibited Pan List': 'Prohibited Pan List',
  'Prohibited Country List': 'Prohibited Country List',
  'Prohibited IP List': 'Prohibited IP List',
  'Prohibited Bin List': 'Prohibited Bin List',

  // Bank account Types
  'Normal': 'Normal',
  'Current': 'Current',
  'Savings': 'Savings',
  'Other': 'Other',

  //Delete Confirmation Box
  'Delete': 'Delete',
  'Are you sure?': 'Are you sure?',
  'Do you really want to delete this record? This process can not be undone.': 'Do you really want to delete this record? This process can not be undone.',
  'Cancel': 'Cancel',
  'Upload': 'Upload',
  //Tabs
  'Statement': 'Statement',
  'Trigger Type': 'Trigger Type',
  'PO Entity': 'PO Entity',
  'Action': 'Action',
  'Status': 'Status',

  //NewRiskRule Tab Fields
  'Rule Conditions': 'Rule Conditions',
  'Rule Assignments ': 'Rule Assignments',
  'field_value': '  Value is the value that will be applied to the field',
  'operator': 'Operator is the condition that will be applied to the field',



  //Edit Risk Rule Fields
  'Edit Risk Rule': 'Edit Risk Rule',
  'Prohibited List': 'Prohibited List',
  'Allowed List': 'Allowed List',
  'Click To Choose New File': 'Choose New File',
  'Click To Choose File': 'Choose File',
  'Download Prohibited List': 'Download Prohibited List',
  'Download List': 'Download List',
  'No file chosen': 'No file chosen',
  'Blacklist': 'Blacklist',
  'Field': 'Field',
  'Home': 'Home',
  'PAN': 'PAN',
  'Issuing Country': 'Issuing Country',
  'Bin Numbers': 'Bin Numbers',
  'IP Address': 'IP Address',
  'Enabled': 'Enabled',
  'Disabled': 'Disabled',
  'BLACKLIST': 'BLACKLIST',
  'Allowed BIN List': 'Allowed BIN List',
  'Allowed IP List': 'Allowed IP List',

  //  Options
  'PO Singapore': 'PO Singapore',
  'PO Japan': 'PO Japan',
  'PO Mauritius': 'PO Mauritius',
  'PO Lithuania': 'PO Lithuania',
  'PO Malaysia': 'PO Malaysia',
  'File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.': 'File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.',
  'Max Transaction Amount': 'Max Transaction Amount',
  'Min Transaction Amount': 'Min Transaction Amount',
  // ProductRiskConfiguration
  'Threshold': 'Threshold',
  'Velocity': 'Velocity',
  'TimeFrame': 'TimeFrame',
  'Risk Controls for': 'Risk Controls for',
  'The value of the number must be greater than 0': 'The value of the number must be greater than 0',
  'Value': 'Value',
  'Value must be greater than 0': 'Value must be greater than 0',
  'Value of the number must be greater than 0': 'Value of the number must be greater than 0',
  'JPY': 'JPY',
  'Configure Rules': 'Configure Rules',
  'Months': 'Months',
  'Hours': 'Hours',
  'Minutes': 'Minutes',

  //MFA Screen
  'VERIFY_CODE': 'Please verify your identity with multi factor authentication',
  'ENTER_CODE': 'Enter the verification code provided by your authenticator app',
  'MFA_RESET_BUTTON': 'Back',
  'MFA_SUBMIT_BUTTON': 'Submit',
  'MFA_HAVING_TROUBLE': 'Having trouble? ',
  'RESET_MFA': 'Reset MFA',
  'STEP_1': 'Step 1',
  'STEP_1_DESC': 'Install a compatible application such as ',
  'STEP_1_DESC_2': ' or ',
  'STEP_1_DESC_3': ' app on your mobile device or computer.',
  'STEP_1_DESC_GOOGLE': 'Google Authenticator',
  'STEP_1_DESC_DUO': 'Duo Mobile',
  'STEP_1_DESC_AUTTY': 'Authy',
  'STEP_2': 'Step 2',
  'STEP_2_DESC': 'Open your authenticator app and scan the QR code displayed, or click Show Secret Key to manually enter it into your authenticator app.',
  'STEP_3': 'Step 3',
  'STEP_3_DESC': 'Type two consecutive MFA codes below',
  'ENTER_OTP_1': 'Enter OTP 1',
  'ENTER_OTP_2': 'Enter OTP 2',
  'SKIP_MFA': 'Skip MFA',
  'SHOW_SECRET_KEY': 'Show secret key',
  'COPY_SECRET_KEY': 'Secret Key copied to clipboard!',
  'FAIL_COPY_SECRET_KEY': 'Failed to copy Secret Key.',
  'SCAN_QR_CODE': 'Scan QR code',
  'Skip MFA will remain available for this Release. After Next Release, MFA will be required again for added Security.': 'The "Skip MFA" button will remain available in this release but will be removed in the next release to enforce MFA for added security.',
  "Multi Factor Authentication Setup": "Multi-Factor Authentication Setup",

  // Error Page
  'ERROR_HEADING': 'Oops! Something went wrong.',
  'ERROR_MESSAGE': 'There was a problem processing the Request.',
  'ERROR_BUTTON': 'Return to Last Page',

  // Dispute
  link: "Link",
  Choose: "Choose",
  "Choose...": "Choose...",

  //billing cycle
  "Billing_Cycle": {
    "Daily": "Daily",
    "Weekly": "Weekly",
    "Monthly": "Monthly",
    "Quarterly": "Quarterly",
    "Semiannually": "Semiannually",
    "Annually": "Annually",
  },
  Payment_Cycle: {
    "Daily": "Daily",
    "Weekly": "Weekly",
    "Monthly": "Monthly",
    "N/A": "N/A",
  },

  SUBSCRIPTION_STATUS: {
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    PAUSED: 'PAUSED',
    INITIATED: 'INITIATED',
    PENDING: 'PENDING',
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
    TOKENPAYMENTFAILED: 'TOKEN PAYMENT FAILED',
    TOKENEXPIRED: 'TOKEN EXPIRED',
    INACTIVE: 'INACTIVE'
  },

  //Risk Configuration
  'Payment Attempts': 'Payment Attempts',
  Merchant: {
    Login: {
      label: 'Merchant Sign in',
      // 'email-label': 'Email Address',
      // 'password-label': 'Password',
      // 'forgot-password': 'Forgot Password?',
      // 'not-registered': 'Not registered yet?',
      // 'create-account': 'Create an Account',
      Session_Timeout: 'Session Timeout..!',
      validationSchema: {
        // Invalid_email: 'Invalid email',
        password_not_provided: 'No password provided',
      },
      // button: {
      //   'Login-button': 'Login',
      // },
      Swiper_Login: {
        // headingA: 'Simplifying Payments,',
        // mainTitleA: 'Enable Growth',
        // descriptionA:
        //   'Your all-in-one digital payment solutions provider, built to accelerate your business growth.',
        // headingB: 'Solution Provider,',
        // mainTitleB: 'Payment Methods',
        // descriptionB:
        //   'Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.',
        // headingC: 'Fastening Payments,',
        // mainTitleC: 'Empowering Growth',
        // descriptionC:
        //   'Instantly accept online payments on your website or collect payments using our no code solutions.',
      },
    },
    // ForgotPassword: {
    // label: 'Forgot Your Password',
    // description:
    //   'We will send you help, just enter your email below to receive password instructions.',
    // Fields: {
    //   'email-label': 'Email Address',
    // },
    // button: {
    // 'Submit-button': 'Submit',
    // 'Login-button': 'Back To Login',
    // },
    // },
    ResetPassword: {
      // label: 'Reset Password',
      Fields: {
        'otp-label': 'Enter OTP',
        // 'new-password-label': 'Enter New Password',
        // 'confirm-password-label': 'Confirm New Password',
      },
      errorMessage: {
        // Required: 'Password is required',
        // PasswordLength: 'Password is too short - should be 14 characters minimum.',
        // PasswordLatin:
        //   'Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.',
        // PasswordMatch: 'Passwords must match',
        PasswordShouldNotMatch:
          "Your password cannot be the same as your username or 'admin'.",
      },
      // button: {
      // 'Reset-button': 'Reset Password',
      // },
    },
    ResetPasswordSuccessfull: {
      // label: 'Congratulations',
      // description: 'Your Password has been successfully changed.',
      button: {
        'Login-button': 'Back To Sign in',
      },
    },
    AccountsTab: {
      MerchantAccont: 'CREATE MERCHANT ACCOUNT',
      PartnerAccont: 'CREATE PARTNER ACCOUNT',
      ComingSoon: 'Coming Soon',
      // Continue: 'Continue',
    },
  },

  TransactionsResult: {
    columnDefs: {
      "Action": "Action",
      "TransactionRefID": "Transaction Ref ID",
      "V2UUID": "V2 ID",
      "Amount": "Amount",
      "status": "Status/Type",
      "Date": "Transaction Date",
      "UpdatedTransactionDate": "Updated Date",
      "StartDate": "StartDate",
      "EndDate": "EndDate",
      "DASMID": "DASMID",
      "Scheme": "Scheme",
      "Merchant": "Merchant Account",
      "PaymentType": "Payment Type",
      "Acquirer": "Acquirer",
      "Type": "Type",
      "TransactionType": "Transaction Type",
      "TimeZone": "Transaction TimeZone",
      "IntegrationMethod": "Integration Method",
      "IntegrationType": "Integration Type",
      "CardNumber": "Card Number",
      "MerchantRefID": "Merchant Ref ID",
      "trackID": "Track ID",
      "AcquirerMID": "Acquirer MID",
      "AuthCode": "Auth Code",
      "CurrencyCode": "Currency",
      "productType": "Product Type",
      "subscriptionID": "Subscription ID",
      "TerminalID": "Terminal ID",
      "TerminalName": "Terminal Name",
      "GatewayError": "Gateway Response",
      "ResponseCode": "Response Code",
      "TransactionID": "Transaction ID",
      "LinkName": "Link Name",
      "MerchantAccountEnglish": "Merchant Account (English)",
      "TransactionEvent": "Transaction Event",
      "Event": "Transaction Event",
      "Reseller": "Reseller",
      "Tokenization": "Tokenization",
      "Yes": "Yes",
      "No": "No",
    },
    BreadCrumb: {
      Home: 'Home',
      'Search-Transaction-Result': 'Search Transaction Result',
    },
    'DownloadCSV': 'Transaction Download',
    'Refresh': 'Refresh',
    'AdditionalColumn': 'Additional Column',
    'AdditionalFields': 'Additional Fields',
    'SelectAll': 'Select All',
    'Search': 'Search',
    'note': "Note:",
    'description': "The additional columns you select from the list above will be saved as a user preference and will be included in your transaction list view until you update this setting from here.",
    'filterInfoDescription': 'By default the last 1 month filter is applied to your transactions.',
  },
  TransactionDetailDrawerBody: {
    'TransactionHistory': 'Transaction History',
    'AuditLog': 'Audit Log',
    'Status_Heading': 'EDIT TRANSACTION STATUS',
    'Should be 6 characters long': "Should be 6 characters long.",
    ApprovePopup: {
      'title': 'APPROVE',
      'heading': 'Are you sure?',
      'content': 'Are you sure you want to change the transaction status?',
      button: {
        'cancel': 'Cancel',
        'submit': 'Approve',
      },
    },
    SubscriptionDetails: {
      'Heading': 'Subscription History',
      'BillingCycle': 'Cycle Billed:',
    },
    TokenizationDetails: {
      'Heading': 'Tokenization History',
    },
    ChargebackHistory: {
      'Heading': 'Chargeback History',
    },
    TransactionReportDownload: {
      'TransactionDownload': "Transaction Download",
      'ScheduleReport': "Schedule Report",
      'DownloadReportTitle': "Transaction Details ",
      'Default Applied Filter': "You can search multiple transactions at once through the transaction ref id filter. Simply provide the transaction ref ids with a comma between them.",
      'PleaseApply': "Please apply filters to download Transaction Report",
      'PleaseDownload': "Please download the requested Transaction Report",
      'FileTimeLimit': "Recently downloaded Transaction Reports : (Available for 14 days only)",
      'MaxLimitReachedTitle': "Transaction Download Limit Exceeded",
      'MaxLimitReachedMessage': "You are trying to download more than 300,000 transactions. Please reach out to the Support team for assistance with this request or refine your search using additional filters.",
      'AppliedFilters': "APPLIED FILTERS",
      'RequestDownload': "Request Download",
      'DownloadReport': "Download Report",
      'ReportType': "Report Format",
      "Total Records": "Total Records",
      ColumsnDefs: {
        'Action': "Action",
        'FileName': "Report Name",
        'FileFormat': "Report Format",
        'CreatedAt': "Created At",
        'Filter': "Filters Applied",
        'Status': "Status",
        'NoOfRecords': "#Records",
        'Preferred Report Name': "Preferred Report Name"
      },
      ReportStatus: {
        'Initiated': "Initiated",
        'InProgress': "In Progress",
        'Ready': "Ready",
        'Failure': "Failed"
      },
      "SensitiveColumns": {
        "Include Sensitive Columns": "Include Sensitive Columns",
        "Include Whitelisted Transactions": "Include Whitelisted Transactions",
        "ECI VALUE": "ECI VALUE",
        "AVS": "AVS",
        "ACQUIRER MID": "ACQUIRER MID",
        "HASH CARD NUMBER": "HASH CARD NUMBER",
        "EXPIRY DATE (MM/YY)": "EXPIRY DATE (MM/YYYY)",
      }
    }
  },
  SideMenu: {
    MenuItems: {
      'Dashboard': 'Dashboard',
      'Transactions': 'Transactions',
      'Merchants': 'Merchants',
      'Acquirers': 'Acquirers',
      'Entity': 'Risk Management',
      'Paybylink': 'Pay By Link',
      'Disputemanagement': 'Dispute Management',
      'OnBoarding': 'Registration',
      'Statements': 'Statements',
      'Contact': 'Help & Support',
      'SalesLead': 'Sales Lead',
      'Partner': 'Partner',
      "LegacyTransactions": "Legacy Transactions",
      "LegacyDisputemanagement": "Legacy Dispute Management",
      "LegacyStatement": "Legacy Statements",
      "Reseller": "Reseller",
      "Hash Card": "Hash Card",
    },
  },
  MenuAppBar: {
    UserProfileItems: {
      'LastLogin': 'Last Sign in:',
      'Entity': 'PO Entity:',
      'Access': 'Access Group:',
      'Logout': 'Sign Out',
      'Settings': 'Settings',
      'Change Password': 'Change Password',
      'User Settings': 'User Settings',
      "Sign In As A Merchant": "Sign In as Merchant",
      'Merchant Id': 'Merchant Id',
      "Sign Out as Merchant": "Sign Out as Merchant",
    },
    ToggleText: {
      'Test': 'Test',
      'Live': 'Live',
    },
  },
  FilterPopup: {
    button: {
      'Filter': 'Filter',
      'NextGenFilter': 'Next Generation Filter'
    },
    PoEntityName: {
      'PO Singapore': 'PO Singapore',
      'PO Japan': 'PO Japan',
      'PO Mauritius': 'PO Mauritius',
      'PO Europe': 'PO Europe',
      'PO Hong Kong': 'PO Hong Kong',
      'PO China': 'PO China',
    }
  },
  MerchantList: {
    Merchants_View_ColumnDefs: {
      'Action': 'Action',
      'MerchantAccount': 'Merchant Account',
      'MerchantID': 'Merchant ID',
      'LegalNameInEnglish': 'Merchant Account (English)',
      'LegalName': 'Merchant Account',
      'Products': 'Products',
      'Country': 'PO Entity',
      'CreatedDate': 'Created Date',
      'Status': 'Status',
      'StartDate': '',
      'EndDate': '',
      'DASMID': 'DASMID',
      'ReferredCode': 'Referred Code',
      'AcquirerName': 'Acquirer',
    },
    Product_View_ColumnDefs: {
      'Action': 'Action',
      'MerchantName': 'Merchant Account',
      'ProductName': 'Product Name',
      'type': 'Product Type',
      'MCC': 'Merchant Category Code',
      'DASMID': 'DASMID',
      'AcquirerCode': 'Acquirer',
      Tooltip: {
        'View_Details': 'View Details',
        'AddRiskRule': 'Add Risk Rule',
        'AddPayByLink': 'Add Pay By Link',
        'EnableMID': 'Enable MID',
        'DisableMID': 'Disable MID',
        'EditPayByLink': 'Edit Cart Item',
        'SoftposDevice': 'Softpos Device',
      },
    },
    tabs: {
      'Merchant': 'Merchant View',
      'Product': 'Product View',
    },
    MerchantDetailsTabs: {
      'Merchant Details': 'Merchant Details',
      'Product Details': 'Product Information',
      'User Management': 'User Access Management',
      'Catalog': 'Merchant Catalog',
      'Merchant Settings': 'Merchant Settings',
      'Device Management': 'Device Management',
    },
    MerchantSettingsTabs: {
      'IP Whitelisting': 'IP Whitelisting Configuration',
      'Webhook URL': 'Webhook URL Configuration',
      'Update Public Key': 'Update Public Key',
      'Gateway Public Key': 'Gateway Public Key',
      'Tax Configuration': 'Tax Configuration',
      'Refund Balance': 'Refund Balance Summary',
      'IP_Whitelisting': {
        'Add Ip Address': 'Add IP Address',
        'Edit Ip Address': 'Edit IP Address',
        "Previous Comments": "Previous Comments",
        "no_record_message": "No IP addresses are currently whitelisted.",

        "Column_Def": {
          "IP Address": "IP Address",
          "Status": "Status",
          "Created Date": "Created Date",
          "Created By": "Created By",
          "Updated Date": "Updated Date",
          "Updated By": "Updated By"
        },
        "Form_Fields": {
          "IP Address": "IP Address",
          "Status": "Status",
          "Comments": "Comments",
        },
        'ApprovePopup': {
          'titleAdd': 'ADD IP ADDRESS',
          'titleEdit': 'UPDATE IP ADDRESS',
          'heading': 'Are you sure?',
          'contentAdd': 'Are you sure you want to add the IP Address?',
          'contentEdit': 'Are you sure you want to update the IP Address?',
          'button': {
            'cancel': 'Cancel',
            'submit': 'Submit',
          },
          "Validation": {
            "ExactIPAddress": "Invalid IP Address",
            "MaxLength": "Maximum 128 Characters only."
          },
        },
      },
      'Webhook_Url': {
        'Webhook URL Configure': 'Webhook URL Configure',
        'Add Webhook Url': 'Add Webhook URL',
        'Edit Webhook Url': 'Edit Webhook URL',
        "Previous Comments": "Previous Comments",
        "No Webhook Url Configured": "No Webhook Url Configured",
        "Please proceed to configure Webhook Url": "Please proceed to configure Webhook Url.",
        "Column_Def": {
          "Webhook Url": "Webhook URL",
          "Status": "Status",
          "Created Date": "Created Date",
          "Created By": "Created By",
          "Updated Date": "Updated Date",
          "Updated By": "Updated By",
          "Comments": "Comments",
        },
        "Form_Fields": {
          "Webhook Url": "Webhook URL",
          "Status": "Status",
          "Comments": "Comments",
        },
        'ApprovePopup': {
          'titleAdd': 'ADD WEBHOOK URL',
          'titleEdit': 'UPDATE WEBHOOK URL',
          'heading': 'Are you sure?',
          'contentAdd': 'Are you sure you want to add the Webhook Url?',
          'contentEdit': 'Are you sure you want to update the Webhook Url?',
          'button': {
            'cancel': 'Cancel',
            'submit': 'Submit',
          },
          "Validation": {
            "ExactIPAddress": "Invalid Webhook Url",
            "MaxLength": "Maximum 128 Characters only."
          },
        },
      },
      'Public_Key': {
        'CardTitle': 'Gateway Public Key',
        'FlowTitle': 'Payment Gateway Public Key (Recommended)',
        'FlowDescription': 'The payment gateway generates an RSA key pair. The public key is shared with you to encrypt sensitive card data before sending it to the gateway.',
        'FlowStep1': 'Gateway generates RSA-2048/4096 key pair.',
        'FlowStep2': 'Public key is provided to the merchant.',
        'FlowStep3': 'Merchant encrypts card data using the gateway public key.',
        'FlowStep4': 'Gateway decrypts the payload using its private key stored in secure HSM/KMS.',
        'No Public Key Available': 'No Gateway Public Key Available',
        'No Public Key Available Message': 'The payment gateway public key is not available yet. Please contact support if you need access.',
        'CopyKey': 'Copy Key',
        'GenerateKey': 'Generate Key',
        'DownloadKey': 'Download Key',
        'CopySuccess': 'Public key copied to clipboard.',
        'CopyFailed': 'Failed to copy public key.',
        'DownloadFailed': 'Failed to download public key.',
        'GenerateConfirm': {
          'title': 'GENERATE PUBLIC KEY',
          'heading': 'Are you sure?',
          'contentGenerate': 'Are you sure you want to generate a new gateway public key?',
          'contentRegenerate': 'Generating a new key will replace the existing gateway public key. Are you sure you want to continue?',
          'cancel': 'Cancel',
          'submit': 'Submit',
        },
        'UsageNote': 'Use this public key to encrypt card data before sending encrypted payloads to the payment gateway.',
        'KeyContentUnavailable': 'Use the Download Key button to download the gateway public key PEM file.',
        'EncryptionGuide': {
          'title': 'How to Encrypt Card Data',
          'description': 'Use the downloaded gateway public key to encrypt sensitive card details before sending them to the payment API. Encryption uses RSA-OAEP with SHA-256, and the ciphertext must be Base64-encoded.',
          'step1': '- Download the gateway public key PEM file using the Download Key button above.',
          'step2': '- Build a JSON object with the sensitive card fields (card number, expiry, CVV, etc.).',
          'step3': '- Encrypt the JSON string with RSA-OAEP (SHA-256) using the public key.',
          'step4': '- Send the Base64-encoded ciphertext in your payment API request (e.g. as encryptedData).',
          'note': 'Keep the JSON payload small. For RSA-4096 keys the maximum plaintext size is limited (typically under 500 bytes). Never log or store unencrypted card data.',
          'CopyCode': 'Copy code',
          'CopySuccess': 'Code sample copied to clipboard.',
          'CopyFailed': 'Failed to copy code sample.',
        },
        'Column_Def': {
          'Key Alias': 'Key Alias',
          'Key Spec': 'Key Spec',
          'Merchant ID': 'Merchant ID',
          'Key Name': 'Key Name',
          'Public Key': 'Public Key',
          'Status': 'Status',
          'Created Date': 'Created Date',
          'Updated Date': 'Updated Date',
        },
      },
      'Tax_Configuration': {
        'CardTitle': 'Tax Configuration',
        'Column_Def': {
          'TaxRegistrationNumber': 'Tax Registration Number',
          'TaxName': 'Tax Name',
          'Subsidiary': 'Subsidiary',
          'TaxOnMDR': 'Tax on MDR (%)',
          'TaxOnOtherFees': 'Tax on Other Fees (%)',
        },
        'EnableLabel': 'Enable {{taxName}} on Merchant Catalog',
        'NoConfigTitle': 'No Tax Configuration Available',
        'NoConfigMessage': 'There is no tax configuration set up for this merchant\'s subsidiary yet.',
        'EnableConfirm': {
          'titleEnable': 'ENABLE TAX CONFIGURATION',
          'titleDisable': 'DISABLE TAX CONFIGURATION',
          'heading': 'Are you sure?',
          'contentEnable': 'Are you sure you want to enable {{taxName}} on Merchant Catalog?',
          'contentDisable': 'Are you sure you want to disable {{taxName}} on Merchant Catalog?',
          'cancel': 'Cancel',
          'submit': 'Submit',
        },
      },
    },
    MerchantCatalogs: {
      "MerchantCategory": {
        "Add Category": "Add Category",
        "Edit Category": "Edit Category",
        "View Products": "View Products",
        "Delete Category": "Delete Category",
        "Go Back": "Back To Categories",
        "ColumnsDefs": {
          "CategoryName": "Category Name",
          "CategoryDesc": "Description",
          "CategoryStatus": "Status",
          "CategoryID": "Category ID",
          "CreatedAt": "Created At",
          "UpdatedAt": "Updated At",
        },
        "FormFields": {
          "CategoryName": "Category Name",
          "CategoryDesc": "Description",
          "CategoryStatus": "Status",
          "FoodType": "Food Type",
          "Size": "Portion Size",
        },
        ApprovePopup: {
          'titleAdd': 'ADD CATEGORY',
          'titleEdit': 'UPDATE CATEGORY',
          'heading': 'Are you sure?',
          'contentAdd': 'Are you sure you want to add the Catalog Category?',
          'contentEdit': 'Are you sure you want to update the Catalog Category?',
          'button': {
            'cancel': 'Cancel',
            'submit': 'Submit',
          },
        },
      },
      "MerchantCategoryProducts": {
        "Add Product": "Add Product",
        "Edit Product": "Edit Product",
        "View Products": "View Products",
        "Delete Product": "Delete Product",
        "ColumnsDefs": {
          "ProductName": "Product Name",
          "ProductDesc": "Description",
          "ProductFoodType": "Food Type",
          "ProductSize": "Portion Size",
          "ProductStatus": "Status",
          "CategoryID": "Category ID",
          "ProductPrice": "Price",
          "ProductID": "Product ID",
          "ProductImage": "Image",
          "ProductCode": "Product SKU / Code",
          "CreatedAt": "Created At",
          "UpdatedAt": "Updated At",
          "ProductStock": "Stock",
        },
        "FormFields": {
          "ProductName": "Product Name",
          "ProductDesc": "Description",
          "ProductStatus": "Status",
          "ProductPrice": "Price",
          "ProductImage": "Image",
          "ProductCode": "Product SKU / Code",
          "ProductStock": "Stock",
          "Currency": "Currency",
          "ServiceFee": "Service Fee (%)",
          "EnableServiceFee": "Enable",
          "FoodType": "Food Type",
          "Size": "Portion Size",
          "foodSizeOptions": {
            "Regular": "Regular",
            "Medium": "Medium",
            "Large": "Large",
          },
          "foodTypeOptions": {
            "Non-Veg": "Non-Veg",
            "Veg": "Veg",
          },
        },
        ApprovePopup: {
          'titleAdd': 'ADD PRODUCT',
          'titleEdit': 'UPDATE PRODUCT',
          'heading': 'Are you sure?',
          'contentAdd': 'Are you sure you want to add the Product?',
          'contentEdit': 'Are you sure you want to update the Product?',
          'button': {
            'cancel': 'Cancel',
            'submit': 'Submit',
          },
        },
      },

      "DeviceManagement": {
        "Add Device": "Add Device",
        "Edit Device": "Edit Device",
        "View Products": "View Products",
        "Delete Device": "Delete Device",
        "Go Back": "Back To Device",
        "ColumnsDefs": {
          "RegistrationNumber": "Unique Code",
          "DeviceName": "Device Name",
          "MerchantID": "Merchant ID",
          "DasMid": "DASMID",
          "DeviceType": "Device Type",
          "Status": "Status",
          "CreatedAt": "Date Created",
          "os": "OS",
          "version": "Version",
          "manufacturer": "Manufacturer"
        },
        "FormFields": {
          "RegistrationNumber": "Unique Code",
          "DeviceName": "Device Name",
          "MerchantID": "Merchant ID",
          "DasMid": "DASMID",
          "DeviceType": "Device Type",
          "Status": "Status"
        },
        "StatusOptions": {
          "PENDING": "PENDING",
          "ACTIVE": "ACTIVE",
          "INACTIVE": "INACTIVE"
        },
        "DeviceTypeOptions": {
          "MOBILE": "MOBILE",
          "TABLET": "TABLET"
        },
        ApprovePopup: {
          'titleAdd': 'ADD CATEGORY',
          'titleEdit': 'UPDATE CATEGORY',
          'heading': 'Are you sure?',
          'contentAdd': 'Are you sure you want to add the Catalog Category?',
          'contentEdit': 'Are you sure you want to update the Catalog Category?',
          'button': {
            'cancel': 'Cancel',
            'submit': 'Submit',
          },
        },
      },
    },
    breadcrumbs: {
      'Home': 'Home',
      'Merchants': 'Merchants',
    },
    MerchantTable: {
      'View_Details': 'View Details',
    },
    ApprovePopup: {
      'title': 'Disable MID',
      'heading': 'Are you sure?',
      'content': 'Are you sure you want to disable this MID ?',
      button: {
        'cancel': 'Cancel',
        'submit': 'Approve',
      },
    },
    DeclinePopup: {
      title: 'Enable MID',
      heading: 'Are you sure?',
      content: 'Are you sure you want to enable this MID ?',
      button: {
        cancel: 'Cancel',
        submit: 'Approve',
      },
    },
    EnableDisableMID: {
      placeholder: 'Enable disable MID',
      Active: 'ACTIVE',
      Terminate: 'TERMINATE',
      Pending: 'PENDING',
    },
    Action: 'Action',
    TerminalId: 'Terminal Id',
    TerminalName: 'Terminal Name',
    LocationId: 'Location Id',
  },
  AcquirerList: {
    AcquirerList_ColumnDefs: {
      Action: 'Action',
      AcquirerName: 'Acquirer',
      AcquirerCode: 'Acquirer Code',
      SettlementOffset: 'Settlement Offset',
      DateInserted: 'Date Inserted',
      Status: 'Status',
    },
    breadcrumbs: {
      Home: 'Home',
      Acquirer: 'Acquirer',
    },
    AddAcquirer: 'Add Acquirer',
    EditAcquirer: 'Edit Acquirer',
    AddAcquirerDetails: 'Add Acquirer MID Details',
    AddAcquirerDetail: {
      fields: {
        'Acquirer MID': 'Acquirer MID',
        'INTEGRATION METHOD': 'INTEGRATION METHOD',
        'ACQUIRER IDENTIFIER': 'ACQUIRER CODE',
        'STATUS': 'STATUS',
        'DESCRIPTION': 'DESCRIPTION',
        'Transaction Type': 'Transaction Type',
        'Username': 'Username',
        'Password': 'Password',
        'Is Recurring': 'Is Recurring',
        'Is Tokenised': 'Is Tokenised',
        'Is Dynamic MCC': ' Is Dynamic MCC',
        'Is Block Refund': ' Is Block Refund',
        'Google MID': 'Google MID',
        'Google MID Validation': 'Google MID must only contain letters and numbers'
      },
    },
    EditAcquirerDetails: 'Edit Acquirer MID Details',
  },
  TransactionDetail: {
    TransactionDetailHeading: 'TRANSACTION DETAILS',
    Edit_button: 'Edit Status',
    breadcrumb: {
      Home: 'Home',
      SearchTransactionDetails: 'Search Transaction Result',
    },
    TransactionTile: {
      "Total Sales": "Total Sales",
      "Today Sales": "Today's Sales",
      "Total Refund": "Total Refund",
      "Today Refund": "Today's Refund",
      "Approval Ratio": "Approval Ratio",
    },
    TransactionInfo: {
      label: 'Transaction Info',
      fields: {
        TransactionRefID: 'Transaction Ref ID',
        V2UUID: 'V2 ID',
        DASMID: 'DASMID',
        Merchant: 'Merchant Account',
        LegalNameInEnglish: 'Merchant Account (English)',
        TransactionType: 'Transaction Type',
        ReferenceRemark: 'Reference',
        Date: 'Transaction Date',
        Amount: 'Amount',
        CurrencyCode: 'Currency',
        Response: 'Response Code',
        Status: 'Status',
        AuthCode: 'Auth Code',
        RequestID: 'Request ID',
        CVVResponse: 'CVV Response',
        GatewayError: 'Gateway Response',
        TransactionID: 'Transaction ID',
        TrackID: 'Track ID',
      },
    },
    CustomerDetails: {
      label: 'Cardholder Details',
      field: {
        CardNumber: 'Card Number',
        HashCardNumber: 'Hash Card Number',
        Scheme: 'Scheme',
        ExpiryDate: 'Expiry Date (MM/YYYY)',
        CardHolder: 'Card Holder',
        EmailAddress: 'Email Address',
        Phone: 'Phone Number',
        BillingCountry: 'Billing Country',
        BillingPostcode: 'Billing Postcode',
        BillingAddress: 'Billing Address',
        BillingCity: "Billing City",
        ShippingCountry: 'Shipping Country',
        ShippingPostcode: 'Shipping Postcode',
        ShippingAddress: 'Shipping Address',
        ShippingCity: "Shipping City",
        PaymentType: "Payment Type",
      },
    },
    SubscriptionDetails: {
      label: 'Subscription Details',
      field: {
        SubscriptionID: 'Subscription ID',
        SubscriptionPlan: 'Subscription Plan',
        BillingCycle: 'Billing Cycle',
        NextBilling: 'Next Billing',
        CycleBilled: 'Cycle Billed',
        Status: 'Subscription Status',
      },
    },
    AdditionalInformation: {
      label: 'Additional Information',
      fields: {
        IssuingBank: 'Issuing Bank',
        IssuingCountry: 'Issuing Country',
        BIN: 'BIN',
        TransactionTimezone: 'Transaction Timezone',
        MerchantCategoryCode: 'Merchant Category Code',
        MerchantIP: 'Merchant IP',
        CustomerIP: 'Customer IP',
        MerchantRefNumber: 'MERCHANT REF. ID',
        Acquirer: 'Acquirer',
        AcquirerMID: 'Acquirer MID',
        AcquirerReferenceNumber: 'Acquirer Reference Number',
        eci: 'ECI Value',
        ACQError: 'ACQUIRER RESPONSE',
        Isrecurring: 'Isrecurring',
        Memo: "Memo",
        TerminalID: "TERMINAL ID",
        TerminalName: "Terminal Name",
        PBLLinkName: "Link Name",
        ProductType: "Product Type",
      },
    },
    BrowserInformation: {
      label: 'Browser Information',
      fields: {
        acceptHeader: 'Accept Header',
        screenColorDepth: 'Screen Color Depth',
        javaEnabled: 'Java Enabled',
        challengeWindowSize: 'Challenge Window Size',
        language: 'Language',
        screenHeight: 'Screen Height',
        screenWidth: 'Screen Width',
        challengeWindow: 'Challenge Window',
        userAgent: 'User Agent',
      },
    },
    TransactionHistory: {
      label: 'Transaction History',
    },
    TransactionListButtonPopper: {
      button: {
        Details: 'Details',
      },
    },
    actionButton: {
      REFUND: 'REFUND',
      CAPTURE: 'Capture',
      DISPUTE: 'Dispute',
      Void_Authorisation: 'Void Authorization',
      heading: 'Are you sure?',
      content:
        'Are you sure you want to void this transaction? This process can not be undone.',
      message: {
        refundFailed: 'Refund failed..!',
        captureFailed: 'Capture failed..!',
      },
      button: {
        cancel: 'Cancel',
        submit: 'Submit',
      },
    },
    rufundButton: 'Refund',
    voidButton: 'Void',
    TransactionTabList: {
      'Transaction History': 'Transaction History',
      'Subscription History': 'Subscription History',
      'Tokenization History': 'Tokenization History',
      'Audit Log': 'Audit Log',
      'Rule Evaluation': 'Rule Evaluation',
      'Case History': 'Case History',
      'Chargeback History': 'Chargeback History',
      'Order Overview': 'Order Overview'
    }
  },
  ActionButtons: {
    TransactionEvent: 'Transaction Event',
    PENDING: 'Pending',
    REFUSED: 'Refused',
    CANCELLED: 'Cancelled',
    PURCHASED: 'Purchased',
    CAPTURED: 'Captured',
    AUTHORISED: 'Authorised',
    REFUNDED: 'Refunded',
    ACQERROR: 'Acquirer Error',
    VOIDED: 'Voided',
    PARTIALLY_CAPTURED: 'Partially Captured',
    PARTIALLY_REFUNDED: 'Partially Refunded',
    PRECONDITION_FAILED: 'Precondition Failed',
    NOT_ACCEPTABLE: 'Not Acceptable',
    UNKNOWN_ERROR: 'Unknown Error',
    TIMEOUT: 'Timeout',
    DECLINED: 'Declined',
  },
  RefundTransaction: {
    title: 'ISSUE A REFUND',
    Amount: 'Original Amount',
    RemainingAmount: 'Remaining',
    RefundAmount: 'Refund Amount',
    Reference: 'Reference(Optional)',
    ConfirmRefundCheckbox:
      'Yes, I would like to issue this refund and I understand that this action is not reversible. Kindly proceed to initiate this refund process.',
    helperText: {
      RefundAmount_helperTxt_JP: 'Value of the number must be greater than 1',
      RefundAmount_helperTxt: 'Value of the number must be greater than 0',
      OptionalMessage: 'Maximum 128 Characters only.',
    },
    message: {
      ConfirmRefundCheckbox:
        'Please confirm if you want to proceed with this request.',
      RefundAmount:
        'The value of the number must be up to two decimal number only',
      ref_max_Character: 'Maximum 128 Characters only.',
    },
  },
  Merchant_Detail: {
    MerchantDetail: {
      label: 'Merchant Details',
      fields: {
        LegalName: 'Merchant Account',
        LegalNameInEnglish: 'Merchant Account (English)',
        RegistrationNumber: 'Registration Number',
        SubsidiaryID: 'PO Entity',
        Company_Address_Information: 'Company Address Information',
        City: 'City',
        PostalCode: 'Postal Code',
        Country: 'Country',
        ResellerName: 'Partner Name',
        ResellerNames: 'Partner Names',
        MCC: 'Merchant Category Code',
        MerchantID: 'Merchant ID',
      },
    },
    MerchantRefundBalance: {
      label: 'Refund Balance Summary',
      fields: {
        CustomRefundBalance: 'Custom Refund Balance',
        CurrentRefundBalance: 'Current Refund Balance',
      },
    },
    API_keys: {
      label: 'API Keys',
      fields: {
        Live_API_key: 'Live API key',
        Test_API_key: 'Test API key',
        "Live Key Visible": "Live Key Visible.",
        "Live Key Hidden": "Live Key Hidden.",
        "Test Key Visible": "Test Key Visible.",
        "Test Key Hidden": "Test Key Hidden.",
        "Live Key Encoded": "Live Key Encoded.",
        "Live Key Decoded": "Live Key Decoded.",
        "Test Key Encoded": "Test Key Encoded.",
        "Test Key Decoded": "Test Key Decoded.",
        "Live Key Copied": "Live Key Copied.",
        "Test Key Copied": "Test Key Copied.",
        "Failed to show Key": "Failed to show Key.",
        "Failed to Copy": "Failed to Copy.",
        "Failed to Encode / Decode": "Failed to Encode / Decode.",
      },
    },
    Product_Information: {
      label: 'Product Information',
      columnDefs: {
        Action: 'Action',
        Name: 'Product Name',
        Type: 'Product Type',
        MCC: 'Merchant Category Code',
        DASMID: 'DASMID',
        V2DASMID: 'V2 DAS MID',
        AcquirerMID: 'Acquirer MID',
        OneTimeSetUpFee: 'Setup Fee',
        MonthlyFee: 'Monthly Fee',
        AnnualFee: 'Annual Fee',
        FraudMonitorFee: 'Fraud Monitoring Fee',
        FraudMonitorFeeFrequency: 'Fraud Monitoring Fee (Frequency)',
        SettlementTransferFee: 'Settlement Transfer Fee',
        TransactionFee: 'Success Fee',
        BankFee: 'Decline Fee',
        RefundFee: 'Refund Fee',
        ChargebackFee: 'Chargeback Fee',
        MinFeeAmt: 'Pre-Arbitration Fee',
        MaxFeeAmt: 'Representment Fee',
        RetrievalFee: 'Retrievals Fee',
        MDR: 'MDR',
        MicroMDR: 'Micro MDR',
        RollingReserve: 'Rolling Reserve %',
        RollingReserveHeld: 'Rolling Reserve Held (YTD)',
      },
      View_Details: 'View Details',
      // Add_Risk_Rule: 'Add Risk Rule',
      Edit_Risk_Rule: 'Edit Risk Rule',
      view_subscription_Plan: 'Subscription Plan Details',
      Edit_Subscription_Plan: 'Edit Subscription Plan',
      View_Subscriber: 'Subscriber Detail',
      Edit_Subscriber: 'Edit Subscriber',
      View_Subscriptions: 'View Subscription',
      Create_Subscription: 'Create Subscription',
      Edit_Subscription: 'Edit Subscription',
      View_Scheduler: 'View Scheduler',
    },
    User_Management: {
      label: 'User Access Management',
      columnDefs: {
        Action: 'Action',
        First_Name: 'First Name',
        Last_Name: 'Last Name',
        Email: 'Email Address',
        User_Role: 'User Role',
        Recieve_Notifications: 'Receive Notifications',
        User_Access_Level: 'User Access Level',
        Status: 'Status',
        Join_Date: 'Joining Date',
        Last_Login: 'Last Sign in',
        DASMID: 'DASMID',
        Products: 'Products',
        Notifications: {
          Recieve_Notifications: 'Receive Notifications',
          Chargeback: 'Chargeback',
          Statement: 'Statement',
          Help_Support: 'Help & Support',
          Emergency_Holiday: 'Emergency Holiday',
          Monthly_Public_Holiday: 'Monthly Public Holiday',
        },
      },
      Edit_User: 'Edit User Access',
      Reset: 'Reset Password',
      Deactivate: 'Deactivate User',
      Activate: 'Activate User',
      Delete: 'Delete User',
      button: {
        cancel: 'Cancel',
        submit: 'Submit',
      },
      Add_New_User: {
        add_label: 'Add New User',
        edit_label: 'Edit User',
      },
      User_Roles: {
        Admin: 'ADMIN',
        Viewer: 'VIEWER',
        Editor: 'EDITOR',
        Customer: 'CUSTOMER',
        Expired: 'EXPIRED',
        Staff: 'STAFF',
      },
      Status: {
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        Expired: 'EXPIRED'
      },
      DeletePopup: {
        title: 'Delete',
        heading: 'Are you sure?',
        content:
          'Are you sure you want to delete the user? This process can not be undone.',
        button: {
          cancel: 'Cancel',
          submit: 'Delete',
        },
      },
      DeactivatePopup: {
        title: 'Deactivate',
        heading: 'Are you sure?',
        content:
          'Are you sure you want to deactivate the user? This process can not be undone.',
        button: {
          cancel: 'Cancel',
          submit: 'Confirm',
        },
      },
      ActivatePopup: {
        title: 'Activate',
        heading: 'Are you sure?',
        content:
          'Are you sure you want to activate the user? This process can not be undone.',
        button: {
          cancel: 'Cancel',
          submit: 'Confirm',
        },
      },
      ResetPasswordPopup: {
        title: 'Reset Password',
        heading: 'Are you sure?',
        content:
          'Are you sure you want to reset password ? An email will be sent to notify user. This process cannot be undone',
        button: {
          cancel: 'Cancel',
          submit: 'Confirm',
        },
      },
      ApiMessages: {
        Delete: {
          UserDelete: 'User Deleted successfully.',
          UserDeleteFailed: 'User Deletion Failed.',
        },
      },
    },
    Subscription: {
      label: 'Subscriptions',
      tabs: {
        subscriptionsPlans: 'Subscriptions Plans',
        Subscriptions: 'Subscriptions',
        Subscribers: 'Subscribers',
      },
      columnDefs: {
        action: 'Action',
        planName: 'Plan Name',
        billingCycle: 'Billing Cycle',
        amount: 'Amount',
        trialPeriod: 'Trial Period',
        discount: 'Discount',
        discountPercenatge: 'Discount Percentage',
        discountMonth: 'Discount Month(s)',
        Subscribers: 'Subscribers',
        status: 'Status',
        subscriptionName: 'Subscription Name',
        subscriptionPlan: 'Subscription Plan',
        subscriptionID: 'Subscription ID',
        subscriberName: 'Subscriber Name',
        startDate: 'Start Date',
        endDate: 'End Date',
        nextBilling: 'Next Billing',
        nextBillingDate: 'Next Billing Date',
        cycleBilling: 'Cycle Billed',
        source: 'Source',
        planID: 'Plan ID',
        subscriptionLink: 'Subscription Link',
        trialPeriodFree: 'Trial Period (Free Days)',
        Days: 'Day(s)',
        APIDAYS: 'DAYS',
        Months: 'Month(s)',
        emailAddress: 'Email Address',
        firstName: 'First Name',
        lastName: 'Last Name',
        includes: 'Include',
        immediately: 'Immediately',
        specificDate: 'Specific Date',
        forever: 'Forever',
        after: 'After',
        cycles: 'Cycles',
        linkExpiryDate: 'Link Expiry Date',
        sendSubscriptionLink: 'Send Subscription Link to subscriber',
        billedCycle: 'Billed Cycle',
        phoneNum: 'Phone Number',
        CardNumber: 'Card Number',
        expiryDate: 'Expiry Date',
        country: 'Country',
        subscriptions: 'Subscriptions',
        cvv: 'CVV',
        postCode: 'Postcode',
        billingCountry: 'Billing Country',
        browse: 'Browse',
        currency: 'Currency',
        CreateSubscription: 'Create Subscription',
        firstPercentage: '% First',
        SpecificStartDate: 'Specific Start Date',
        SpecificEndDate: 'Specific End Date',
        'Subscription Type': 'Subscription Type',
        'Discount Percentage': 'Discount Percentage',
        'Discount Month': 'Discount Month',
        'SUBSCRIBER DETAILS': 'SUBSCRIBER DETAILS',
        'SUBSCRIPTION DETAILS': 'SUBSCRIPTION DETAILS',
        'Comments': 'Comments'
      },
      buttons: {
        view: 'View Details',
        copyLink: 'Copy Link',
        edit: 'Edit',
        duplicatePlan: 'Duplicate Plan',
        duplicate: 'Duplicate',
        delete: 'delete',
        cancel: 'Cancel',
        submit: 'Submit',
        addSubscriptionPlan: 'CREATE NEW SUBSCRIPTION PLAN',
        addSubscription: 'CREATE NEW SUBSCRIPTION',
        uploadSubscription: 'IMPORT SUBSCRIPTION',
        regenerateLink: 'REGENERATE LINK',
        createSubscription: 'Create Subscription',
        pauseButton: 'Pause',
        resumeButton: 'Resume',
      },
      drawer: {
        subscriptionPlanDetails: 'Subscription Plan Details',
        addSubscriptionPlan: 'Create New Subscription Plan',
        EditSubscriptionPlan: 'Edit Subscription Plan',
        editSubscriptionPlanDetails: 'Edit Subscription Plan',
        createSubscription: 'Create Subscription',
        SubscriptionDetails: 'Subscription Details',
        EditSubscription: 'Edit Subscription',
        ViewSubscriber: 'Subscriber Details',
      },
      subscriptionDetailsDrawer: {
        subscriberDetails: 'SUBSCRIBER DETAILS',
        subscriptionDetails: 'SUBSCRIPTION DETAILS',
      },
      deletePopup: {
        deleteSubscriptionPlan: 'Delete Subscription Plan',
        deleteSubscriber: 'Delete Subscriber',
        warningMsg: 'Are you sure?',
        deleteSubscription: 'Delete Subscription',
        subscriptionPlanContent:
          'Are you sure you want to delete this subscription plan ? This process cannot be undone.',
        subscriptionContent:
          'Are you sure you want to cancel this subscription ? This process cannot be undone.',
        subscriberContent:
          'Are you sure you want to delete this subscriber ? This process cannot be undone.',
        subscriptionPlanDeleteMsg:
          'Subscription Plan has been deleted successfully.',
        subscriberDeleteMsg: 'Subscriber deleted successfully!',
        pauseSubscription: 'Pause Subscription',
        resumeSubscription: 'Resume Subscription',
        pauseSubscriptionMsg:
          'Are you sure you want to pause this subscription ?',
        resumeSubscriptionMsg:
          'Are you sure you want to resume this subscription ?',
        cancelDescription: 'Cancel Subscription',
      },
      downloadPopup: {
        subscriptionsCSVImport: 'SUBSCRIPTIONS CSV IMPORT',
        popupHeader: 'Please upload your subscriptions list in CSV format.',
        uploadCSVFile: 'UPLOAD CSV FILE',
      },
      duplicatePopup: {
        duplicateSubscription: 'SUBSCRIPTIONS ALREADY EXIST',
        heading: 'This subscriber already has this subscription plan:',
        changePlan: 'CHANGE PLAN',
        overwriteSubscription: 'OVERWRITE SUBSCRIPTION',
      },
      Subscriber: {
        editSubscriber: 'Edit Subscriber',
        paymentDetails: 'Payment Details',
      },
      errorMsg: {
        endDate: 'End Date is required.',
        startDate: 'Start Date is required.',
      },
      subscriberCount:
        'This subscription plan already has existing subscribers.',
      activeSubscriber: 'Subscriber is active',
      subscriptionCreatedSuccessfully: 'Subscription created successfully',
      subscriptionUpdatedSuccessfully: 'Subscription updated successfully',
    },
    ContactDetail: {
      label: 'Contact Details',
      fields: {
        FirstName: 'First Name',
        LastName: 'Last Name',
        MiddleName: 'Middle Name',
        TelephoneNumber: 'Phone Number',
        EmailAddress: 'Email Address',
      },
    },
    breadcrumbs: {
      Home: 'Home',
      Merchants: 'Merchants',
      MerchantsDetails: 'Merchants Details',
    },
  },
  ProductModal: {
    'Merchant Account': 'Merchant Account',
    'Shop Processing URL': 'Shop Processing URL',
    'customerServiceNumber':'Customer Service Number',
    'Merchant Category Code': 'Merchant Category Code',
    'Settlement Currency': 'Settlement Currency',
    'Processing Currency': 'Processing Currency',
    'Acquirer MID': 'Acquirer MID',
    'Recurring Acquirer MID': 'Recurring Acquirer MID',
    'Auth Acquirer MID': 'Auth Acquirer MID',
    'ApplePay MID': 'ApplePay MID',
    'GooglePay MID': 'GooglePay MID',
    'GCash MID': 'GCash MID',
    'PAYPAY MID': 'PAYPAY MID',
    'PayEasy MID': 'PAYEasy MID',
    'Konbini MID': 'Konbini MID',
    'Purchase Acquirer MID': 'Purchase Acquirer MID',
    'DAS MID': 'DASMID',
    'Billing Descriptor': 'Billing Descriptor',
    'Merchant Logo URL': 'Merchant Logo URL',
    'Scheme Types': 'Scheme Types',
    'Acquirer Code': 'Acquirer',
    'Customer Service Number': 'Customer Service Number',
    ConnectionMethods: {
      'Connection Methods': 'Integration Type',
      value: {
        HPP: 'Hosted Payment Page',
        SERVERTOSERVERAPI: 'Server to Server',
      },
    },
    TransactionType: {
      'Transaction Type': 'Transaction Type',
      value: {
        '3DSecure': '3D Secure',
        Non3DSecure: 'Non 3D Secure',
        'CVV2/CVC2': 'CVV2/CVC2',
        'NonCVV2/CVC2': 'Non CVV2/CVC2',
        Recurring: 'Recurring',
        Tokenised: 'Tokenised',
        DynamicMCC: 'Dynamic MCC',
      },
    },
    button: {
      closeButton: 'Close',
    },
  },
  Acquirer_Details: {
    AcquirerDetails: {
      label: 'Acquirer Details',
      fields: {
        AcquirerName: 'Acquirer',
        TimeZone: 'Time Zone',
        URL1: 'Url',
        Country: 'Country',
        ChargebackInvestigationDays: 'Chargeback Investigation Days',
        AcquirerIndentifier: 'Acquirer Code',
        RetrievalInvestigationDays: 'Retrieval Integration days',
        SettlementOffset: 'Settlement Offset',
        Token: 'token',
        Sender: 'sender',
        Channel: 'channel',
        Status: 'Status',
      },
    },
    AcquirerMID: {
      label: 'Acquirer MID Details',
      fields: {
        AcquirerMID: 'Acquirer MID',
        PaymentCurrency: 'Payment Currency',
        SettlementCurrency: 'Settlement Currency',
        Description: 'Description',
        EnterMsg: 'Enter Message',
      },
    },
    breadcrumbs: {
      Home: 'Home',
      Acquirer: 'Acquirer',
      AcquirerDetails: 'Acquirer Details',
    },
  },
  Add_Acquirer: {
    AddAcquirer: {
      label: 'Add Acquirer',
      fields: {
        AddAcq: 'Acquirer',
        TimeZone: 'Time Zone',
        URL1: 'Url',
        Country: 'Country',
        ChargebackInvestigationDays: 'Chargeback Investigation Days',
        AcquirerIndentifier: 'Acquirer Code',
        RetrievalInvestigationDays: 'Retrieval Integration days',
        SettlementOffset: 'Settlement Offset',
        Status: 'Status',
        Token: 'Token',
        Sender: 'Sender',
        SenderHelperText: 'Acquirer MID for Acquirer MineSec.',
        Channel: 'Channel',
        ChannelHelperText: 'Terminal ID (TID) for Acquirer MineSec.',
        URLMaxLimitMessage: 'Maximum 256 Characters only.',
        NameMaxLimitMessage: 'Maximum 128 Characters only.',
        CodeMaxLimitMessage: 'Maximum 45 Characters only.',
      },
      breadcrumb: {
        Home: 'Home',
        Acquirer: 'Acquirer',
        AddAcquirer: 'Add Acquirer',
      },
      button: {
        Submit: 'Submit',
        Cancel: 'Cancel',
      },
    },
  },
  EditAcquirer: {
    label: 'Edit Acquirer Details',
    breadcrumb: {
      Home: 'Home',
      Acquirer: 'Acquirer',
      AcquirerDetails: 'Acquirer Details',
      EditAcquirer: 'Edit Acquirer',
    },
  },
  Filter: {
    AdvancedFilters: 'Advanced Filters',
    AdvancedNextGenFilters: 'Next Generation Filter',
    Add_New_Filter: 'Add New Filter',
    button: {
      Reset: 'Reset',
      Apply: 'Apply',
    },
    field: 'Field',
    Value: 'Value',
    Operator: 'Operator',
    NoReferredMerchants: 'No referred merchants',
    AUTHORISATION: 'Authorization',
    PURCHASE: 'Purchase',
    CAPTURE: 'Capture',
    VOIDAUTHORISATION: 'Void Authorization',
    REFUND: 'Refund',
    SUCCESSFUL: 'Successful',
    NOTSUCCESSFUL: 'Not Successful',
    PENDING: 'Pending',
    SELECTDATERANGE: 'Select Date Range',
    ECOM: 'ECOM',
    QR: 'QR',
    PBL: 'PBL',
    SUBSCRIPTION: 'SUBSCRIPTION',
    SCHEDULER: 'SCHEDULER',
    MOTO: 'MOTO',
    SOFTPOS: 'SOFTPOS'
  },
  ISSUE_A_REFUND: {
    label: 'ISSUE A REFUND',
    button: {},
  },
  FormTemplate: {
    button: {
      Submit: 'Submit',
      Cancel: 'Cancel',
    },
  },
  ProductRiskRuleDrawerModal: {
    currency: {
      // JPY: 'JPY',
      SGD: 'SGD',
    },
    DownloadProhibitedList: 'Download Prohibited List',
    // RISK_CONFIGURATION: 'Risk Configuration',
    // 'transaction-title': 'Risk Controls for',
    // Statement: 'Statement',
    Trigger_Type: 'Trigger Type',
    Action: 'Action',
    // Configure_Rules: 'Configure Rules',
    Blacklist: 'Blacklist',
    Threshold: 'Threshold',
    Velocity: 'Velocity',
    Whitelist: "Whitelist",
    Refund_Percentage: 'Refund Percentage',
    Max_Volume: 'Volume',
    // ProhibitedList: 'Prohibited Country List',
    // Field: 'Field',
    TimeFrame: 'TimeFrame',
    Select_Currency: "Select Currency",
    Total_payout: "Total Payout",
    Allowable_Refund: 'Allowable Refund %',
    Refund_Balance: 'Allowable Refund Amount',
    Remaining_Refund_Amount: 'Remaining Refund Amount',
    Settlement_Period: 'Settlement Period',
    Payment_Cycle: 'Payment Cycle',
    Statement_Status: 'Statement Status',
    // Value: 'Value',
    // Required: 'Required',
    // Choose_File: 'Choose File',
    // No_File_Chosen: 'No file chosen',
    // Edit_Ridk_Rule: 'Edit Risk Rule',
    Add_Risk_configuration: 'Add Risk Configuration',
    button: {
      Submit: 'Submit',
      Cancel: 'Cancel',
    },
    // helperText: {
    // Threshold: 'Value of the number must be greater than 0',
    // TimeFrame: 'Value must be greater than 0',
    // Value: 'The value of the number must be greater than 0',
    // },
    option: {
      IssuingCountry: 'Issuing Country',
      // PAN: 'PAN',
      // IPAddress: 'IP Address',
      Field: 'Max Transaction Amount',
      MaxTransactionAmount: 'Max Transaction Amount',
      MinTransactionAmount: 'Min Transaction Amount',
      MaxVolume: 'Maximum Volume',
      "REFUND": "Refund Count",
      "REFUND_VOLUME": "Refund Volume"
    },
    message: {
      Value: 'The value of the number must be up to two decimal number only',
    },
  },
  ProductEnableDisableMid: {
    heading: 'Enable / Disable MID',
  },
  TransactionCaptureDrawerBody: {
    ISSUE_A_CAPTURE: 'ISSUE A CAPTURE',
    fields: {
      Original_Amount: 'Original Amount',
      Remaining: 'Remaining',
      CaptureAmount: 'Capture Amount',
      Reference: 'Reference(Optional)',
      ConfirmCaptureCheckbox:
        'Yes, I would like to capture the amount and I understand that this action is not reversible. Kindly proceed to initiate this capture process.',
    },
    helperText: {
      CaptureAmountJP: 'Value of the number must be greater than 1',
      CaptureAmount: 'Value of the number must be greater than 0',
      OptionalMessage: 'Maximum 128 Characters only.',
    },
    message: {
      ConfirmCaptureCheckbox:
        'Please confirm if you want to proceed with this request.',
      CaptureAmount:
        'The value of the number must be up to two decimal number only',
      notification: 'Capture amount should not be more than remaining amount.',
      ref_max_Character: 'Maximum 128 Characters only.',
    },
    button: {
      Submit: 'Submit',
      Cancel: 'Cancel',
    },
  },
  TransactionRefundDrawerBody: {
    notification: 'Refund amount should not be more than remaining amount.',
  },
  TransactionCSVDownload: {
    heading: 'CSV Download Options',
    subTitle: 'Please select the date range to download CSV ',
    label: 'Select Date Range',
    downloadCsv: 'Please download CSV',
  },
  EntityRiskConfiguration: {
    // label: 'Risk Configuration',
    // Risk_ColumnDefs: {
    //  Statement: 'Statement',
    //  Type: 'Trigger Type',
    //  POEntity: 'PO Entity',
    //  action: 'Action',
    //  enabled: 'Status',
    // },
    // Confirmation_Dialog: {
    // title: 'Delete',
    //   heading: 'Are you sure?',
    //   content:
    //     'Do you really want to delete this record? This process can not be undone.',
    // },
    fields: {
      // subsidiaryID: 'PO Entity',
      // statement: 'Statement',
      // type: 'Trigger Type',
      // fieldBlackList: 'Field',
      // blacklisteditems: 'Prohibited Country List',
      // blacklistedbins: 'Prohibited Bin List',
      // blacklistedpan: 'Prohibited Pan List',
      // blacklistedip: 'Prohibited IP List',
      enabled: 'Status',
      errorMessage:
        'File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.',
    },
    form_title: 'Configure Rules',
    file_upload: {
      // label: 'Prohibited List',
    },
    button: {
      Submit: 'Submit',
      Cancel: 'Cancel',
    },
    breadcrumbs: {
      Home: 'Home',
      // Rules: 'Entity Risk Rule',
    },
    options: {
      Singapore: 'PO Singapore',
      Japan: 'PO Japan',
      Mauritius: 'PO Mauritius',
      Lithuania: 'PO Lithuania',
      Malaysia: 'PO Malaysia',
    },
    TriggerTypeValues: {
      VELOCITY: "VELOCITY",
      BLACKLIST: "BLACKLIST",
      THRESHOLD: "THRESHOLD",
      WHITELIST: "WHITELIST",
      REFUND: "REFUND",
      VOLUME: "VOLUME"
    },
    // TriggerType: 'Blacklist',
    // BinNumbers: 'Bin Numbers',
    // IP_Address: 'IP Address',
    // IssuingCountry: 'Issuing Country',
    // PAN: 'PAN',
    // Status: {
    //   Enabled: 'Enabled',
    //   Disabled: 'Disabled',
    // },
  },
  PayByLinkConfiguration: {
    'Pay By Link': 'Pay By Link',
    'Das Pay By Link': 'Das Pay By Link',
    PayByLink_ColumnDefs: {
      action: 'Action',
      link: 'Link ID',
      linkname: "Link Name",
      linknameoptional: "Link Name (Optional)",
      generateddate: 'Generated Date',
      amount: 'Total Amount',
      expirydate: 'Expiry Date',
      reminderdate: 'Reminder Date',
      status: 'Status',
    },
    PayByLink_ColumnDefs_Buttons: {
      'View Details': 'View Details',
      'View Link': 'View Link',
      'Copy Link': 'Copy Link',
    },
    Create_link_button: {
      'Create New Link': 'Create New Link',
    },
    'Pay By Link For': 'Pay By Link For',
    Link_fields: {
      'Set Reminder': 'Set Reminder',
      'Expiry Date': 'Expiry Date',
      'Let customer adjust quantity': 'Let customer adjust quantity',
      'Allow Promocodes': 'Allow Promocodes',
    },
    Pbl_button: {
      'Generate Link': 'Generate Link',
      'Deactivate Link': 'Deactivate Link',
    },
    message: {
      'Value is not a number': 'Value is not a number',
    },
    Generate_button: {
      copy: 'Copy',
      preview: 'Preview',
    },
    Cart_Details: {
      'Cart Items': 'Cart Items',
      'Total': 'Total:',
    },
    Message_Update: {
      PayByLINK_Details_Updated: 'PayByLINK Details Updated',
      Order_Link_Desactivated: 'Order Link Deactivated',
    },
    Confirmation_Dialog: {
      'LEAVE PAGE': 'LEAVE PAGE?',
      'Are you sure': 'Are you sure',
      'you want to leave this page': 'you want to leave this page?',
      'content':
        'Changes you made to this link may not be saved. Please regenerate this link.',
      'STAY': 'STAY',
      'EXIT': 'EXIT',
    },
    Confirmation_Delete_Dialog: {
      'Delete': 'Delete',
      'Are you sure': 'Are you sure?',
      'content':
        'Do you really want to delete this record? This process can not be undone.',
      'cancel': 'Cancel',
      'submit': 'Submit',
    },
    Confirmation_Deactivate_Dialog: {
      title: 'Deactivate Link',
      heading: 'Are you sure?',
      content:
        'Do you really want to deactivate this link? This process can not be undone.',
      cancel: 'Cancel',
      submit: 'Submit',
    },
    PblDelete_item: {
      delete_item: 'At least one item should be added to the cart.',
    },
    file_upload: {
      fileSize:
        'File is too large, maximum allowed size is $maxSize KB. Current file has $size KB.',
      imageType: 'Image format is not supported.',
    },
    PblProduct_ColumnDefs: {
      action: 'Action',
      photo: 'Photo',
      products: 'Products',
      quantity: 'Quantity',
      price: 'Unit Price',
      totalPrice: 'Total Price',
    },
    PblProduct_ColumnDefs_Buttons: {
      'Edit Item': 'Edit Item',
      'Delete Item': 'Delete Item',
    },
    Add_Product_button: {
      'Add New Item': 'Add New Item',
    },
    Product_fields: {
      productname: 'Product Name',
      quantity: 'Quantity',
      currency: 'Select Currency',
      price: 'Unit Price',
      upload: 'Upload Photo',
      wantToUploadImage: 'Want to upload image',
      Yes: 'Yes',
      No: 'No',
      errorMsg: {
        'MaxLimit Message': 'Maximum 255 Characters only.',
        'MaxNameLimit Message': 'Maximum 100 Characters only.',
        'Price Min ZeroDecimal': 'Value must be greater than or equal to 1 {{currency}}',
        'Price Max ZeroDecimal': 'Value must be less than or equal to 9,999,999 for {{currency}}',
        'Price Min': 'Value must be greater than or equal to 0.01',
        'Price Max': 'Value must be less than or equal to 9,999,999.99',
        'Price Whole Number': 'Value must be a whole number for {{currency}}',
        'Price Decimal Places': 'Value can have a maximum of 2 decimal places.'
      }
    },
    Product_button: {
      'Add To Cart': 'Add To Cart',
      'Cancel': 'Cancel',
    },
    BreadCrumb: {
      Home: 'Home',
      paybylink: 'Pay By Link',
    },
  },
  CreateThresholdEndAdornment: {
    Payment_Attempts: 'Payment Attempts',
  },
  // CreateTimeFrameAdornment: {
  //   Months: 'Months',
  //   Hours: 'Hours',
  //   Minutes: 'Minutes',
  // },
  PoMidSchema: {
    QR: {
      Merchant_Name: 'Merchant Name',
      'Merchant Category Code': 'Merchant Category Code',
      'Currency': 'Currency',
      'Acquirer MID': 'Acquirer MID',
      'DAS MID': 'DASMID',
      'Location Name': 'Location Name',
      'Terminal ID': 'Terminal ID',
      'Terminal Name': 'Terminal Name',
      'Merchant Logo URL': 'Merchant Logo URL',
      'Billing Descriptor': 'Billing Descriptor',
      'Scheme Types': 'Scheme Types',
      TransactionType: {
        'Transaction Type': 'Transaction Type',
        value: {
          '3DSecure': '3D Secure',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': 'Non CVV2/CVC2',
          Non3DSecure: 'Non 3D Secure',
        },
      },
      Generate_label: 'Select Currency to generate QR',
      button: {
        Download_QR: 'Download QR',
        Generate_QR: 'Generate QR',
      },
    },
  },
  PoMidSchemaPBL: {
    PBL: {
      Merchant_Name: 'Merchant Name',
      MCC: 'Merchant Category Code',
      Currency: 'Currency',
      Acquirer_MID: 'Acquirer MID',
      DASMID: 'DASMID',
      Location_name: 'Location name',
      TerminalID: 'Terminal ID',
      MerchantLogoURL: 'Merchant Logo URL',
      BillingDescriptor: 'billing descriptor',
      SchemeTypes: 'scheme types',
      TransactionType: {
        label: 'Transaction Type',
        value: {
          '3DSecure': '3D Secure',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': 'Non CVV2/CVC2',
          Non3DSecure: 'Non 3D Secure',
          Recurring: 'Recurring',
        },
      },
    },
  },
  PoMidSchemaSCHEDULER: {
    SCHEDULER: {
      Merchant_Name: 'Merchant Name',
      MCC: 'Merchant Category Code',
      Currency: 'Currency',
      Acquirer_MID: 'Acquirer MID',
      DASMID: 'DASMID',
      Location_name: 'Location name',
      TerminalID: 'Terminal ID',
      MerchantLogoURL: 'Merchant Logo URL',
      BillingDescriptor: 'billing descriptor',
      SchemeTypes: 'scheme types',
      TransactionType: {
        label: 'Transaction Type',
        value: {
          '3DSecure': '3D Secure',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': 'Non CVV2/CVC2',
          Non3DSecure: 'Non 3D Secure',
          Recurring: 'Recurring',
        },
      },
    },
  },
  PoMidSchemaMOTO: {
    MOTO: {
      Merchant_Name: 'Merchant Name',
      MCC: 'Merchant Category Code',
      Currency: 'Currency',
      Acquirer_MID: 'Acquirer MID',
      DASMID: 'DASMID',
      Location_name: 'Location name',
      TerminalID: 'Terminal ID',
      MerchantLogoURL: 'Merchant Logo URL',
      BillingDescriptor: 'billing descriptor',
      SchemeTypes: 'scheme types',
      TransactionType: {
        label: 'Transaction Type',
        value: {
          '3DSecure': '3D Secure',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': 'Non CVV2/CVC2',
          Non3DSecure: 'Non 3D Secure',
          Recurring: 'Recurring',
        },
      },
    },
  },
  AddNewProduct: {
    Tooltip: 'Go Back',
    Title: 'Cart Items',
  },
  constants: {
    Failure: {
      ACTION_INVALID_USER: 'Invalid username or password',
    },
    SUCCESS: {
      ACTION_VOID_AUTHORIZATION: 'The transaction is voided successfully.',
      ACTION_CAPTURE: 'The amount is captured successfully.',
      ACTION_REFUND: 'The amount is refunded successfully.',
    },
  },
  RiskManagement: {
    CreateRule: 'CREATE NEW RULE',
    NoLevels: 'No Level',
    Schema: {
      tooltip: {
        fieldSelect: 'Select the transaction attribute to be used for rule evaluation',
        valueText: 'Enter the value that will be compared against the selected field',
        valueSelect: 'Select the value that will be compared against the selected field',
        levelField: 'Select the level to be used for rule evaluation',
        levelValue: 'Enter the level value that will be compared against the selected level type',
      }
    }
  },
  DisputeManagement: {
    'Dispute Management': 'Dispute Management',
    'Status_Heading': 'EDIT CHARGEBACK CASE',
    InformationCards: {
      TOTALDISPUTES: {
        'heading': 'TOTAL DISPUTES',
      },
      TOTALAMOUNTSGD: {
        'heading': 'TOTAL AMOUNT',
        'currencySGD': CurrencyType.SGD,
      },
      TOTALAMOUNTJAPAN: {
        'heading': 'TOTAL AMOUNT',
        'currencyJPY': CurrencyType.JPY,
      },
    },
    DrawerType: {
      StatusType: {
        'open': 'Open',
        'progress': 'In Progress',
        'represented': 'Not Represented',
        'closed': 'Closed',
        'expired': 'Expired',
      },
    },
    DisputeDetailHeading: 'DISPUTE CASE DETAILS',
    CaseDiscussion: {
      'label': 'Case Discussion',
      fields: {
        'Message': 'Message',
        'AddFile': 'Add File',
      },
      button: {
        'Submit': 'Send',
      },
    },
    ChallangeDispute: 'CHALLENGE DISPUTE',
    CaseHistory: {
      'label': 'Case History',
      'RetrievalRequest': 'Retrieval Request',
      'FirstChargeback': 'First Chargeback',
      'SecondChargeback': 'Second Chargeback',
      'Reversal': 'Chargeback Reversal',
      'LostFund': 'Lost Funds',
      'CaseClosed': 'Case Closed',
      'InternalDispute': 'Internal Dispute',
      'AutoRepresentment': 'Auto Representment',
      'ChargebackReversal': 'Chargeback Reversal',
      'CaseCreated': 'Case Created',
      'EvidenceUnderReview': 'Evidence Under Review',
      'CaseReOpened': 'Case Reopened',
      'CaseUpdated': 'Case Updated',
    },
    OrignalHistory: {
      'Orignal Transaction History': 'Orignal Transaction History',
    },
    columnDefs: {
      'Action': 'Action',
      'ChargebackCaseID': 'Case ID',
      'DASMID': 'DASMID',
      'Merchant': 'Merchant Account',
      'MerchantInEnglish': 'Merchant Account (English)',
      'CaseType': 'Case Type',
      'ReasonID': 'Reason ID',
      'ReasonCategory': 'Reason Description',
      'STATUS': 'Status',
      'Amount': 'Dispute Amount',
      'Currency': 'Currency',
      'IssueDate': 'Issued Date',
      'DueDate': 'Due Date',
      'UpdatedAt': 'Updated Date',
      'ARN': 'ARN',
      'Acquirer': 'Acquirer',
      'OrderCode': 'Transaction Ref Id',
      'Fees': 'Fees',
      'StatementID': 'Statement ID',
      'Statement_ID': 'Statement ID'
    },
    DetailInfo: {
      'Case Info': 'Case Info',
      fields: {
        'Chargeback Case ID': 'Case ID',
        'Merchant': 'Merchant Account',
        'MerchantInEnglish': 'Merchant Account (English)',
        'ARN': 'ARN',
        'Auth Code': 'Auth Code',
        'Case Type': 'Case Type',
        'Date': 'Issued Date',
        'Cycle': 'Cycle',
        'Reason Category': 'REASON DESCRIPTION',
        'Card Number': 'CARD NUMBER',
        'Amount': 'Dispute Amount',
        'Currency': 'Currency',
        'Due Date': 'Due Date',
        'DASMID': 'DASMID',
        'Acquirer': 'Acquirer',
        'STATUS': 'Status',
        'Order Code': 'Order Code',
        'Time Left': 'Time Left',
        'Fees': 'Fees',
        'StatementID': 'Statement ID'
      },
    },
    BreadCrumb: {
      'Home': 'Home',
      'list': 'Dispute Management',
    },
    DownloadCSV: 'Download CSV',
    SentToAcquirer: 'Sent To Acquirer',
    IssueChargeback: 'CREATE NEW',
    DisputeListButtons: {
      'Details': 'Details',
      'Complete': 'Sent To Acquirer',
      'Accept': 'Accept Dispute',
      'Challenge': 'Challenge Dispute',
      'Evidence': 'Submit Evidence',
      'Missing Info': 'Missing Info',
      'Missing Information': 'Missing Information',
      'label': 'Please upload evidence in Case Discussion.',
      'Case Close': 'Close Case',
      'Edit': 'Edit'
    },
    Status: {
      'CASE STATUS': 'CASE STATUS',
      'open': 'open',
    },
    FilterStatus: {
      'open': 'Open',
      'closed': 'Closed',
    },
    AutoLodge: {
      'Title': 'Auto Lodge Chargeback',
      'Button': 'AUTO LODGE',
      'UploadInstruction': 'Upload Chargeback File for Auto Lodge (Format XLSX)',
      'DragDropText': 'Drag and drop your file here',
      'FormatNote': 'Note: Please ensure your file follows the required template format. Only .xlsx files are accepted. The sheet must be named "Chargeback".',
      'InvalidFileType': 'Invalid file type. Please upload an Excel file (.xlsx)',
      'FileTooLarge': 'File size exceeds 5MB limit',
      'NoFileSelected': 'Please select a file to upload',
      'UploadSuccess': 'Chargebacks uploaded successfully',
      'UploadFailed': 'Failed to upload chargebacks. Please try again.',
      'DownloadTemplate': 'Download Template',
      'TemplateHint': 'Use this template to ensure correct format',
      'TemplateDownloaded': 'Template downloaded successfully',
      'TemplateDownloadFailed': 'Failed to download template',
      'RequiredColumns': 'Required Columns (in order)',
      'MandatoryNote': '* Columns marked with asterisk (*) and orange border are mandatory',
      'Validating': 'Validating file...',
      'ValidationSuccess': 'File validation successful! Ready to upload.',
      'ValidationFailed': 'Validation failed. Please fix the errors below.',
      'ValidationError': 'Error occurred during validation',
      'ValidationErrors': 'Validation Errors',
      'AllRowsValid': 'All rows are valid and ready for upload',
      'ValidationErrorsFound': 'Validation errors found. Please fix and re-upload.',
      'FixValidationErrors': 'Please fix validation errors before uploading',
      'MoreErrors': '...and {{count}} more errors',
      'Columns': {
        'Case Type': 'Case Type',
        'Merchant Account': 'Merchant Account',
        'Acquirer': 'Acquirer',
        'DASMID': 'DASMID',
        'Dispute Amount': 'Dispute Amount',
        'Issue Date (SGT)': 'Issue Date (SGT)',
        'Due Date': 'Due Date',
        'Card Number': 'Card Number',
        'Transaction Date (SGT)': 'Transaction Date (SGT)',
        'Transaction Amount': 'Transaction Amount',
        'Transaction Ref Id': 'Transaction Ref Id',
        'Reason Code': 'Reason Code',
        'ARN': 'ARN',
      },
    },
  },
  MDR: {
    'Add_MDR_Rates': 'ADD MDR RATES',
    'Same_MDR_Rates': 'All Products have the same MDR Rates',
    buttons: {
      'mdrRates': 'MDR RATES',
      'submit': 'SUBMIT',
      'confirm': 'CONFIRM',
      'cancel': 'CANCEL',
    },
    Confirmation_Dialog: {
      'sub_content':
        'Are you sure you want to submit this MDR Rates ? This process can not be undone.',
    },
  },
  AcceptChargebackDrawer: {
    'Accept_Chargeback': 'ACCEPT CHARGEBACK',
    'Info': 'Accepting chargeback will issue a refund to this transaction and will be deducted from your next payout.',
    fields: {
      'Original_Amount': 'Chargeback Amount',
      'Remaining': 'Refund Amount',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'Accept Chargeback',
      'Cancel': 'Cancel',
    },
  },
  DeclineChargebackDrawer: {
    'Decline_Chargeback': 'DECLINE CHARGEBACK',
    'Info': 'Kindly provide evidence and upload supporting files to present your case.',
    fields: {
      'Description': 'Description',
      'FileUpload': 'Upload File',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'Decline Chargeback',
      'Cancel': 'Cancel',
    },
  },
  SubmitEvidenceDrawer: {
    'Heading': 'Submit Evidence',
    fields: {
      'message': 'Enter Message',
      'document': 'Attach File',
      'upload': 'Click to Upload',
      helperText: {
        'OptionalMessage': 'Maximum 250 Characters only.',
        'OptionalDesMessage': 'Maximum 128 Characters only.',
      },
      file_upload: {
        'fileSize':
          'File is too large, maximum allowed size is $maxSize MB. Current file has $size MB.',
        'imageType': 'Only PDF file format is supported.',
      },
      button: {
        'send': 'Send',
        'cancel': 'Cancel',
      },
    },
    'successMessage': 'Chargeback case updated successfully.',
  },
  SearchChargebackTransaction: {
    'Heading': 'Search Transaction',
    fields: {
      'CardNumber': 'Card Number',
      'Date': 'Transaction Date',
      'V2UUID': 'V2 ID',
      'Acquirer': 'Acquirer',
      'Amount': 'Amount',
      'AuthCode': 'Auth Code',
      'Scheme': 'Scheme',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'Search',
      'Cancel': 'Cancel',
      'Reset': 'Reset',
    },
    'TransactionResult': 'Transaction Result',
    columnDefs: {
      Action: 'Action',
      TransactionRefID: 'Transaction Ref ID',
      V2UUID: 'V2 ID',
      DASMID: 'DASMID',
      Date: 'Date',
      Amount: 'Amount',
      AuthCode: 'Auth Code',
    },
    'ActionButton': 'View',
    'EditButton': 'Link',
  },
  IssueChargebackDrawer: {
    'Issue_Chargeback': 'ISSUE CHARGEBACK / RETRIEVAL',
    fields: {
      'TransactionRefID': 'Transaction Ref ID',
      'ChargebackARN': 'ARN',
      'Acquirer': 'Acquirer',
      'ChargebackIssuedDays': 'Issued Date',
      'DueDate': 'Due Date',
      'Amount': 'Dispute Amount',
      'ReasonCategory': 'Reason Description',
      'ReasonForUpdate': 'Reason For Update',
      'Cycle': 'Case Type',
      'OrderID': 'Transaction Ref Id',
      'Status': 'Status'
    },
    AcquirerValues: {
      'Worldpay': 'WorldPay',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'Submit',
      'Cancel': 'Cancel',
    },
    message: {
      'notification': 'Amount should not be more than original amount.',
      'Cancel': 'Back to List',
    },
    ApprovePopup: {
      'title': 'COMPLETED',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to sent to acquirer? This process can not be undone.',
      message: {
        'settlementFailed': 'Dispute completeion failed..!',
        'settlementSuccess': 'Dispute complete is Approved..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Complete',
      },
    },
    AcceptDisputePopup: {
      'title': 'ACCEPT DISPUTE',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to accept the dispute? This process can not be undone.',
      message: {
        'settlementFailed': 'Accept dispute failed..!',
        'settlementSuccess': 'Accept dispute is Approved..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Accept',
      },
    },
    CaseClosePopup: {
      'title': 'Close Case',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to close this case? This process can not be undone.',
      message: {
        'settlementFailed': 'Case close failed..!',
        'settlementSuccess': 'Case close is Approved..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Approve',
      },
    },
    CaseCloseDrawer: {
      'title': 'Close Case',
      fields: {
        'reason': 'Reason',
        'comment': 'Comments',
      },
    },
  },
  CreateCurrencyFrameAdornment: {
    SGD: 'SGD',
    JPY: 'JPY',
    USD: 'USD',
  },
  AG_GRID_LOCALE: {
    Page: 'Page',
    to: 'to',
    of: 'of',
    more: 'More',
  },
  FinanceStatements: {
    msg: {
      "EDIT_MSG": "Please Regenerate the Statement"
    },
    breadcrumbs: {
      'Home': 'Home',
      'Statements': 'Finance',
      'ClearSelections': 'Clear Selections'
    },
    Statement_Transactions: {
      "Statement Transactions": "Statement ID",
      "Merchant Account": "Merchant Account",
      "Merchant Account (English)": "Merchant Account (English)",
      "DASMID": "DASMID",
      "Statement Date": "Statement Date",
      "Statement Status": "Statement Status",
      "Sync": "Sync",
      "Is Whitelisted": "Is Whitelisted",
      "PopupData": {
        "No Whitelist": "Whitelist No",
        "Yes Whitelist": "Whitelist Yes",
        'Are you sure?': 'Are you sure?',
        "Are You Sure you want to disable Whitelist feature": "Do yo really want to mark this transaction as Whitelist No?",
        "Are You Sure you want to enable Whitelist feature": "Do yo really want to mark this transaction as Whitelist Yes?",
        "Approve": "Approve",
        "Close": "Close",
      }
    },
    Statement_ColumnDefs: {
      'STATEMENT_ID': 'Statement ID',
      'Date': 'Statement Date',
      'TRANSACTION_START_DATE': 'Transaction Start Date',
      'TRANSACTION_END_DATE': 'Transaction End Date',
      'DASMID': 'DASMID',
      'Payout_Date': 'Payout Date',
      'PaymentType': 'Payment Type',
      'Acquirer': 'Acquirer',
      'amount': 'Total Payout',
      'Recon_Status': 'Recon Status',
      'STATUS': 'Statement Status',
      'Wired_Status': 'Wired Status',
      'action': 'Action',
      'ROLLING_RESERVE_HELD': 'Rolling Reserve (%)',
      'ROLLING_RESERVE_HELD_AMOUNT': 'Rolling Reserve Held',
      'ROLLING_RESERVE_RELEASED': 'Rolling Reserve Released',
      'CUMULATIVE_RESERVES': 'Cumulative Reserves',
      'TransactionDate': 'Transaction Date',
      'OnHoldStatus': 'Statement Release Status',
      'FixedDepositHeldYTDAmount': 'Fixed Deposit Held',
      'AdjustmentsAmount': 'Adjustment Amount',
      'NET_SALES': 'Net Sales',
      'TOTAL_FEES': 'Total Fees',
      'ReleasedDate': 'Released Date',
      'PO_Entity': 'PO Entity',
    },
    Popper_Buttons: {
      'edit': 'Edit',
      'view': 'View',
      'download': 'Download',
      'settle': 'Settle',
      'generate': 'Generate',
      'approve': 'Approve',
      'download_pdf': 'Pdf',
      'regenerate': 'Regenerate',
      'Report': 'Report',
      "Select To Download": "Select To Download",
      "Multiple Statements on": "Multiple Statements on",
      "Selection limit reached You can download 25 statements only": "Selection limit reached: You can download 25 statements only.",
    },
    StatusTypes: {
      'PENDING': 'PENDING',
      'APPROVED': 'APPROVED',
      'RECONCILED': 'RECONCILED',
      'DISCREPANCY': 'DISCREPANCY',
      'NOT_PAID': 'NOT PAID',
      'PAID_OUT': 'SETTLED - PAID OUT',
      'CARRY_FORWARD': 'CARRY FORWARD',
      'CARRYFORWARDUNAPPROVED': 'CF UNAPPROVED',
      'ACTIVE': 'ACTIVE',
      'ON_HOLD': 'ON HOLD',
      'SUBMITTED': 'SUBMITTED',
      'COMPLETED': 'COMPLETED',
      'INACTIVE': 'INACTIVE',
      'RISKREJECTED': 'RISK REJECTED',
      'TERMINATED': 'TERMINATED',
      'CONDITIONAL_APPROVED': 'CONDITIONAL APPROVED',
      'CLOSED': 'CLOSED',
    },
    tabs: {
      'Account': 'Reconciliation',
      'Merchant': 'Merchant Statements',
      'MerchantHeading': 'Merchant Statements',
      'Holiday': 'Public Holiday',
    },
    EditMerchantStatements: {
      'title': 'EDIT MERCHANT STATEMENT',
      Edit_form_Fields: {
        'NET_SALES': 'NET SALES',
        'TOTAL_FEES': 'TOTAL FEES',
        'GROSS': 'GROSS SETTLEMENT',
        'ROLLING_RESERVE_HELD': 'ROLLING RESERVE (%)',
        'ROLLING_RESERVE_HELD_AMOUNT': 'ROLLING RESERVE HELD',
        'ROLLING_RESERVE_RELEASED': 'ROLLING RESERVE RELEASED',
        'amount': 'TOTAL PAYOUT',
        'CUMULATIVE_RESERVES': 'CUMULATIVE RESERVES',
        'TAX_PLACEHOLDERS': 'TAX PLACEHOLDERS',
        'ADJUSTMENT': 'ADJUSTMENT',
        'ADJUSTMENT_NOTE': 'ADJUSTMENT NOTE',
        'STATUS': 'STATUS',
        'Wired_Status': 'WIRED STATUS',
        'FixedDepositHeldYTDAmount': 'FIXED DEPOSIT HELD',
        button: {
          'SAVE': 'SAVE',
          'CANCEL': 'CANCEL',
        },
        helperText: {
          'OptionalMessage': 'Maximum 128 Characters only.',
        },
      },
    },
    ViewMerchantStatements: {
      'title': 'MERCHANT STATEMENT DETAILS',
      Statement_Settlement: {
        'LABEL': 'SETTLEMENT STATEMENT',
        fields: {
          'CLIENT_NAME': 'Client Name',
          'CLIENT_CODE': 'Client Code',
          'STATEMENT_ID': 'Statement ID',
          'BillingDescriptor': 'Billing Descriptor',
          'Currency': 'Currency',
          'STATEMENT_DATE': 'Statement Date',
          'STATEMENT_PERIOD': 'Statement Period',
          'PAYMENT_TRANSFER_DAY': 'Payment Transfer Day',
          'RESERVES': 'RESERVES',
        },
      },
      Processing_Summary: {
        'LABEL': 'PROCESSING SUMMARY',
        fields: {
          'PURCHASE_CAPTURE': 'Purchase/Capture Sales',
          'REFUND': 'Refund',
          'CHARGEBACK': 'Chargeback',
          'CHARGEBACK_REVERSAL': 'CHARGEBACK REVERSAL',
          'REPRESENTMENT': 'Representment',
          'NET_TRANSACTION_AMOUNT': 'NET TRANSACTION AMOUNT',
        },
      },
      FEES: {
        'LABEL': 'FEES',
        fields: {
          'Fees': 'FEES',
          'Count': 'COUNT',
          'Fee': 'FEE',
          'JPY_Amount': 'JPY AMOUNT',
        },
      },
      Settlement_Summary: {
        'LABEL': 'SETTLEMENT SUMMARY',
        fields: {
          'Settlement_Summary_Label': 'SETTLEMENT SUMMARY',
          'Date': '',
          'Fee': '',
          'JPY_Amount': 'JPY AMOUNT',
        },
      },
      button: {
        'SAVE': 'SAVE',
        'CLOSE': 'CLOSE',
      },
    },
    SelectLanguagePopup: {
      'title': 'LANGUAGE OPTIONS',
      'heading': 'Please select the language to download file.',
      message: {
        'settlementFailed': 'Language change is failed..!',
        'settlementSuccess': 'Language is successfully changed..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Download',
      },
    },
    ApprovePopup: {
      'title': 'APPROVE',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to approve all the selected statements? This process can not be undone.',
      message: {
        'settlementFailed': 'Statement Approval failed..!',
        'settlementSuccess': 'Statement is Approved..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Approve',
      },
    },
    WiredPopup: {
      'content':
        'Are you sure you want to approve the wire status of all selected statements? This process can not be undone.',
    },
    confirmPopup: {
      'title': 'SETTLEMENT',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to settle all the selected statements? This process can not be undone.',
      message: {
        'settlementFailed': 'Statement setteled failed..!',
        'settlementSuccess': 'Statement is setteled..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Submit',
      },
    },
    DownloadconfirmPopup: {
      'title': 'DOWNLOAD',
      'heading': 'Are you sure?',
      'content':
        'Are you sure you want to download all the selected statements? This process can not be undone.',
      message: {
        'downloadFailed': 'Download failed..!',
        'downloadSuccess': 'Downloaded successfully..!',
      },
      button: {
        'cancel': 'Cancel',
        'submit': 'Submit',
      },
    },
  },
  Holiday: {
    'AddButton': 'Add Holiday / Emergency Off',
    'EditButton': 'Edit Holiday / Emergency Off',
    'Public Holiday List': 'Public-Holiday-List',
    'InvalidUploadTemplate': 'Please use a valid template.',
    'InvalidUploadFileType': 'Please use a valid file format.',
    'UploadFileLable': 'Upload Holiday List (Excel format)',
    'UploadBtn': 'Upload',
    'CancelBtn': 'Cancel',
    'Uploading': 'Processing...',
    'UploadFailed': 'File Uploading Failed',
    Schema: {
      'Name': 'Name',
      'Type': 'Type',
      'Date': 'Date',
      'Country': 'PO Entity',
      'SendEmailCheckbox': 'Send Email Notification',
    },
    ColumnDefs: {
      'HolidayName': 'Holiday Name',
      'Type': 'Type',
      'Month': 'Date',
      'Day': 'Day',
      'Country': 'PO Entity',
    },
    type: {
      'PublicHoliday': 'Public Holiday',
      'EmergencyOff': 'Emergency Off',
    },
    DeletePopup: {
      'title': 'CONFIRM DELETE',
      'heading': 'Are you sure?',
      'content':
        'Do you really want to delete this record? This process can not be undone.',
      button: {
        'cancel': 'Cancel',
        'submit': 'Submit',
      },
    },
    Button: {
      'Add': 'Submit',
      'Cancel': 'Cancel',
    },
  },
  validation: {
    Required: 'Required',
    MIN_NUMBER_VALUE: 'The minimum input amount must be 1',
    CHARGEBACK_MIN_NUMBER_VALUE:
      'The minimum input amount must be greater than 0',
    MAX_NUMBER_VALUE_JPY: 'The maximum input amount must be 9999999',
    MAX_NUMBER_VALUE_OTHER: 'The maximum input amount must be 9999999.99',
    TWO_DECIMAL_PLACES: "Only two decimal places are allowed",
    InvalidStringCharacters: 'Allowed characters: letters, numbers, spaces, and &., \'"()-_/\\: – $ @ # *',
    InvalidStringCharactersSQL: 'Characters not allowed',
    OnlySpacesNotAllowed: 'This field cannot contain only spaces',
    charMaxLimitMessage: "Maximum 100 Characters only.",
    NameMaxLimitMessage: "Maximum 128 Characters only."
  },
  NO_RECORD_FOUND: 'No record found',
  NO_ROWS_TO_SHOW: 'No rows to show',
  OnBoarding: {
    VirusScan: {
      'NoVirus': 'Scan completed',
      'VirusDetectedFileRemoved': 'Infected files removed by antivirus, Please remove the file identifiers and upload again',
      'VirusDetectedFileRemoved_1': 'Infected files removed by antivirus, Please upload new file',
      'VirusScanInProg': 'Antivirus scan In progress',
    },
    welcomeContent: {
      "Welcome": 'Welcome to Payment Options',
      "details":
        'Before you enjoy our platform, we would need your details for your account.',
      "Business": 'Business Information',
      "Business_details":
        'We need some key information on your business to prescribe you with the correct setup.',
      "Stakeholder": 'Stakeholder Information',
      "Stake_details": "We'll need to get to know your stakeholders (KYC).",
      "Payment": 'Payment or Settlement',
      "Payment_details": 'We need to know where to send your business proceeds.',
      "detail_second": 'Need more time in filling up the form?',
      "first_description":
        'No worries! You can get back on where you left off and continue from there. Just ensure that you complete all the fields on the tabs before you proceed to the completion.',
      "second_description": 'We’ll help you track your progress along the way.',
      "arrow_description_left": 'Fields left for you to answer',
      "arrow_description_right": 'Need more time in filling up the form?',
      Buttons: {
        "Next": 'Next',
        "Start": 'Get Started Now',
      },
    },
    SideNav: {
      "Complete": "Complete Your registration",
      "Your_registration": "",
      "fill_out_required_fields": "Please fill out all required fields through the following section",
      "through_the_following_section": "",
      "Sales_Heading": "Merchant Registration",
    },
    ChooseAccount: {
      // label: 'Choose an Account',
      // type: 'What type of account you want to create?',
      Merchant_label: {
        "first_title": 'I’m a',
        // second_title: 'I’m a Merchant',
      },
      Partner_label: {
        "first_title": 'I’m a',
        // second_title: 'I’m a Partner',
      },
    },
    BreadCrumbs: {
      "MerchantTitle": 'Merchant Registration',
      "SalesTitle": 'Application Approval',
      "ResellerTitle": 'Partner Registration',
    },
    Prompt_Message: {
      "IfSubmittedTrue":
        'Your registration is completed and your details are being reviewed which may take roughly about 5-8 working days.',
      "IfSubmittedFalse":
        'Your registration is not yet completed. Please click the link to continue and submit your application.',
      "MissingInfoMessage":
        'You have received a request of missing information. Please click the link to provide the require details.',
      "TCDisagreed_1":
        'You have disagreed the application, the application and access will be removed with in',
      "TCDisagreed_2": 'day(s)',
      "TCDisagreed_3":
        'You disagreed to the terms, your application process will be permanently removed by the end of the day.',
      "requiredUBO":
        'Please mark at least one stakeholder as Ultimate Beneficial Owner (UBO)',
      "primaryContact":
        'Please complete the details for the primary stakeholder.',
      "SolePercentage": 'The percentage should be 100% for sole proprietor.',
      "SolePercenatgeErrorMsg":
        'Please make shareholding percentage as 100% for the sole proprietor.',
      "requiredAuthorizedSignatory":
        'Please mark at least one stakeholder as authorized signatory',
      'Please_Click_On-Edit_Primary_Stakeholder':
        'Please Click on Edit Button to Complete the Details for Primary Stakeholder',
      Buttons: {
        "ClickHere": 'Click Here',
      },
      deletePreviouslyUploadedFile: {
        'title': 'Update Required!',
        'heading':
          'Changing this option requires you to upload corresponding files. Please ensure your uploaded files match the selected option.',
        'ok': 'OK',
      },
    },
    OTP_MODAL: {
      "TITLE": 'Please enter OTP to verify your account',
      "DESCRIPTION":
        'Please check your email account for the verification code we just sent you and enter that code in the box below',
      "VERIFY": 'VERIFY',
      "RESEND_OTP": 'Resend OTP',
      "VERIFIED": 'VERIFIED',
      "DIDNT_RECIEVED": 'Didn’t receive code?',
      "OTP": 'OTP',
    },
    Password_requirements: {
      "heading": 'Password Requirements',
      "pass_one": 'One lowercase letter.',
      "pass_two": 'One number.',
      "pass_three": 'One uppercase letter.',
      "pass_four": 'One special character.',
      "pass_five": 'Supported Special characters ',
    },
    ABOUT_BUSSINESS: {
      'About_Business': 'About your Business',
      'Business_Location': 'Business Location',
      'Business_Name': 'Company Name',
      'Name': 'Full Name',
      'Select_Date': 'Select date',
      'Doing_Business': 'Store/Brand Name',
      'Unique_Entity_Number': 'Registration Number',
      'Monthly_Revenue': 'Monthly Revenue',
      'BusinessLicense': 'Does your business require a license to operate?',
      'MailingAddress': 'Different Mailing Address?',
      'MainMailingAddress': 'Address',
      'Registered_Address': 'Registered Address',
      'AddressLine1': 'Address Line 1',
      'AddressLine2': 'Address Line 2',
      'Postcode': 'Postcode',
      'City': 'City',
      'Country': 'Country',
      'IncorporationDate': 'Incorporation Date',
      'Company_Type': 'Company Type',
      'Company_Type_Other': 'Company Type (Other)',
      'NEXT': 'NEXT',
      'UploadDocuments': 'Company Registration Document / Certificate of Incorporation',
      'UploadDocuments_Required': 'Company Registration Document / Certificate of Incorporation / Share Register / Proof of Address is required',
      'UploadDocuments_CertOfIncorp': 'Certificate of Incorporation / Business Registration',
      'UploadDocuments_CompanyConstitution': 'Company Constitution (M&A / Constitution)',
      'DocumentTypeShareRegister': ' Share Register',
      'Right_Panel_Text': 'Please note that you will be prompt at the last step to upload your Company Registration Certificate or Organisational Documentation, so please be prepared with those. You can also come back later to continue your registration.',
      'ToolTip_Text': 'Refers to the trading name of your Company Registration Certificate.',
      'JP_Business_Name': 'Merchant Account (English)',
      'Stock_Code': 'Stock Code',
      'noOfEmployees': 'Number of Employees',
      'DocumentUpload': 'Document Upload',
      BusinessTooltips: {
        'Registered_Address': 'PO Box is not acceptable',
        'This amount represents the fee for each individual transaction': 'This amount represents the fee for each individual transaction'
      },
      Business_Name_Messages: {
        'Name': 'Full Name as per ID',
      },
      POSTCODE_MESSAGES: {
        'Merchant_Min_Value': 'Please enter a valid postal code with 7 digits.',
        'Merchant_Max_Value': 'Please enter a valid postal code with 7 digits.',
        'Partner_Min_Value':
          'Please enter a valid postal code with minimum 2 digits.',
        'Partner_Max_Value':
          'Please enter a valid postal code with maximum 10 digits.',
      },
      COMPANY_TYPES: {
        'Company': 'Company Limited',
        'Liability': 'Limited Liability Company (LLC)',
        'PrivateLimitedSG': 'Private Company Limited by Shares',
        'Partnership': 'Partnership',
        'Limited': 'Limited Partnership',
        'NonProfit': 'Specified Non-profit Corporation',
        'IncorporatedAssociation': 'General Incorporated Association',
        'IncorporatedFoundation': 'General Incorporated Foundation',
        'Sole': 'Sole Proprietor',
      },
      'CorporateWebsite': 'Corporate Website/Social Media',
      MU: {
        'CertOfIncorporation': 'Certificate of Incorporation',
        'CompanyConstitution': 'Company Constitution',
        'DirectorsShareholdersUboRegistry': 'Registry of Directors, Shareholders and UBOs',
        'DirectorsRegistry': 'Registry of Directors',
        'ShareholdersRegistry': 'Registry of Shareholders',
        'UboRegistry': 'Registry of UBOs',
        'BusinessLicense': 'Global Business Licence',
        'GoodStandingOrIncumbency': 'Certificate of Good Standing or Certificate of Incumbency',
        'GoodStanding': 'Certificate of Good Standing',
        'Incumbency': 'Certificate of Incumbency',
        'BusinessPlan': 'Business Plan',
        'ProofOfBusinessAddress': 'Proof of Business Address',
      },
      CORPPASS: {
        'Log_In_With_Singpass': 'Log in with Singpass',
        'Log_In_With': 'Log in with',
        'As_Corppass_User': 'as Corppass user',
        'Verify_Again': 'Verify again',
        'Verified': 'Verified',
        'Connecting_To_Corppass': 'Connecting to Corppass...',
        'Corppass_Init_Failed': 'We could not start Myinfo Business retrieval. Please try again or fill in your details manually.',
        'Retry': 'Retry',
      },
    },
    SUPPORTED_COUNTRY: {
      'SupportedCountries': 'About your Business',
      'BANNER_SUBTITLE': 'Country not supported !',
      'FIRST_PARAGRAPH':
        'We are sorry - our service is not live in your country.',
      'MIDDLE_PARAGRAPH':
        "If you're ready to boost your business to the next level, get in touch with us to find the right payment solution or be informed when we are available in your business location!",
      'SECOND_PARAGRAPH':
        'Meanwhile, you can choose another location from our list below:',
      'SPEAKTOUS': 'SPEAK TO US',
      'LOCATEUS': 'Or locate us in other parts of the world',
      'BUTTON': 'CONTINUE REGISTRATION',
      'Business_Location': 'DASGATEWAY is actually supporting',
    },
    CREATE_ACCOUNT: {
      'LEFT_SUBTITLE':
        'Submitting your business information and get a merchant account to start receiving payments',
      'RESELLER_SUBTITLE':
        'Send us your information and get a reseller account to start receiving commission.',
      // Create_Your: 'Create your',
      // Merchant_Account: 'Merchant Account',
      // Last_Step: 'You’re on the last step of registration!',
      // Set_Password: 'Set your account’s password.',
      // Complete_all_required_fields: 'Complete all required fields',
      //  First_Name: 'First Name',
      'Middle_Name': 'Middle Name',
      // Last_Name: 'Last Name',
      'Phone_Number': 'Phone Number',
      // Business_Location: 'Business Location',
      // Email_Address: 'Email Address',
      // Verify: 'Verify',
      'Verified': 'Verified',
      'Create_Password': 'Create Password',
      'Confirm_Password': 'Confirm Password',
      // I_agree_with_all: 'I agree with the',
      // 'terms_&_conditions': 'Terms and Conditions',
      // privacy_policy: 'Privacy Policy',
      // and: 'and',
      'CREATE_ACCOUNT': 'CREATE ACCOUNT',
      'Or_Sign_Up_with_your_social_media_account':
        'Or Sign Up with your social media account',
      // 'already-registered': 'Already have an account?',
      // 'signin-account': 'Sign In',
      CreateAccountTooltips: {
        'Name': 'Please ensure name is in Romaji and in accordance to your identification card or passport.',
      },
      ValidationMessages: {
        "Please input your first name": "Please input your first name",
        "Invalid first name": "Invalid first name",
        "Please input your last name": "Please input your last name",
        "Invalid last name": "Invalid last name",
        "Please select country Code": "Please select country code",
        "Please input your phone number": "Please input your phone number",
        "Invalid phone number": "Invalid phone number",
        "Please input your business location": "Please input your business location",
        "Please input your email": "Please input your email",
        "Please input your password": "Please input your password",
        'Please confirm your password!': 'Please confirm your password!',
        'The new password that you entered do not match!': 'The new password that you entered do not match!',
        "Password is too short - should be 14 characters minimum.": "Password is too short - should be 14 characters minimum.",
        "Your password cannot be the same as your username or admin": "Your password cannot be the same as your username or admin",
        "Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.": "Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.",
        "You must accept the terms and privacy policy to register your account": "You must accept the terms and privacy policy to register your account"
      }
    },
    PAYMENT_METHODS: {
      'Payment_Methods': 'Payment Methods',
      'Choose_payment_acceptance': 'Choose a payment acceptance',
      'Settlement_Currency': 'Settlement Currency',
      'Settlement_Currency_Required': 'Settlement Currency is required',
      'Scheme': 'Scheme',
      'SchemeLabel': 'Payment Methods',
      'Cards': 'Cards',
      'Processing_Currency': 'Processing Currency',
      'Processing_Website': 'Processing Website',
      'Processing_Website_required': 'Website field is required',
      'Processing_Website_invalid': 'Invalid website',
      Option: {
        '3DSecure': '3D Secure',
        'NON3DSecure': 'NON 3D Secure',
        'Recurring': 'Recurring',
      },
      'TypeOfIntegration': 'Type of Integration',
      'DescribeTheProducts':
        'Describe the products or goods and services that will be sold',
      'Countries': 'Countries where the major transactions are from',
      countriesOptions: {
        'Japan': 'Japan',
        'Singapore': 'Singapore',
      },
      'Average_Transaction_Amount': 'Average Transaction Amount',
      'Maximum_Transaction_Amount': 'Maximum Transaction Amount',
      'Total_Annual_Projection': 'Total Annual Projection',
      'is_Store_Customer_Info':
        "Do you store your customer's credit card information?",
      'hasTechnologicalArchitecture':
        'Is your technological architecture compliant with the payment cards industry data security standards (PCIDSS)?',
      'is_Process_Card_trans': 'Have you process cards transactions before?',
      'Refund_Rate': 'Refund Rate',
      'Average_Refund': 'Average Refund',
      'Chargeback_Rate': 'Chargeback Rate',
      'Average_Chargeback': 'Average Chargeback',
      'HPP': 'Hosted Payment Page',
      'SERVER_API': 'Server API',
      'PAYMENT_LINK': 'Payment Links',
      'RECURRING': 'Recurring',
      'QR_CODE': 'QR Code',
      'SUBSCRIPTION': 'Subscription',
      'SOFTPOS': 'SoftPOS',
      'isRecurringText':
        'Does your business accept recurring or subscription models?',
      'DECIMAL_ERROR': 'Please enter a number without decimal point',
      'Refund_Rate_MAX_VALIDATOR':
        'Refund Rate should be less than or equal to 100%',
      'Refund_Rate_MIN_VALIDATOR': 'Refund Rate should be above 0.01%',
      'Chargeback_Rate_MAX_VALIDATOR':
        'Chargeback Rate should be less than or equal to 100%',
      'Chargeback_Rate_MIN_VALIDATOR': 'Chargeback Rate should be above 0.01%',
      'Chargeback_Rate_REQUIRED': 'Chargeback Rate is required',
      'Refund_Rate_REQUIRED': 'Refund Rate is required',
      'Average_Refund_REQUIRED': 'Average Refund is required',
      'Average_Refund_MIN_VALIDATOR': 'Average Refund should be above 1',
      'Average_Chargeback_REQUIRED': 'Average Chargeback is required',
      'Average_Chargeback_MIN_VALIDATOR': 'Average Chargeback should be above 1',
      'Average_Transaction_Required': 'Average Transaction Amount is required',
      'Maximum_Transaction_Amount_Required':
        'Maximum Transaction Amount is required',
      'Total_Annual_Projection_Required': 'Total Annual Projection is required',
      'Average_Transaction_MIN': 'Average Transaction Amount should be above 1',
      'Maximum_Transaction_Amount_MIN':
        'Maximum Transaction Amount should be above 1',
      'Total_Annual_Projection_MIN': 'Total Annual Projection should be above 1',
      'Days': 'Days',
      'ID_Of_The_Individual':
        'Valid Passport/ MyNumber ID/ Driving License / Health Insurance License',
      'Proof_Of_Address':
        'Bank Statement / Utility Bill / Tenancy Agreement (within last 3 months)',
    },
    PAYOUT_DETAILS: {
      'Payout_Details': 'Payout Details',
      'Add_New_Payout_Details': 'Add a New Payout Details',
      'Edit_Payout_Details': 'Edit Payout Details',
      'View_Payout_Details': 'View Payout Details',
      Account_Number: {
        'label': 'Account Number',
        'tooltip':
          'Please upload a copy of your bank statement that was issued in the last three months',
      },
      'Settlement_Currency': 'Settlement Currency',
      Bank_Country: {
        'Country_of_Bank': 'Country of Bank',
        option: {
          'Japan': 'Local Bank Account',
          'Singapore': 'Singapore',
          'International': 'International Bank Account',
        },
      },
      'Bank_Name': 'Bank Name',
      'Branch_Code': 'Branch Code',
      'Bank_Code': 'Bank Code',
      'Bank_Account_Name': 'Bank Account Name',
      'Swift_Code': 'SWIFT Code',
      'How-often_to_paid': {
        'label': 'How often to be paid',
        option: {
          'Daily': 'Daily',
          'Bi-Weekly': 'Bi-Weekly',
          'Weekly': 'Weekly',
          'Monthly': 'Monthly',
        },
      },
      'How-often_to_paid_helper_text': 'Minimum Settlement Amount: JPY 40,000',
      'How-often_to_paid_helper_text_for_hkd': 'Minimum Settlement Amount: HKD 1,500',
      'Min-settlement-amount': 'Minimum Settlement Amount: JPY 10,000',
      'UploadDocuments':
        'Upload the latest month Bank Statement or Statement of Account (within the last 3 months)',
      'IBAN': 'IBAN',
      'UploadDocuments_Message': 'Bank statements are required',
      'AccountType': 'Account Type',
      Account_Type: {
        'Normal': 'Normal',
        'Current': 'Current',
        'Savings': 'Savings',
        'Others': 'Others',
      },
    },
    EXTRA_DOCUMENTS: {
      'heading': 'Missing Info',
      'Upload_more_documents': 'Upload More Documents',
      'Upload_Documents_heading': 'Documents/Certificates',
      'Upload_Missing_Info': 'Upload Missing Info',
      'Request': 'Request',
      'fileDownloadOptions': 'Document Download',
      'No_Data_Found': 'No Data Found',

    },
    ENTITIES: {
      'Entities': 'Entities',
      'Payment_Options_Entities': 'Payment Options Entities',
      'Please_Select_Merchant_Entities': "Please select your merchants' entity :",
    },
    REGISTRATION_COMPLETED: {
      'REGISTRATION_COMPLETED': 'Registration Completed',
      'FIRST_PARAGRAPH': 'Thank you for your application submission, you will hear from us within the next 5-8 working days via email notification.',
      'SECOND_PARAGRAPH': 'If you require further assistance, please feel free to contact us at through the following channels:',
      'Shibuya_Office': 'Shibuya Office',
      'Singapore_Office': 'Singapore Office',
      'Address': 'Address:',
      'Dogenzaka_Address': 'Dogenzaka 225 Bldg. 1F/2F, 2-23-14 Dogenzaka, Shibuya-ku, Tokyo',
      'Singapore_Address': '9 Temasek Boulevard, Suntec City Tower 2, #19-02, Singapore 038989',
      'Email': 'Email Address:',
      'Opening_Time': 'Operating day and time:',
      'Opening_Days_And_Time': 'Monday to Friday 10am to 7pm.',
      'Explore_As_Test_Mode': 'Until then, do explore our payment gateway in TEST mode',

    },
    REGISTRATION_COMPLETED_RESELLER: {
      'REGISTRATION_COMPLETED': 'Registration Completed',
      'THANK_REGISTRATION_WITH_US': 'Thank you for your registration. ',
      'FIRST_PARAGRAPH':
        'We will review your details, which should take roughly about 5-8 working days.',
      'MIDDLE_PARAGRAPH':
        'We will notify you if we require any further clarifications on your KYC application.',
      'LAST_PARAGRAPH':
        'Until then, do explore our payment gateway in TEST mode.',
    },

    STAKEHOLDERS_INFO: {
      'About_your_Stakeholders': 'About your Stakeholders',
      'Add_New_Payout': 'Add New Payout Details',
      columnDefs: {
        'Action': 'Action',
        'First_Name': 'First Name',
        'Middle_Name': 'Middle Name',
        'Last_Name': 'Last Name',
        'Nationality': 'Nationality',
        'UBO': 'Shareholding %',
        'Auth_Signatory': 'Authorisation Signatory',
        'KYC_Status': 'eKYC Status',
        'Applicant_Status': 'Status',
      },
      'ISAUTHORIZED_YES': 'Yes',
      'NA': 'N/A',
    },
    UPLOAD_DOCUMENTS: {
      'Upload_Documents': 'Final Step',
      'VirusScanIssues_text_1': 'Your documents are being scanned for viruses. Please wait...',
      'VirusScanIssues_text_2': 'Identified some infected document files. Please remove them and upload again.',
      'Company_Registration_Certificate':
        'Company Registration Document / Certificate of Incorporation',
      'No_order_doc': 'Upload a document of no older than six months',
      'Drop_File_to_Upload': 'Drop files to Upload or',
      'ID': 'Identification Document: Valid Passport/ My Number ID/ Driving License/ Health Insurance License.',
      'Bank_Statement':
        ' Recent copy of bank statements or statement of accounts (no older than 3 months)',
      'Confirmation_Dialog':
        'I confirm that all Information I provided is true and correct. Once you submit, you will no longer be able to change your registration Information. For any changes after submission, Please contact our',
      'Support_Team': 'Support Team.',
      button: {
        'SUBMIT': 'SUBMIT',
      },
      'Identification_Document': 'Identification Document Required',
      'TERMS_CONDITION': 'I agree with the Terms and Conditions',
      'Hooray': 'Hooray! You’ve reached the last step of your registration!',
      'Neccessary':
        'Oops! You haven’t filled up all the neccessary information yet.',
      'Neccessary_text':
        'Kindly ensure that all required fields are answered before proceeding to this page. You can refer to the indicators per tab on your missed fields. Thank you!',
      'TERMS_CONDITION_DESCRIPTION':
        'By submitting this Application, the Merchant and its representative(s) warrants and represents to PAYMENT OPTIONS as set out in the declaration below. It is further understood and agreed that Transmission of a Transaction Receipt for a Transaction to PAYMENT OPTIONS, shall be the Customer’s acceptance of and agreement to the terms of service. The submission by a representative of the Customer of this Application, or the transmission of a Transaction Receipt or other evidence of a Transaction to Us, shall be the Customer’s acceptance of and agreement to the terms and conditions contained in the Agreement, comprising, this Application, the TERMS OF SERVICE and the Operating Guide. The Customer agrees to comply with the Application, the TERMS AND SERVICE, the Operating Guide and all applicable laws, rules and regulations including the rules and regulations of the respective Card Schemes and understands that failure to comply may result in termination of services. Words and phrases not specifically set out in this Application shall have the same meaning as set out in the TERMS OF SERVICE.',
      'TERMS_CONDITION_DESCRIPTION_RESELLER':
        'By submitting this Application, the Third party and its representative(s) warrants and represents to PAYMENT OPTIONS as set out in the declaration below. It is further understood and agreed that Transmission of a Transaction Receipt for a Transaction to PAYMENT OPTIONS, shall be the Customer’s acceptance of and agreement to the terms of service. The submission by a representative of the Customer of this Application, or the transmission of a Transaction Receipt or other evidence of a Transaction to Us, shall be the Customer’s acceptance of and agreement to the terms and conditions contained in the Agreement, comprising, this Application, the TERMS OF SERVICE and the Operating Guide. The Customer agrees to comply with the Application, the TERMS AND SERVICE, the Operating Guide and all applicable laws, rules and regulations including the rules and regulations of the respective Card Schemes and understands that failure to comply may result in termination of services. Words and phrases not specifically set out in this Application shall have the same meaning as set out in the TERMS OF SERVICE.',
      'Attestation': 'Attestation',
      'Attestation_Description':
        'I/We have read, understood, and agree to be bound by the Agreement. The Agreement (and amendments made from time to time) shall apply to the reseller of Service(s) in which Payment Options agrees to provide to me/us from time to time.I/We warrant that:• Any information given by me/us on this application form and in any additional material supplied in connection with the provision of the Services or the status of my/our business is true, accurate and complete in all respects.• I am/We are the owner(s) or representative(s) of my/our business/company with the authority to make final decisions as they relate to my/our application for Payment Options reseller programme.• I/We acknowledge that Payment Options reserves the right at its absolute discretion and without incurring any liability to decline my/our application without giving any reason whatsoever for so declining.• My/our business/company is registered in [ ] and has any and all licenses and permissions necessary to sell or market the services and/or goods on offer.The submission of this Application to Payment Options by a representative of the Third-Party shall constitute the Third-Party’s acceptance of and agreement to the terms and conditions contained in the Agreement, comprising, this Application, the Terms of Service and related materials. The Third-Party agrees to comply with the Application, the Terms of Service and all applicable laws, rules and regulations including the rules and regulations of the Card Schemes and understands that failure to comply may result in termination of services. Words and phrases not specifically defined in this Application shall have the same meaning as set out in the Agreement.I am submitting this request as an authorized signatory for and on behalf of the Third Party.',
      'AGREE_LABEL':
        "By selecting 'I agree', you are consenting to the conditions described above",
      'I_AGREE': 'I agree',
      'I_DISAGREE': 'I disagree',
      'Merchant-Attestation': 'I/We have read, understood, and agree to be bound by the TERMS OF SERVICE (and any accompanying Operating Guide or relating to this application (the “Agreement”). The Agreement (and amendments made from time to time) shall apply to the Service(s) applied for and which PAYMENT OPTIONS agrees to provide to me/us from time to time.',
      "Merchant_termsData": {
        "TextA": "Any information given by me/us on this application form and in any additional material supplied in connection with the provision of the Services or the status of my/our business is true, accurate and complete in all respects.",
        "TextB": "I am/We are the owner(s) or representative(s) of my/our business/company with the authority to make final decisions as they relate to my/our application for PAYMENT OPTIONS merchant acceptance programme.",
        "TextC": "I/We acknowledge that PAYMENT OPTIONS reserves the right at its absolute discretion and without incurring any liability to decline my/our application without giving any reason whatsoever for so declining.",
        "TextD": "My/our business/company is registered in ",
        "TextDD": "",
        "TextE": " and has any and all licenses and permissions necessary to sell or market the services and/or goods on offer.",
      },
      "Merchant_ApplicationSubmissitionText": "The submission of this Application to PAYMENT OPTIONS by a representative of the Customer, or the transmission of a Transaction Receipt or other evidence of a Transaction to PAYMENT OPTIONS, shall constitute the Customer’s acceptance of and agreement to the terms and conditions contained in the Agreement, comprising, this Application, the TOS the Operating Guide and related materials. The Customer agrees to comply with the Application, the TOS, the Operating Guide and all applicable laws, rules and regulations including the rules and regulations of the Card Schemes and understands that failure to comply may result in termination of processing services. Words and phrases not specifically defined in this Application shall have the same meaning as set out in the TOS.",
      "Merchant_behalf": "I am submitting this request as an authorized signatory for and on behalf of the Merchant.",
      'Partner-Attestation': 'I/We have read, understood, and agree to be bound by the Agreement. The Agreement (and amendments made from time to time) shall apply to the reseller of Service(s) in which Payment Options agrees to provide to me/us from time to time.',
      "Partner_termsData": {
        "TextA": "Any information given by me/us on this application form and in any additional material supplied in connection with the provision of the Services or the status of my/our business is true, accurate and complete in all respects.",
        "TextB": "I am/We are the owner(s) or representative(s) of my/our business/company with the authority to make final decisions as they relate to my/our application for Payment Options reseller programme.",
        "TextC": "I/We acknowledge that Payment Options reserves the right at its absolute discretion and without incurring any liability to decline my/our application without giving any reason whatsoever for so declining.",
        "TextD": "My/our business/company is registered in ",
        "TextDD": "",
        "TextE": " and has any and all licenses and permissions necessary to sell or market the services and/or goods on offer.",
      },
      "Partner_ApplicationSubmissitionText": "The submission of this Application to Payment Options by a representative of the Third-Party shall constitute the Third-Party’s acceptance of and agreement to the terms and conditions contained in the Agreement, comprising, this Application, the Terms of Service and related materials. The Third-Party agrees to comply with the Application, the Terms of Service and all applicable laws, rules and regulations including the rules and regulations of the Card Schemes and understands that failure to comply may result in termination of services. Words and phrases not specifically defined in this Application shall have the same meaning as set out in the Agreement.",
      "Partner_behalf": "I am submitting this request as an authorized signatory for and on behalf of the Third Party.",
      Confirmation_Dialog_Content: {
        'title': 'Confirm deletion',
        'heading': 'Are you sure ?',
        'content':
          'By not agreeing to the terms, your application is scheduled to be deleted within seven (7) days without recovery. During this period you may cancel the deletion and return to complete your application without losing your application data and user login. Are you sure you would like to remove your application ?',
        button: {
          'submit': 'CONFIRM',
          'cancel': 'CANCEL',
        },
      },
    },
    ADD_NEW_STAKEHOLDER: {
      'Add_New_StakeHolder': 'Add a New StakeHolder',
      'Delete_Stakeholder': 'Delete Stakeholder',
      'EDIT_StakeHolder': 'Edit StakeHolder',
      'Select_Date': 'Select date',
      'StakeHolder_Info': 'View StakeHolder',
      'First_Name': 'First Name',
      'Last_Name': 'Last Name',
      'DOB': 'Date of Birth',
      'Nationality': 'Nationality',
      'PhoneNumber': 'Phone Number',
      'ID_Number': 'ID Number',
      'ID_Type': 'ID Type',
      'Job_Title': 'Job Title',
      'Rigth_to_Sign_Doc': ' This Person is an Authorised Signatory',
      'Ultimate_Beneficiary_Owner': 'This Person is an Ultimate Beneficial Owner',
      'A_Sole_Proprietor': 'This Person is a Sole Proprietor',
      'Percentage_in_Ownership': 'Percentage in Ownership',
      'Percentage_in_Ownership_Validate': 'Percentage in Ownership is required',
      'overallPercentage': "Overall percentage can't be greater than 100",
      'Percentage_in_Ownership_NUM': 'Enter a number beween 25 and 100',
      'Country_of_Residence': 'Country of Residence',
      'Postcode': 'Postcode',
      'City': 'City',
      'Address': 'Address',
      'Update_KYC': 'Update KYC',
      button: {
        'SUBMIT': 'SUBMIT',
        'CANCEL': 'CANCEL',
      },
      'tooltip_title':
        "Please upload a photo of document ID that will help us validate each stakeholder's identity.",
      'Percentage_in_Ownership_MAX_VALIDATOR':
        'Percentage in Ownership should not be greater than 100%',
      'Percentage_in_Ownership_MIN_VALIDATOR':
        'Percentage in Ownership should be greater than 25%',
      'CHECKBOX_ERROR':
        'At least Ultimate Beneficiary Owner or Authorisation Signatory is required.',
      Stakeholder_Tooltips: {
        'Name': 'Given Name',
        'Surname': 'Surname',
        'Ultimate_Beneficiary_Owner':
          'Natural Person(s) who holds more than 25% of the voting rights/shares of the company.',
        'Auth_Signatory':
          'Natural person(s) legally appointed by the company to sign and execute transactions on behalf of the company.',
        'Registered_Address': 'PO Box is not acceptable',
      },
      'EmptyEmailErrorMsg': 'Please input your E-mail!',
      'validEmailErrorMsg': 'The input is not valid E-mail!',
      'expiryDate': 'Expiry date',
      'issuedDate': 'Issued date',
      IDTYPES: {
        'Passport': 'Passport',
        'NationalID': 'National ID',
        'MyNumberCard': 'My Number Card',
        'DriverLicense': "Driver's License",
        'InsuranceCard': 'Insurance Card ',
        'ResidenceCard': 'Residence Card',
      },
      MU: {
        'ProofOfAddress': 'Proof of Address',
        'Cv': 'CV',
      },
    },
    RegistrationComplete: {
      'EXPLORE_THE_GATEWAY': 'EXPLORE THE GATEWAY',
    },
    'API_ERROR_MESSAGE': 'Please try again....',
    'UPLOAD_FILE_SIZE_ERROR': 'File size exceeds the maximum limit of 5MB.',
    'FILE_UPLOAD_TEXT': 'Drop files to Upload or',
    'BROWSE': 'Browse',
    'IS_REQUIRED': ' is required',
    ResellerOnboarding: {
      COMPANY_PROFILE: {
        'Company_Profile': 'Business Information',
        'Doing_Business_As_Name': 'Doing Business As Name (DBA)',
        'Company_Registration_Number': 'Company Registration Number',
        'Company_Registration_Number_sole':
          'Company Registration Number (NA if not applicable)',
        'Country_Company_Incorporated':
          'Country where your company is incorporated',
        'Settlement_currency': 'Currency',
        'Country_Business_Operations':
          'Countries where your business operations are',
        'Country_Payment_Options_Business_Operations':
          'Countries where you will be referring Payment Options Products are',
        'Company_Type': 'Company Type',
        'Corporate_Website': 'Corporate Website',
        'No_Of_Employees': 'Number of Employees',
        'Business_Industry': 'Core Business Industry / Nature of Core Business',
        'Type_ThirdParty': 'Type of Third Party',
        'Other_Third_Party': 'Other (Third Party Type)',
        'Type_ThirdPary': 'Third Party Type',
        'Other_Business_Industry': 'Other (Business Industry)',
        'MailingAddress':
          'Does your Business require a regulatory license to operate?',
        'MainMailingAddress': 'Registration Address',
        'doingBusinessDBA': 'Doing Business As (DBA) Address',
        'RegistrationAddressTooltip': 'PO Box is not acceptable',
        'BusinessAsDBA':
          'If the DBA address is not the same as your registration address, please indicate your Head Office physical address including postal code. PO Box is not acceptable. ',
        'SameAsRegistration': 'Same as registeration address',
        'PostCode': 'PostCode',
        'City': 'City',
      },
      STAKEHOLDERS_INFO: {
        'Stakeholders_Info': 'Stakeholders Information',
        'BusinessRepresentativeInfo': 'Business Representative Information',
        'BusinessRepresentativeInfoToolTip':
          "A Business Representative can be a Controlling Director or an Authorised Signer. A Controlling Director of a company is an individual with significant responsibility for managing or directing the entity, including an executive officer or senior manager, appointed by the Company to manage the Company's day to day affairs. An Authorised Signer is someone that has been appointed by the company either through a Company Board of Resolution, or through an Authorisation letter signed by the Controlling Director, to sign and execute transactions on behalf of the company.",
        'controllingPerson':
          'Controlling Person/Business Owner/Shareholders/Ultimate Beneficial Owner Information',
        'controllingPersonTooltip':
          'UBO must be natural person except stock listed firm. Please list UBO with 25% holding and above. If no one owns more than 25%, please list the top three UBOs',
        'Contact_Number': 'Contact Number',
        'Email_Address': 'Email Address',
        'Name': 'Name',
        'Registration_Address_Proof':
          "Proof of Authorised Signatory's authority to sign ( Letter of Authorisation OR a Company Board of Resolution).",
        'UltimateBeneficialOwner': 'Ultimate Beneficial Owner',
        'IndividualShareholder': 'Individual Shareholder',
        'CorporateShareholder': 'Corporate Shareholder',
        'AuthorisedRepresentative': 'Authorised Representative',
        'ControllingDirector': 'Controlling Director',
        'Position': 'Position',
        columnDefs: {
          'Name': 'Name',
          'Position': 'Position',
          'ShareholdingPercent': 'Shareholding %',
        },
        ADD_NEW_STAKEHOLDER: {
          'Name': 'Name',
          'Ultimate_Beneficiary_Owner': 'Ultimate Beneficial Owner?',
          'Individual_Shareholder': 'Individual Shareholder',
          'Corporate_Shareholder': 'Corporate Shareholder',
          'GovtID':
            'Valid government issued ID for any : Authorised Signatory, Director, Control Person, and Shareholder/Beneficial owner over 25%',
          'Registry_Verification':
            'Share Registry for verification of ultimate Beneficial ownership',
          'Proof_Of_Address':
            'Proof of Address (if not noted on the government issued ID) for Shareholder/Ultimate Beneficial Owners over 25% - Proof of address can take the form of a utility bill or blank statement issued in the last three (3) months, or a local tax authority or national revenue department bill issued within the last twelve (12) months, or a government issued benefits statement.',
        },
      },
      BUSINESS_INFO: {
        'Business_Info': 'Business Information',
        'Heading': "Do you store your customer's credit card information?",
        'SubHeading':
          'Is your technological architecture compliant with the payment cards industry data security standards (PCIDSS) ?',
        'Yes': 'Yes',
        'No': 'No',
      },
      PAYOUT_SETTLEMENT_INFORMTION: {
        'Payout_Settlement_Information': 'Payout / Settlement Information',
        'Currency': 'Currency',
        'HKD': 'HKD',
        'MYR': 'MYR',
        'PHP': 'PHP',
        'THB': 'THB',
        'JPY': 'JPY',
        'BankName': 'Bank Name',
        'Bank_Identification_Code': 'Bank Identification Code (Branch Code)',
        'Bank_Account_Name': 'Bank Account Name',
        'Bank_Account_Number': 'Bank Account Number',
        'Settlement_Doc_Upload': 'Copy of settlement bank account.',
        'Settlement_Doc_Upload_Msg':
          'The bank account document should be issued within the last 3 months and must containe at least account holder name, address, account number, and date.',
      },
      UPLOAD_DOCUMENTS: {
        'Upload_Documents': 'Final Step',
        'mailingAddressUploadDocuments':
          'Copy of Business/Regulatory License - If Business requires one in order to operate or commence operations.',
        'mailingAddressUploadDocumentsRequired':
          'Copy of Business/Regulatory License - If Business requires one in order to operate or commence operations is required.',
        'certificateOfIncorporation':
          'Certificate of Incorporation, Business Registration Certificate/Extracts, Annual Return or equivalent document issued by Government Authority',
        'AuthorisedSignatoryName': 'Authorised Signatory Name',
        'AuthorisedSignatoryChecked':
          'I am submitting this request as an authorized signatory for and on behalf of the Third Party.',
        'Position': 'Position',
        'Signature': 'Signature',
        'Date': 'Date',
        'Browse': 'Browse',
        'NotificationOfCommencement':
          '1. Notification of Commencement for Individual Business.',
        'ConfirmationOfTaxDeclaration':
          '2. Confirmation of tax declaration receipt / Blue tax return registration/ Acceptance of my sole prop registration.',
        'SolePropPDF_first': 'Tax Office - Opening-of-office.pdf',
        'SolePropPDF_Second': 'Tax Office - Blue-tax.pdf',
        'AllFOrmats': 'All file formats are supported.',
        'Doc_required': 'Document is required.',
        'NNC': 'NNC1 (Company established for less than 1 year)',
        'NAR': 'NAR1 (Company established for more than 1 year)',
        'BoardResolution': 'Board Resolution / Authorisation Letter',
        'ProofOfResidentialAddress': 'Proof of Residential Address',
        'NricPassportDirectors': 'NRIC/Passport of Directors, Beneficial Owners, Authorised Signatories',
      },
      ENTITIES: {
        'Entities': 'Entities',
      },
      ResellerCompanyType: {
        default: {
          'SOLE': 'Sole Proprietor / Sole Trader',
          'PARTNER': 'Partnership',
          'PUBLIC': 'Public Limited',
          'PRIVATE': 'Private Limited',
          'STOCK': 'Stock Listed',
          'INDIVIDUAL': 'Individual',
          'OTHER': 'Other',
        },
        JP: {
          'SOLE': 'Sole Proprietor / Sole Trader',
          'PRIVATE': 'Private Limited',
          'GODOKAISHA': 'Godo Kaisha',
          'INDIVIDUAL': 'Individual',
          'OTHER': 'Other',
        },
        Malaysia: {
          'SOLE': 'Sole Proprietor / Sole Trader',
          'PARTNER': 'Partnership',
          'PUBLIC': 'Public Limited (BDH)',
          'PRIVATE': 'Private Limited (SDN BDH)',
          'INDIVIDUAL': 'Individual',
          'OTHER': 'Other',
        },
      },
      businessIndustry: {
        'FOOD': 'Food & Beverage',
        'RETAILGOODS': 'Retail Goods',
        'TRANSPORTATION': 'Transportation',
        'TOBACCO': 'Tabacco',
        'FURNITURE': 'Furniture',
        'JEWELLERY': 'Jewellery',
        'ELECTRONICS': 'Electronics',
        'FINANCIALSERVICE': 'Financial Services',
        'REALESTATE': 'Real Estate',
        'TRAVEL': 'Travel',
        'HOTELS': 'Hotels & Accomodation',
        'MEMBORG': 'Membership Organisations',
        'MEDIA': 'Social Media',
        'DRUGS': 'Drugs, Pharmacies',
        'MARKETING': 'Direct Marketing',
        'DATING': 'Dating and Escort Services',
        'GAMBLING': 'Gambling',
        'OTHER': 'Others',
      },
    },
    UploadMessage: {
      'size': 'The file size exceeds our 2MB limit.',
      'limit': 'Upload limit reached.',
      'helpertext':
        'Maximum of 5 files can be uploaded. The size of each file should be limited to 2MB.',
      'helpertext2':
        'To validate the Bank Account Holder Name, Address, Account Number and Date.',
      'fileFormat': 'is not a valid file format.',
      'SelectDocumentType': 'Select document type',
      'SelectDocumentTypeRequired': 'Please select a document type for every uploaded file.',
    },
  },
  Footer: {
    button: {
      'TERMS_BUTTON': 'Terms & Conditions',
      'PRIVACY_BUTTON': 'Privacy Policy',
    },
  },
  ConfirmationDialogRaw: {
    actionButton: {
      'title': 'VOID AUTHORIZATION',
      'heading': 'Are you sure',
      'content':
        'Are you sure you want to void this transaction? This process can not be undone.',
      'Cancel': 'Cancel',
      'Submit': 'Submit',
    },
    voidButton: {
      'title': 'VOID AUTHORIZATION',
      'heading': 'Are you sure',
      'content':
        'Are you sure you want to void this transaction? This process can not be undone.',
      'Cancel': 'Cancel',
      'Submit': 'Submit',
    },
    riskRule: {
      'title': 'Delete',
      'heading': 'Are you sure?',
      'content':
        'Do you really want to delete this record? This process can not be undone.',
      'cancel': 'Cancel',
      'submit': 'Submit',
    },
  },
  RiskRule: {
    'TabLabel': 'RISK CONFIGURATION',
    'tooltipTitle': 'Add New Risk Rule',
    'Configure_Rules': 'Configure Rules',
    'Risk_Control_for': 'Risk Controls for',
    button: {
      'Close': 'Close',
    },
    'FileType': 'Only CSV file format is supported.',
  },
  ActivateAccount: {
    'title': 'Activate Your Account',
    'description':
      'Your Merchant Account has been created. You can proceed to activate your account and reset your password.',
    breadcrumb: {
      'Home': 'Home',
      'activate': 'Activate Your Account',
    },
    buttons: {
      'Activate': 'Activate Your Account',
    },
  },
  'languagecode': 'en',
  "API_STATUS_MESSAGE": {
    "INFO0000": "Payment Successful",
    "INFO0001": "Amount successfully captured",
    "INFO0002": "Amount successfully refunded",
    "INFO0003": "Authorization Successfully Cancelled",
    "INFO0004": "Transaction status updated successfully",
    "INFO0005": "Find all chargeback ticket details",
    "INFO0006": "Fine one chargeback ticket details",
    "INFO0007": "Status updated successfully",
    "INFO0008": "Application already submitted",
    "INFO0009": "Saved as Draft",
    "INFO0010": "Application submitted successfully",
    "INFO0011": "Document Downloaded",
    "INFO0012": "Application details",
    "INFO1001": "Token refreshed.",
    "INFO1002": "Your password has been reset successfully",
    "INFO3000": "Subscription Updated",
    "INFO20000": "Successful",
    "INFO3001": "Transaction in Processing state",
    "INFO3002": "Unfortunately, the transaction has failed. Please try again",
    "INFO3003": "The transaction was completed successfully",
    "INFO_AB_0000": "Successful.",
    "INFO4000": "Preset filter added successfully.",
    "INFO4001": "Preset filter updated successfully.",
    "INFO4002": "Preset filter deleted successfully.",
    "INFO4003": "Preset filters retrieved successfully.",
    "INFO4004": "Preset filter retrieved successfully.",
    "INFO4010": "Report preference added successfully.",
    "INFO4011": "Report preference updated successfully.",
    "INFO4012": "Report preference deleted successfully.",
    "INFO4013": "Report preferences retrieved successfully.",
    "INFO4014": "Report preference retrieved successfully.",
    "INFO4020": "Transaction downloading schedule added successfully.",
    "INFO4021": "Transaction downloading schedule updated successfully.",
    "INFO4022": "Transaction downloading schedule deleted successfully.",
    "INFO4023": "Transaction downloading schedules retrieved successfully.",
    "INFO4024": "Transaction downloading schedule retrieved successfully.",
    "INFO4030": "Transaction column preference added successfully.",
    "INFO4031": "Transaction column preference updated successfully.",
    "INFO4032": "Transaction column preference deleted successfully.",
    "INFO4033": "Transaction column preferences retrieved successfully.",
    "INFO4034": "Transaction column preference retrieved successfully.",
    "INFO_FS_O0050": "Statement preference added successfully.",
    "INFO_FS_O0051": "Statement preference updated successfully.",
    "INFO_FS_O0052": "Statement preference deleted successfully.",
    "INFO_FS_O0053": "Statement preferences retrieved successfully.",
    "INFO_FS_O0054": "Statement preference retrieved successfully.",
    "INFO_FS_O0056": "Dispute preference added successfully.",
    "INFO_FS_O0057": "Dispute preference updated successfully.",
    "INFO_FS_O0058": "Dispute preference deleted successfully.",
    "INFO_FS_O0059": "Dispute preferences retrieved successfully.",
    "INFO_FS_O0060": "Dispute preference retrieved successfully.",
    "INFO_AB_0001": "Otp has been sent to your email.",
    "INFO_AB_0002": "Otp has been verified.",
    "INFO_AB_0003": "Otp has been resent to the email.",
    "INFO_AB_0004": "Account created successfully. Please complete the remaining steps to finish your registration.",
    "INFO_AB_0005": "Otp has been verified.",
    "INFO_AB_0006": "Account created successfully. We are facing some technical problem, please login to complete your registration.",
    "INFO_AB_0007": "Application details not found.",
    "INFO_AB_0008": "Application already submitted.",
    "INFO_AB_0009": "Saved as Draft.",
    "INFO_AB_0010": "Application submitted successfully.",
    "INFO_AB_0011": "Document Downloaded.",
    "INFO_AB_0012": "Application details.",
    "INFO_AB_0013": "Deleted...!",
    "INFO_AB_0014": "Application approved.",
    "INFO_AB_0015": "Application rejected.",
    "INFO_AB_0016": "Application will be removed in x day(s).",
    "INFO_AB_0017": "Application submission is in progress. Please refresh the application after sometime.",
    "INFO_AB_0018": "Pricing submitted successfully.",
    "INFO_AB_0026": "Myinfo Business retrieval started.",
    "INFO_AB_0027": "Myinfo Business retrieval status.",
    "INFO_AB_0028": "Singpass verification started.",
    "INFO_AB_0029": "Singpass verification status.",
    "INFO_AB_0030": "Singpass verification link sent.",
    "INFO_AB_0031": "Singpass verification invitation.",
    "INFO_AB_0032": "Singpass verification callback processed.",
    "INFO_AB_0033": "Business verification callback processed.",
    "INFO_ACQ_0000": "Success",
    "INFO_ACQ_0001": "Acquirer MID created",
    "INFO_ACQ_0002": "Acquirer MID updated",
    "INFO_ACQ_0003": "Acquirer created",
    "INFO_ACQ_0004": "Acquirer Details",
    "INFO_ACQ_0005": "Acquirer list",
    "INFO_ACQ_0006": "Acquirer updated",
    "INFO_AUTH_0000": "Successful.",
    "INFO_AUTH_0001": "Token refreshed.",
    "INFO_AUTH_0002": "Your password has been reset successfully",
    "INFO_AUTH_0003": "Otp has been resent to the email",
    "INFO_AUTH_0005": "Otp has been sent to your email",
    "INFO_CONFIG_0000": "Successful",
    "INFO_CONFIG_0001": "Created",
    "INFO_CONFIG_0002": "Updated",
    "INFO_CONFIG_0003": "Deleted",
    "INFO_FS_O0000": "File uploaded successfully. New records are being processed and will appear shortly.",
    "INFO_FS_O0001": "Statement update is successful",
    "INFO_FS_O0002": "Statement List",
    "INFO_FS_O0003": "Otp has been resent to the email",
    "INFO_FS_O0004": "Chargeback ticket created successfully.",
    "INFO_FS_O0005": "Find all chargeback ticket details.",
    "INFO_FS_O0006": "Fine one chargeback ticket details.",
    "INFO_FS_O0007": "Status updated successfully.",
    "INFO_FS_O0008": "Find chargeback records INFO_FS_o",
    "INFO_FS_O0009": "Chargeback case updated successfully.",
    "INFO_FS_O0010": "Find chargeback message details.",
    "INFO_FS_O0011": "Find chargeback history details.",
    "INFO_FS_O0012": "File uploaded successfully.",
    "INFO_FS_O0013": "Please close the open case of the same order code.",
    "INFO_FS_O0014": "File downloaded successfully.",
    "INFO_FS_O0015": "Duplicate ARN found ! Please try again.",
    "INFO_FS_O0016": "First Chargeback should be issued before Second Chargeback.",
    "INFO_FS_O0017": "Please enter valid DASMID.",
    "INFO_FS_O0018": "Please enter valid caseId.",
    "INFO_FS_O0019": "Please enter valid status.",
    "INFO_FS_O0020": "Holiday List Details",
    "INFO_FS_O0021": "Holiday List Details Generated Successfully",
    "INFO_FS_O0022": "Statement ReGenerated Successfully",
    "INFO_FS_O0023": "Holiday List Email Sent Successfully",
    "INFO_FS_O0025": "Please create AutoRepresentment Chargeback.",
    "INFO_FS_O0026": "Download request initiated.",
    "INFO_FS_O0028": "All Statement Transaction Details",
    "INFO_FS_O0029": "Transaction Sync",
    "INFO_FS_O0031": "Hashcard Updated",
    "INFO_FS_O0034": "Hash Card added successfully",
    "INFO_FS_O1000": "Download started successfully.",
    "INFO_MS_0000": "Successful",
    "INFO_MS_0001": "Statement update is successful",
    "INFO_MS_0002": "Statement List",
    "INFO_MS_0003": "Otp has been resent to the email",
    "INFO_MS_0004": "Status updated successfully",
    "INFO_MS_0005": "Thank you for getting in touch!",
    "INFO_MS_0006": "Find the Product Details for Support",
    "INFO_MS_0007": "Please select a valid product type",
    "INFO_MS_0008": "No product found for the given DASMID/MerchantID",
    "INFO_MS_0009": "The status has been updated for the specified DASMID of the Merchant",
    "INFO_MS_0010": "Recurring plans retrieved successfully",
    "INFO_MS_0011": "Plan details retrieved successfully",
    "INFO_MS_0012": "Please enter a valid planId",
    "INFO_MS_0013": "Plan created successfully",
    "INFO_MS_0014": "Plan updated successfully",
    "INFO_MS_0015": "Subscription details",
    "INFO_MS_0016": "Subscription edited successfully",
    "INFO_MS_0017": "Please enter a valid subscriptionId",
    "INFO_MS_0018": "Subscription already exists",
    "INFO_MS_0019": "Subscription cancelled successfully",
    "INFO_MS_0020": "Subscription not found",
    "INFO_MS_0021": "SubscriptionPlan already exists",
    "INFO_MS_0022": "Subscriber details",
    "INFO_MS_0023": "Subscriber not found",
    "INFO_MS_0024": "Email already exists for the subscriber",
    "INFO_MS_0025": "Subscriber created successfully",
    "INFO_MS_0026": "Find the Subscriber details",
    "INFO_MS_0027": "You can't update the plan for an active available Subscription",
    "INFO_MS_0028": "Find the Merchant & Merchant Config Details",
    "INFO_MS_0029": "Subscription can't be edited",
    "INFO_MS_0030": "Please enter a valid DASMID",
    "INFO_MS_0031": "You can't delete the plan for an available Subscription",
    "INFO_MS_0032": "Plan deleted successfully",
    "INFO_MS_0033": "Email sent successfully!",
    "INFO_MS_0034": "Oops! It appears you're currently subscribed",
    "INFO_MS_0035": "Subscriber deleted successfully",
    "INFO_MS_0036": "SubscriptionPlan not found",
    "INFO_MS_0037": "User created successfully",
    "INFO_MS_0038": "All users details",
    "INFO_MS_0039": "User details",
    "INFO_MS_0040": "User not found",
    "INFO_MS_0041": "User already exists",
    "INFO_MS_0042": "User deleted successfully",
    "INFO_MS_0043": "User activated/deactivated successfully",
    "INFO_MS_0044": "User updated successfully",
    "INFO_MS_0045": "Subscriber detail updated",
    "INFO_MS_0046": "Merchant Details",
    "INFO_MS_0047": "Created",
    "INFO_MS_0048": "Updated",
    "INFO_MS_0049": "Deleted",
    "INFO_MS_0050": "Product Details",
    "INFO_MS_0051": "Password reset completed successfully",
    "INFO_MS_0052": "Please logout and login to switch the account",
    "INFO_MS_0055": "Category Created Successfully",
    "INFO_MS_0056": "Category Updated Successfully",
    "INFO_MS_0057": "Category Deleted Successfully",
    "INFO_MS_0059": "Product Created Successfully",
    "INFO_MS_0060": "Product Updated Successfully",
    "INFO_MS_0061": "Product Deleted Successfully",
    "INFO_MS_0063": "Webhook Created Successfully",
    "INFO_MS_0064": "Webhook Updated Successfully",
    "INFO_MS_0065": "Webhook List",
    "INFO_MS_0066": "Merchant IP List",
    "INFO_MS_0067": "Merchant IP Created Successfully",
    "INFO_MS_0068": "Merchant IP Updated Successfully",
    "INFO_MS_0069": "Merchant IP Deleted Successfully",
    "INFO_MS_0070": "Merchant IP Data",
    "INFO_MS_0072": "Merchant key pair status",
    "INFO_PBL_0000": "Successful",
    "INFO_PBL_0001": "New order created to pay via Link",
    "INFO_PBL_0002": "Updated",
    "INFO_PBL_0003": "Created",
    "INFO_PBL_0004": "Deleted",
    "INFO_PBL_0005": "Order Link Deactivated",
    "INFO_PBL_0006": "Image uploaded",
    "INFO_DX_0000": "successful",
    "ERR0000": "Access denied..!",
    "ERR0001": "Something went wrong...! Please try again",
    "ERR0002": "Something went wrong...!",
    "ERR0003": "No connection established. Please try again",
    "ERR0004": "OTP expired",
    "ERR0005": "Retry count exceeded. Please regenerate the OTP",
    "ERR0006": "Invalid OTP",
    "ERR0007": "Exceeded the maximum retry count",
    "ERR0008": "Email not verified",
    "ERR0009": "Payment options email identifier found",
    "ERR0010": "Application not processed",
    "ERR0011": "Upload failed",
    "ERR0012": "Download failed",
    "ERR0013": "Unable to remove the file",
    "ERR0014": "Failed to fetch Application details",
    "ERR0015": "Application details not found",
    "ERR0016": "Country not supported",
    "ERR0017": "Invalid user id",
    "ERR0018": "Invalid user id",
    "ERR0019": "No data found",
    "ERR0020": "Failed to fetch the details",
    "ERR0024": "User not exist",
    "ERR0025": "You can not reset password for Inactive user.",
    "ERR0030": "This email address has already been added.",
    "ERR0100": "Amount exceeds the permitted limit",
    "ERR0101": "Card is Not Valid",
    "ERR0102": "Card has expired",
    "ERR0103": "Card is not supported",
    "ERR0104": "Security violation",
    "ERR0105": "Authorization not allowed for recurring",
    "ERR0106": "Payment info is not valid",
    "ERR0107": "FraudWall has blocked the transaction",
    "ERR0108": "Subscription details missing on the payment request",
    "ERR0109": "Invalid subscription id",
    "ERR0110": "Missing dfReferenceId",
    "ERR0111": "A rule with the same name already exists. Please provide a different rule name.",
    "ERR0201": "Please enter valid amount for capture",
    "ERR0202": "You don't have enough amount for capture",
    "ERR0203": "The value should not be in the fraction",
    "ERR0204": "You don't have balance amount for refund",
    "ERR0205": "Invalid transaction id",
    "ERR0206": "The Transaction status cannot be updated to the same as current status",
    "ERR0207": "Not a valid transaction for capture",
    "ERR0208": "Invalid DASMID",
    "ERR1000": "API not implemented.",
    "ERR1001": "Incorrect username or password",
    "ERR1002": "Invalid User Session.",
    "ERR1003": "Refresh token expired or user signout from the application.",
    "ERR1004": "Paymentoption email. Please contact the support.",
    "ERR1005": "User is not registered with us.",
    "ERR1006": "Invalid OTP provided.",
    "ERR1007": "Invalid code provided, please request a code again.",
    "ERR1008": "Attempt limit exceeded, please try after some time.",
    "ERR1009": "Not valid request.",
    "ERR1010": "User is disabled, Contact support team.",
    "ERR10000": "Invalid URL",
    "ERR10001": "Invalid amount",
    "ERR10002": "Invalid subscription or missing subscription details",
    "ERR10003": "No details found on link",
    "ERR3000": "Not a valid subscription DASMID",
    "ERR3001": "Invalid transaction id",
    "ERR3002": "Only ACTIVE subscriptions are allowed pause",
    "ERR3003": "Subscription cancellation failed",
    "ERR3004": "Unable to resume the subscription",
    "ERR3019": "Insufficient refund balance",
    "ERR3020": "Insufficient refund balance",
    "ERR0211": "The refund is not allowed",
    "ERR0213": "The allowed refund volume limit has been exceeded. Kindly reach out to the Support Team for further assistance.",
    "ERR0214": "Preset filter with this name already exists for this user.",
    "ERR0222": "You have reached the maximum number of transaction downloading schedules",
    "ERR0223": "Transaction column preference with this name already exists for this user",
    "ERR0224": "You are not authorized to manage this transaction column preference",
    "ERR0225": "Transaction column preference with provided UUID not found",
    "ERR_FS_O0020": "Statement Preference with this name already exists for this user",
    "ERR_FS_O0021": "You are not authorized to manage this statement preference",
    "ERR_FS_O0022": "Statement Preference with provided UUID not found",
    "ERR_FS_O0025": "Dispute Preference with this name already exists for this user",
    "ERR_FS_O0026": "You are not authorized to manage this dispute preference",
    "ERR_FS_O0027": "Dispute Preference with provided UUID not found",
    "ERR_ACQ_0001": "Please provide AcquirerName",
    "ERR_ACQ_0002": "Acquirer already exists",
    "ERR_ACQ_0003": "Acquirer Not Found",
    "ERR_ACQ_0004": "Acquirer MID Doesn't exist",
    "ERR_ACQ_0005": "Enter the unique Acquirer MID",
    "ERR_AUTH_0001": "Incorrect username or password.",
    "ERR_AUTH_0002": "Invalid User Session.",
    "ERR_AUTH_0003": "Refresh token expired or user signout from the application.",
    "ERR_AUTH_0004": "Paymentoption email. Please contact the support.",
    "ERR_AUTH_0005": "User is not registered with us.",
    "ERR_AUTH_0006": "Invalid OTP provided.",
    "ERR_AUTH_0007": "Invalid code provided",
    "ERR_AUTH_0008": "Attempt limit exceeded",
    "ERR_AUTH_0009": "Not valid request.",
    "ERR_AUTH_0010": "User is disabled",
    "ERR_AUTH_0011": "Invalid password policy",
    "ERR_AUTH_0012": "User already exist in the pool",
    "ERR_AUTH_0013": "Invalid email",
    "ERR_AUTH_0014": "UserAttributes Error",
    "ERR_AUTH_0015": "User already exist.",
    "ERR_AUTH_0016": "New password cannot be the same as the current password.",
    "ERR_AUTH_0018": "Your account has been locked due to multiple failed login attempts. Please try again after 60 minutes.",
    "ERR_AUTH_0019": "The code you entered is incorrect or has expired.",
    "ERR_CONFIG_0000": "",
    "ERR_CONFIG_0001": "Duplicate rule",
    "ERR_FS_O0000": "Not implemented",
    "ERR_FS_O0001": "An emergency holiday has already been scheduled for the same date. Please choose an alternative date",
    "ERR_FS_O0002": "A holiday with the same name is already scheduled for the given date. Please choose a different date",
    "ERR_MS_0021": "Invalid plan id provided",
    "ERR_MS_0022": "Plan should belong to the same MID",
    "ERR_MS_0023": "Not an active plan",
    "ERR_MS_0024": "Subscription can't be edited",
    "ERR_MS_0025": "Invalid request.",
    "ERR_MS_0026": "Username or email already exists",
    "ERR_MS_0027": "SubscriptionPlan already exists",
    "ERR_MS_0028": "You can't update plan for active available Subscription",
    "ERR_MS_0029": "Unable to delete the plan",
    "ERR_MS_0030": "Unable to delete the subscriber",
    "ERR_MS_0034": "The email is already register with us.",
    "ERR_MS_0036": "Please provide all available DASMID",
    "ERR_MS_0037": "Merchant IP already exists",
    "ERR_PBL_0001": "Please enter the correct DASMID",
    "ERR_PBL_0002": "All products must have the same currency",
    "ERR_PBL_0004": "Cart amount limit exceeded for this currency. Max amount limit : 9999999",
    "ERR_PBL_0005": "Cart amount limit exceeded for this currency. Max amount limit : 9999999.99",
    "ERR_PBL_0006": "Cart amount is below the minimum allowed limit for this currency. Min amount limit : 1",
    "ERR_PBL_0007": "Cart amount is below the minimum allowed limit for this currency. Min amount limit : 0.01",
    "ERR_AB_0000": "Access denied..!",
    "ERR_AB_0001": "Something went wrong...! Please try again",
    "ERR_AB_0002": "The email is already register with us.",
    "ERR_AB_0003": "User details not found.",
    "ERR_AB_0004": "OTP expired.",
    "ERR_AB_0005": "Retry count exceeded. Please regenerate the OTP.",
    "ERR_AB_0006": "Invalid OTP.",
    "ERR_AB_0007": "Exceeded the maximum retry count, please conact the support.",
    "ERR_AB_0008": "Email not verified.",
    "ERR_AB_0009": "Payment options email identifier found.",
    "ERR_AB_0010": "Application not processed.",
    "ERR_AB_0011": "Upload failed.",
    "ERR_AB_0012": "Download failed.",
    "ERR_AB_0013": "Unable to remove the file.",
    "ERR_AB_0014": "Failed to fetch Application details.",
    "ERR_AB_1000": "API not implemented.",
    "ERR_AB_0015": "Application details not found.",
    "ERR_AB_0016": "Country not supported.",
    "ERR_AB_0017": "Invalid user id.",
    "ERR_AB_0018": "Not valid application.",
    "ERR_AB_0019": "Incomplete application.",
    "ERR_AB_0020": "Expecting at least one stakeholder details.",
    "ERR_AB_0021": "Expecting at least one authorized signatory.",
    "ERR_AB_0022": "Duplicate registration number or legalName",
    "ERR_AB_0023": "Expecting at least one UBO.",
    "ERR_AB_0024": "Application already proccessed.",
    "ERR_AB_0025": "Selected payment type is not allowed to add pricing.",
    "ERR_AB_0026": "Customer not completed the application.",
    "ERR_AB_0027": "Unable to push the application to DASPOS.",
    "ERR_AB_0028": "Invalid Referral Code.",
    "ERR_AB_0029": "Communication error.",
    "ERR_AB_0030": "The email address cannot be the same as the primary email address provided.",
    "ERR_AB_0031": "Can not have more than one primary contact.",
    "ERR_AB_0032": "Modification not allowed.",
    "ERR_AB_0033": "Expecting application id for THIRDPARTY user.",
    "ERR_AB_0034": "Please reverify the email.",
    "ERR_AB_0035": "Modification not allowed for 'External sales'.",
    "ERR_AB_0036": "User not selected this product.",
    "ERR_AB_0037": "Additional info request not allowed for this application.",
    "ERR_AB_0038": "Additional info request not completed.",
    "ERR_AB_0039": "this request is already fulfilled.",
    "ERR_AB_0040": "Pricing is not allowed for third-party application.",
    "ERR_AB_0041": "Referral Code not active.",
    "ERR_AB_0042": "Application approval is already inprogress.",
    "ERR_AB_0043": "Invalid password policy",
    "ERR_AB_0044": "Pricing not submitted",
    "ERR_AB_0045": "Reseller application not approved by sales team",
    "ERR_AB_0049": "Myinfo Business retrieval is not available for this application.",
    "ERR_AB_0050": "Could not start Myinfo Business retrieval. Please try again or fill in your details manually.",
    "ERR_AB_0051": "Myinfo Business retrieval could not be completed. Please try again or fill in your details manually.",
    "ERR_AB_0052": "This Myinfo Business retrieval link has expired or is invalid.",
    "ERR_AB_0053": "Singpass verification is not available for this stakeholder.",
    "ERR_AB_0054": "Could not start Singpass verification. Please try again or verify with Onfido.",
    "ERR_AB_0055": "Singpass verification could not be completed. Please try again or verify with Onfido.",
    "ERR_AB_0056": "A National Registration Identity Card number is required on the stakeholder before Singpass verification can be used.",
    "ERR_AB_0057": "An email address is required on the stakeholder before a KYC link can be sent.",
    "ERR_AB_0058": "This verification link is not valid.",
    "ERR_AB_0059": "This verification link has expired. Please ask for a new one.",
    "ERR_AB_0060": "This verification has already been completed.",
    "ERR_9000": 'Too Many Requests',
    "VAL1001": "Token details required.",
    "VAL1002": "Access token required.",
    "VAL1003": "Id token required.",
    "VAL1004": "Refresh token required.",
    "VAL1005": "OTP required.",
    "VAL1006": "Password missmatch.",
    "VAL1007": "Confirm password is required.",
    "VAL1008": "Invalid OTP length.",
    "VAL0001": "Invalid amount",
    "VAL0002": "Invalid currency",
    "VAL0003": "auto_capture required",
    "VAL0004": "Invalid customer IP",
    "VAL0005": "Card details are missing",
    "VAL0006": "Missing billing country",
    "VAL0007": "Provide a valid email",
    "VAL0008": "Provide a valid phone number",
    "VAL0009": "Address line missing",
    "VAL0010": "Address line 2 missing",
    "VAL0011": "City missing",
    "VAL0012": "State missing",
    "VAL0013": "Postal code missing",
    "VAL0014": "Invalid subscription plan name",
    "VAL0015": "Invalid subscription plan type",
    "VAL0016": "Invalid subscription plan duration",
    "VAL0017": "Invalid subscription plan cycle",
    "VAL0018": "MID missing",
    "VAL0019": "Invalid Subscription plan desc",
    "VAL0020": "Incorporation date is required",
    "VAL0021": "Invalid Subscription cycle type",
    "VAL0022": "",
    "VAL0023": "Invalid subscription end type",
    "VAL0024": "Invalid subscription interval cycle",
    "VAL0025": "Max_cycle_count missing/not valid",
    "VAL0026": "Expecting boolean for has trial period",
    "VAL0027": "Not a valid trial period duration type",
    "VAL0028": "Not a trial trial period duration",
    "VAL0029": "Expecting boolean for has discount",
    "VAL0030": "Invalid stakeholder id",
    "VAL0031": "Not a valid discount duration",
    "VAL0032": "Invalid CVC",
    "VAL0033": "Invalid expiry month",
    "VAL0034": "Invalid expiry year",
    "VAL0035": "Invalid card holder name",
    "VAL0036": "Invalid card number",
    "VAL0037": "Invalid stakeholder UBO",
    "VAL0038": "Merchant txn ref exceeded the character limit of 45",
    "VAL0039": "Invalid Merchant id",
    "VAL0040": "Invalid webhook url",
    "VAL0041": "Invalid success url",
    "VAL0042": "Invalid decline url",
    "VAL0043": "Invalid session id",
    "VAL0044": "Not a valid integer",
    "VAL0045": "Not a valid number",
    "VAL0046": "Not a valid Paymentmethod.type",
    "VAL0047": "Invalid subscription_id",
    "VAL0048": "Invalid PaymentMethod.hasServerApi",
    "VAL0049": "Invalid PaymentMethod.hasQR",
    "VAL0050": "Invalid PaymentMethod.hasPBL",
    "VAL0051": "Invalid PaymentMethod.hasVISA",
    "VAL0052": "Invalid PaymentMethod.hasMastercard",
    "VAL0053": "Invalid PaymentMethod.hasJCB",
    "VAL0054": "Invalid PaymentMethod.hasAMEX",
    "VAL0055": "Invalid PaymentMethod.hasUPI",
    "VAL0056": "Invalid PaymentMethod processingCurrency",
    "VAL0057": "Invalid PaymentMethod integrationType",
    "VAL0058": "Invalid PaymentMethod describeProduct",
    "VAL0059": "Invalid PaymentMethod transactionalCountries",
    "VAL0060": "Invalid PaymentMethod averageTransactionAmount",
    "VAL0061": "Invalid PaymentMethod averageTransactionCcy",
    "VAL0062": "Invalid PaymentMethod maximumTransactionAmount",
    "VAL0063": "Invalid PaymentMethod maximumTransactionCcy",
    "VAL0064": "Invalid PaymentMethod totalAnnualProjectionAmount",
    "VAL0065": "Invalid PaymentMethod totalAnnualProjectionCcy",
    "VAL0066": "Invalid PaymentMethod website",
    "VAL0067": "Invalid PaymentMethod.isCreditInformationStored",
    "VAL0068": "Invalid PaymentMethod.isCardTransaction",
    "VAL0069": "Invalid PaymentMethod refundRate",
    "VAL0070": "Invalid PaymentMethod averageRefund",
    "VAL0071": "Invalid PaymentMethod chargebackRate",
    "VAL0072": "Invalid PaymentMethod averageChargeback",
    "VAL0073": "Invalid PaymentDetail id",
    "VAL0074": "Invalid PaymentDetail accountNumber",
    "VAL0075": "Invalid PaymentDetail settlementCurrency",
    "VAL0076": "Invalid PaymentDetail bankName",
    "VAL0077": "Invalid PaymentDetail bankCountry",
    "VAL0078": "Invalid PaymentDetail paymentFrequency",
    "VAL0079": "Invalid PaymentDetail delete docs option",
    "VAL0080": "Invalid Stakeholder delete docs option",
    "VAL0081": "Invalid Business delete docs option",
    "VAL0082": "Invalid stakeholders delete option",
    "VAL0083": "Invalid PaymentMethod.hasRecurring",
    "VAL0084": "Invalid country of residence",
    "VAL0085": "Invalid IBAN",
    "VAL0086": "Business.doingBusinessAs is required.",
    "VAL0087": "Business.hasMailingAddress is required.",
    "VAL0088": "Business.mailAddress is required.",
    "VAL0089": "Business.mailCity is required.",
    "VAL0090": "Business.mailCountry is required.",
    "VAL0091": "Business.mailPostcode is required.",
    "VAL0092": "PaymentMethod.hasTechnologicalArchitecture is required.",
    "VAL0093": "Invalid PaymentDetail bankAccountName",
    "VAL0094": "Invalid PaymentDetail swiftCode",
    "VAL0095": "Invalid Business.isBusinessLicenseRequired ",
    "VAL0096": "Invalid mcc ",
    "VAL0097": "Invalid payment type",
    "VAL0098": "Invalid frequency type",
    "VAL0099": "Invalid mdr card discount rate",
    "VAL0100": "Invalid setup fee",
    "VAL0101": "Invalid transaction fee",
    "VAL0102": "Invalid refund processing fee",
    "VAL0103": "Invalid chargeback processing fee",
    "VAL0104": "Invalid decline fee",
    "VAL0105": "Invalid retrival req fee",
    "VAL0106": "Invalid pre arbitration fee",
    "VAL0107": "Invalid representment fee",
    "VAL0108": "Invalid fraud monitoring fee",
    "VAL0109": "Invalid status.",
    "VAL0147": "Not a valid Paymentmethod.storePaymentMethod",
    "VAL0148": "Not a valid Paymentmethod.storedPaymentMethodId",
    "VAL_AB_0001": "Email is Invalid.",
    "VAL_AB_0002": "Email is too long.",
    "VAL_AB_0003": "id is required.",
    "VAL_AB_0004": "Not a valid id.",
    "VAL_AB_0005": "OTP is required.",
    "VAL_AB_0006": "First name is required.",
    "VAL_AB_0007": "Last name is required.",
    "VAL_AB_0008": "Contact no is required.",
    "VAL_AB_0009": "Business location is required.",
    "VAL_AB_0010": "Password is required.",
    "VAL_AB_0011": "Password length is too short/long.",
    "VAL_AB_0012": "Expecting numeric value in the otp",
    "VAL_AB_0013": "User Id is required.",
    "VAL_AB_0014": "User Id not valid.",
    "VAL_AB_0015": "Business location is required.",
    "VAL_AB_0016": "Company name is required.",
    "VAL_AB_0017": "Registration number is required.",
    "VAL_AB_0018": "Company type is required.",
    "VAL_AB_0019": "Other company type is required.",
    "VAL_AB_0020": "Incorporation date is required.",
    "VAL_AB_0021": "Registered address is required.",
    "VAL_AB_0022": "Business.Postcode is required.",
    "VAL_AB_0023": "Business.city is required.",
    "VAL_AB_0024": "Invalid application id.",
    "VAL_AB_0025": "Invalid doc id.",
    "VAL_AB_0026": "Document file Name required.",
    "VAL_AB_0027": "Document data required.",
    "VAL_AB_0028": "Document file type required.",
    "VAL_AB_0029": "Business id is not valid",
    "VAL_AB_0030": "Invalid stakeholder id",
    "VAL_AB_0031": "Stakeholder primary missing/Invalid. ",
    "VAL_AB_0032": "Stakeholder first name missing.",
    "VAL_AB_0033": "Stakeholder last name not valid.",
    "VAL_AB_0034": "Stakeholder dob invalid. ",
    "VAL_AB_0035": "Stakeholder phoneNumber invalid. ",
    "VAL_AB_0036": "Stakeholder email is invalid. ",
    "VAL_AB_0037": "Invalid stakeholder UBO. ",
    "VAL_AB_0038": "Invalid stakeholder ownershipPercentage ",
    "VAL_AB_0039": "Invalid stakeholder isAuthorized ",
    "VAL_AB_0040": "Invalid stakeholder identification id ",
    "VAL_AB_0041": "Invalid stakeholder job title ",
    "VAL_AB_0042": "Invalid stakeholder address",
    "VAL_AB_0043": "Invalid stakeholder postcode ",
    "VAL_AB_0044": "Invalid stakeholder city",
    "VAL_AB_0045": "Invalid stakeholder nationality",
    "VAL_AB_0046": "Invalid PaymentMethod id",
    "VAL_AB_0047": "Invalid PaymentMethod.hasHpp",
    "VAL_AB_0048": "Invalid PaymentMethod.hasServerApi",
    "VAL_AB_0049": "Invalid PaymentMethod.hasQR",
    "VAL_AB_0050": "Invalid PaymentMethod.hasPBL",
    "VAL_AB_0051": "Invalid PaymentMethod.hasVISA",
    "VAL_AB_0052": "Invalid PaymentMethod.hasMastercard",
    "VAL_AB_0053": "Invalid PaymentMethod.hasJCB",
    "VAL_AB_0054": "Invalid PaymentMethod.hasAMEX",
    "VAL_AB_0055": "Invalid PaymentMethod.hasUPI",
    "VAL_AB_0056": "Invalid PaymentMethod processingCurrency",
    "VAL_AB_0057": "Invalid PaymentMethod integrationType",
    "VAL_AB_0058": "Invalid PaymentMethod describeProduct",
    "VAL_AB_0059": "Invalid PaymentMethod transactionalCountries",
    "VAL_AB_0060": "Invalid PaymentMethod averageTransactionAmount",
    "VAL_AB_0061": "Invalid PaymentMethod averageTransactionCcy",
    "VAL_AB_0062": "Invalid PaymentMethod maximumTransactionAmount",
    "VAL_AB_0063": "Invalid PaymentMethod maximumTransactionCcy",
    "VAL_AB_0064": "Invalid PaymentMethod totalAnnualProjectionAmount",
    "VAL_AB_0065": "Invalid PaymentMethod totalAnnualProjectionCcy",
    "VAL_AB_0066": "Invalid PaymentMethod website",
    "VAL_AB_0067": "Invalid PaymentMethod.hasCreditInformationStored",
    "VAL_AB_0068": "Invalid PaymentMethod.hasCardTransaction",
    "VAL_AB_0069": "Invalid PaymentMethod refundRate",
    "VAL_AB_0070": "Invalid PaymentMethod averageRefund",
    "VAL_AB_0071": "Invalid PaymentMethod chargebackRate",
    "VAL_AB_0072": "Invalid PaymentMethod averageChargeback",
    "VAL_AB_0073": "Invalid PayoutDetail id",
    "VAL_AB_0074": "Invalid PayoutDetail accountNumber",
    "VAL_AB_0075": "Invalid settlementCurrency",
    "VAL_AB_0076": "Invalid PayoutDetail bankName",
    "VAL_AB_0077": "Invalid PayoutDetail bankCountry",
    "VAL_AB_0078": "Invalid PayoutDetail paymentFrequency",
    "VAL_AB_0079": "Invalid PayoutDetail delete docs option",
    "VAL_AB_0080": "Invalid Stakeholder delete docs option",
    "VAL_AB_0081": "Invalid Business delete docs option",
    "VAL_AB_0082": "Invalid stakeholders delete option",
    "VAL_AB_0083": "Invalid PaymentMethod.hasRecurring",
    "VAL_AB_0084": "Invalid country of residence",
    "VAL_AB_0085": "Invalid IBAN",
    "VAL_AB_0086": "Business.doingBusinessAs is required.",
    "VAL_AB_0087": "Business.hasMailingAddress is required.",
    "VAL_AB_0088": "Business.mailingAddress is required.",
    "VAL_AB_0089": "Business.mailingCity is required.",
    "VAL_AB_0090": "Business.mailingCountry is required.",
    "VAL_AB_0091": "Business.mailingPostcode is required.",
    "VAL_AB_0092": "PaymentMethod.hasPCIDSS is required.",
    "VAL_AB_0093": "Invalid PayoutDetail bankAccountName",
    "VAL_AB_0094": "Invalid PayoutDetail swiftCode",
    "VAL_AB_0095": "Invalid Business.isBusinessLicenseRequired ",
    "VAL_AB_0096": "Invalid mcc ",
    "VAL_AB_0097": "Invalid payment type",
    "VAL_AB_0098": "Invalid frequency type",
    "VAL_AB_0099": "Invalid mdr card discount rate",
    "VAL_AB_0100": "Invalid setup fee",
    "VAL_AB_0101": "Invalid transaction fee",
    "VAL_AB_0102": "Invalid refund processing fee",
    "VAL_AB_0103": "Invalid chargeback processing fee",
    "VAL_AB_0104": "Invalid decline fee",
    "VAL_AB_0105": "Invalid retrival req fee",
    "VAL_AB_0106": "Invalid pre arbitration fee",
    "VAL_AB_0107": "Invalid representment fee",
    "VAL_AB_0108": "Invalid fraud monitoring fee",
    "VAL_AB_0109": "Invalid status.",
    "VAL_AB_0110": "Invalid maintAndSupp fee",
    "VAL_AB_0111": "Invalid ReferralCode",
    "VAL_AB_0112": "Please provide the user type.",
    "VAL_AB_0113": "ReferralCode not applicable for THIRDPARTY",
    "VAL_AB_0114": "Invalid user type",
    "VAL_AB_0115": "Comment can not be empty.",
    "VAL_AB_0116": "Invalid doc type.",
    "VAL_AB_0117": "Invalid info id.",
    "VAL_AB_0118": "Invalid docType .",
    "VAL_AB_0119": "Invalid nature of business.",
    "VAL_AB_0120": "Invalid third party type.",
    "VAL_AB_0121": "Invalid 3PL merchant entity list.",
    "VAL_AB_0122": "Invalid CCY passed for PaymentMethod.settlementCurrencyForHpp",
    "VAL_AB_0123": "Invalid CCY passed for PaymentMethod.settlementCurrencyForRecurring",
    "VAL_AB_0124": "Invalid CCY passed for PaymentMethod.settlementCurrencyForServerApi",
    "VAL_AB_0125": "Invalid CCY passed for PaymentMethod.settlementCurrencyForQR",
    "VAL_AB_0126": "Invalid CCY passed for PaymentMethod.settlementCurrencyForPBL",
    "VAL_AB_0127": "Invalid corpWebsite",
    "VAL_AB_0128": "Invalid stakeholder identification Type ",
    "VAL_AB_0129": "Invalid stock code  ",
    "VAL_AB_0130": "Middle name missing.",
    "VAL_AB_0131": "Invalid nature of business(other).",
    "VAL_AB_0132": "Invalid Other third party type.",
    "VAL_AB_0133": "Invalid noOfEmployees",
    "VAL_AB_0134": "Invalid referralRequest id",
    "VAL_AB_0135": "ReferralRequest email is invalid",
    "VAL_AB_0136": "ReferralRequest companyName is required",
    "VAL_AB_0137": "ReferralRequest contactName is invalid",
    "VAL_AB_0138": "ReferralRequest message is invalid",
    "VAL_AB_0139": "ReferralRequest referralLink is required",
    "VAL_AB_0140": "ReferralRequest resellerName is required",
    "VAL_AB_0141": "ReferralRequest referralCode is required",
    "VAL_AB_0142": "ReferralRequest standardMDR is required",
    "VAL_AB_0143": "ReferralRequest microMDR is required",
    "VAL_AB_0144": "Invalid PayoutDetail branchCode",
    "VAL_AB_0145": "Invalid PayoutDetail bankCode",
    "VAL_AB_0146": "ReferralRequest language is required",
    "VAL_AB_0147": "Invalid file",
    "VAL_ACQ_0000": "",
    "VAL_AUTH_0001": "Email is Invalid",
    "VAL_AUTH_0002": "Id is required",
    "VAL_AUTH_0003": "Password mismatch",
    "VAL_AUTH_0004": "Not a valid id",
    "VAL_AUTH_0005": "OTP is required",
    "VAL_AUTH_0010": "Password is required",
    "VAL_AUTH_0011": "Password length is too short/long",
    "VAL_AUTH_0012": "Expecting numeric value in the otp",
    "VAL_AUTH_0013": "User Id is required",
    "VAL_AUTH_0014": "User Id not valid",
    "VAL_AUTH_0015": "Token details required",
    "VAL_AUTH_0016": "Access token required",
    "VAL_AUTH_0017": "Id token required",
    "VAL_AUTH_0018": "Refresh token required",
    "VAL_AUTH_0019": "OTP required",
    "VAL_AUTH_0020": "Password mismatch",
    "VAL_AUTH_0021": "Confirm password is required",
    "VAL_AUTH_0022": "Invalid OTP length",
    "VAL_CONFIG_0000": "",
    "VAL_DP_0001": "Invalid amount",
    "VAL_DP_0002": "Invalid currency",
    "VAL_DP_0003": "auto_capture required",
    "VAL_DP_0004": "Invalid customer IP",
    "VAL_DP_0005": "Card details are missing",
    "VAL_DP_0006": "Missing billing country",
    "VAL_DP_0007": "Provide a valid email",
    "VAL_DP_0008": "Provide a valid phone number",
    "VAL_DP_0009": "Address line missing",
    "VAL_DP_0010": "Address line 2 missing",
    "VAL_DP_0011": "City missing",
    "VAL_DP_0012": "State missing",
    "VAL_DP_0013": "Postal code missing",
    "VAL_DP_0014": "Invalid subscription plan name",
    "VAL_DP_0015": "Invalid subscription plan type",
    "VAL_DP_0016": "Invalid subscription plan duration",
    "VAL_DP_0017": "Invalid subscription plan cycle",
    "VAL_DP_0018": "MID missing",
    "VAL_DP_0019": "Invalid Subscription plan desc",
    "VAL_DP_0020": "",
    "VAL_DP_0021": "Invalid Subscription cycle type",
    "VAL_DP_0022": "",
    "VAL_DP_0023": "Invalid subscription end type",
    "VAL_DP_0024": "Invalid subscription interval cycle",
    "VAL_DP_0025": "Max_cycle_count missing/not valid",
    "VAL_DP_0026": "Expecting boolean for has trial period",
    "VAL_DP_0027": "Not a valid trial period duration type",
    "VAL_DP_0028": "Not a trial trial period duration",
    "VAL_DP_0029": "Expecting boolean for has discount",
    "VAL_DP_0030": "Not a valid discount percentage",
    "VAL_DP_0031": "Not a valid discount duration",
    "VAL_DP_0032": "Invalid CVC",
    "VAL_DP_0033": "Invalid expiry month",
    "VAL_DP_0034": "Invalid expiry year",
    "VAL_DP_0035": "Invalid card holder name",
    "VAL_DP_0036": "Invalid card number",
    "VAL_DP_0037": "Merchant txn ref is required",
    "VAL_DP_0038": "Merchant txn ref exceeded the character limit of 45",
    "VAL_DP_0039": "Invalid Merchant id",
    "VAL_DP_0040": "Invalid webhook url",
    "VAL_DP_0041": "Invalid success url",
    "VAL_DP_0042": "Invalid decline url",
    "VAL_DP_0043": "Invalid session id",
    "VAL_DP_0044": "Not a valid integer",
    "VAL_DP_0045": "Not a valid number",
    "VAL_DP_0047": "Invalid subscription_id",
    "VAL_DP_0048": "Not a valid Paymentmethod.type",
    "VAL_DP_0049": "Not a valid Paymentmethod.storePaymentMethod",
    "VAL_DP_0050": "Not a valid Paymentmethod.storedPaymentMethodId",
    "VAL_DP_0051": "Not a valid Product",
    "VAL_DP_0052": "Not a valid DASMID",
    "VAL_MS_0085": "subscription.subscriber required",
    "VAL_MS_0086": "Subscriber email required",
    "VAL_MS_0087": "Subscriber first name required",
    "VAL_MS_0088": "Subscriber last name required",
    "VAL_MS_0089": "Plan id required",
    "VAL_MS_0090": "Invalid subscriptionType",
    "VAL_MS_0091": "Invalid subscriptionEndsAt",
    "VAL_MS_0092": "Invalid subscriptionStartsAt",
    "VAL_MS_0093": "Invalid maxCycleCount",
    "VAL_MS_0094": "Dasmid required",
    "VAL_MS_0095": "Missing subscriber details",
    "VAL_MS_0096": "Not a valid link expiry date",
    "VAL_MS_0097": "Amount is out of the allowed range for the selected currency",
    "VAL_PBL_0000": "",
    "VAL_FS_O0008": "Not valid value for ROLLING_RESERVE_HELD",
    "VAL_FS_O0006": "Not valid value for ROLLING_RESERVE_RELEASED",
    "VAL_FS_O0004": "Not valid value for FixedDepositHeldYTDAmount",
    "VAL_FS_O0002": "Not valid value for AdjustmentsAmount",
    "VAL_FS_O0003": "Not valid value for NetSales",
    "VAL_FS_O0001": "Not valid value for TotalFees",
    "defaultErrorMsg": "Internal Server Error",
    "CUSTOM_ERR001": "File must be smaller than 2 MB",
    "ACTION_STATEMENTUPDATE": "The statement update is successful.",
    "ACTION_STATEMENTUPDATEFAILED": "The statement update was not successful.",
    "ADD_NEW_FILTER_ERROR": "Please enter a value to filter",
    "INFO_FS_O0032": "Hashcard Already Exists",
    "INFO_FS_O0033": "Transaction whitelist updated successfully.",
    "INFO_FS_O0038": "Hashcard Already Whitelisted",
    "INFO_FS_O0039": "Hashcard Not Whitelisted",
    "ERR_MS_0039": "Product SKU / Code already exists",
    "ERR_MS_0040": "Category Name already exists",
    "ERR_MS_0046": "Merchant key pair already exists.",
    "ERR_MS_0047": "Merchant key pair not found.",
    "ERR_MS_0052": "Tax config mapping not found",
    "ERR_MS_0053": "Tax config mapping not found for the given merchant",
    "ERR_MS_0054": "Tax config not found for the given merchant subsidiary",
    "VAL100001": "Invalid data format. Please check the data and try again.",
    "INVALID_FILTER_ERROR": "Please enter valid value to filter",
    "INFO_MS_0073": "Merchant key pair generated successfully",
    "INFO_MS_0076": "Merchant Tax Config Fetched Successfully",
    "INFO_MS_0077": "Merchant Tax Config Status Updated Successfully",
  },
  'React-Tour': {
    Configuration: {
      Transactions: {
        heading: 'Transactions',
        content:
          'This is where you can find all your transactions, as well as do a refund or capture for individual transactions.',
      },
      Statements: {
        heading: 'Statements',
        content:
          'For retrieval of all your merchant settlement statements- you can view as well as download a copy of your statements.',
      },
      Merchants: {
        heading: 'Merchants',
        content:
          'Click here to see information of your merchant profile and DASMIDs.',
      },
      'dispute-Management': {
        heading: 'Dispute Management',
        content:
          'If ever a chargeback case is open for your action, you will find this notification bell displayed - click on the icon to see more details of the case at hand.',
      },
      'sales-Lead': {
        heading: 'Sales Lead',
        content: 'If ever a chargeback case is open for your action, you will find this notification bell displayed - click on the icon to see more details of the case at hand.',
      },
      Filter: {
        heading: 'Search Filters',
        content:
          'Use the advanced filter to extract a list of search results with predefined criteria.',
      },
      language: {
        heading: 'Change Language',
        content:
          'Change to your preferred language on the gateway using this option.',
      },
      user: {
        heading: 'User Profile',
        content:
          'Click here to view your user settings and sign out of the portal.',
      },
      Buttons: {
        LetsGo: 'Lets Go!',
      },
    },
    ResellerConfiguration: {
      SalesLead: {
        heading: 'Sales Lead',
        content:
          'Merchant applications submitted using your referral code are listed here for approval. You have the option to reject or approve these applications.',
      },
      Partner: {
        heading: 'Partner',
        content:
          'Access your Partner Account Profile and view your referral details. You can share your referral link with any prospective merchants who wish to connect to the gateway.',
      },
      Filter: {
        heading: 'Search Filters',
        content:
          'Use the advanced filter to extract a list of search results with predefined criteria.',
      },
      language: {
        heading: 'Change Language',
        content:
          'Change to your preferred language on the gateway using this option.',
      },
      user: {
        heading: 'User Profile',
        content:
          'Click here to view your user settings and sign out of the portal.',
      },
      Buttons: {
        LetsGo: 'Lets Go!',
      },
    },
  },
  ContactUs: {
    BreadCrumb: {
      'Home': 'Home',
      'Help & Support': 'Help & Support',
    },
    tabs: {
      'Contact': 'Contact Us',
    },
    SupportForm: {
      'Send us your request': 'Send us your request',
      fields: {
        'Subject': 'Subject',
        'Ticket Type': 'Ticket Type',
        values: {
          'Technical Issue': 'Technical Issues',
          'sales': 'Business/Sales Opportunity',
          'Change Request': 'Change Request',
          'others': 'Others',
        },
        Product: 'Product',
        Description: 'Description',
        Document: 'Attach File',
        helperText: {
          'Optional Message': 'Maximum 500 Characters only.',
        },
        file_upload: {
          'file Size':
            'File is too large, maximum allowed size is $maxSize MB. Current file has $size MB.',
          'image Type': 'File format is not supported.',
        },
      },
      buttons: {
        'Send Request': 'Send Request',
        'Cancel': 'Cancel',
        'Reset': 'Reset',
      },
    },
    Documentation: {
      'Documentation': 'Documentation',
      'Latest': 'Latest',
      'Archieved': 'Archived',
      Links: {
        'API Integration Manual': 'API Integration Manual',
        'User Guide Manual': 'User Guide Manual',
        'Release Notes': 'Release Notes / Change Logs',
      },
    },
  },
  SalesLead: {
    'Heading': 'Merchant Registration',
    'PartnerHeading': 'Partner Registration',
    'Status': 'Status:',
    'RegisterationNumber': 'Application Ref ID:',
    BreadCrumb: {
      'Home': 'Home',
      'Application': 'Onboarding Merchants',
      'PartnerApplication': 'Onboarding Partners',
    },
    AccountsTab: {
      'MerchantAccount': 'Merchant Applications',
      'PartnerAccount': 'Partner Applications',
      'ComingSoon': 'Coming Soon',
    },
    columnDefs: {
      'Action': 'Action',
      'RegisterationNumber': 'Application Ref ID',
      'ApplicationDate': 'Application Date',
      'CustomerLegalName': 'Merchant Account',
      'BusinessLocation': 'Business Location',
      'Email': 'Email Address',
      'RegistrationType': 'Registration Type',
      'Status': 'Status',
      'Products': 'Products',
      'MerchantAccount': 'Merchant Account',
      'PartnerName': 'Partner Name',
    },
    StatusType: {
      'PENDING': 'PENDING',
      'APPROVED': 'APPROVED',
      'REJECTED': 'REJECTED',
      'NOTSUPPORTEDCOUNTRY': 'COUNTRY NOT SUPPORTED',
      'INPROGRESS': 'IN PROGRESS',
      'APPROVALINPROGRESS': 'APPROVAL IN PROGRESS',
      'PENDINGFORDELETION': 'PENDING FOR DELETION',
      'INPROGRESS_REG_NOT_COMPLETED': 'NOT SUBMITTED'
    },
    OnBoarding_Content: {
      'APPROVE': 'APPROVE',
      'REJECT': 'REJECT',
      'ADD': 'ADD PRICING',
      'VIEW': 'VIEW PRICING',
    },
    RegisterationType: {
      'REFERRAL': 'REFERRAL',
      'SELF': 'SELF',
    },
    PricingContent: {
      'heading': 'ADD NEW PRICING',
      'PricingHeading': 'PRICING DETAILS',
      FormFields: {
        'MCC': 'Merchant Category Code',
        'MDR_CARD': 'Blended MDR Card Discount Rate',
        'SETUP_FEE': 'Setup Fee',
        'SUPPORT_FEE_FREQUENCY': 'Maintenance and Support Fee Frequency',
        ANNUAL_FEE: {
          'MONTHLY': 'Monthly',
          'ANNUAL': 'Annual',
        },
        'ANNUAL_MONTHLY_FEE': 'Annual / Monthly Fee',
        'TRANSACTION_FEE': 'Transaction Fee',
        'REFUND_PROCESSING_FEE': 'Refund Processing Fee',
        'CHARGEBACK_PROCESSING_FEE': 'Chargeback Processing Fee',
        'DECLINE_FEE': 'Decline Fee',
        'RETRIEVAL_REQUEST_FEE': 'Retrieval Request Fee',
        'PRE_ARBITRATION_FEE': 'Pre-Arbitration Fee',
        'REPRESENTMENT_FEE': 'Representment Fee',
        'FRAUD_MONITORING_FEE': 'Fraud Monitoring Fee',
        'StandardMDRRate': 'Standard MDR Rate',
        'MicroMDRRate': 'Micro MDR Rate',
        Buttons: {
          'Submit': 'Submit',
          'Cancel': 'Cancel',
        },
      },
    },
    SubmitPricing: {
      title: 'SUBMIT PRICING',
      heading: 'Pricing has not been added !',
      content:
        'Please add pricing for selected products(s) in Payment Methods tab before submitting.',
      ok: 'OK',
      goToPaymentMethods: "Go To Payment Methods"
    },
    ApprovePopup: {
      title: 'APPROVE',
      heading: 'Are you sure?',
      content:
        'Are you sure you want to approve the application? This process can not be undone.',
      message: {
        settlementFailed: 'Application Approval failed..!',
        settlementSuccess: 'Application is Approved..!',
      },
      button: {
        cancel: 'Cancel',
        submit: 'Approve',
      },
    },
    RejectPopup: {
      title: 'REJECT',
      heading: 'Are you sure?',
      content:
        'Are you sure you want to reject the application? This process can not be undone.',
      message: {
        settlementFailed: 'Application rejection failed..!',
        settlementSuccess: 'Application is Rejected..!',
      },
      button: {
        cancel: 'Cancel',
        submit: 'Reject',
      },
    },
    warningMessage:
      'Please note that pricing for some products has not been added',
  },
  TermsAndConditionsHeading: 'Terms & Conditions',
  TermsAndCondtions: {
    BeforeLinkDescription:
      'If you continue to browse and use this website you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern Payment Options relationship with you in relation to this website.\n\nThese terms of use (the ‘terms’), as amended by us from time to time, set out the basis on which you may use the website of ',
    AfterLinkDescription:
      '(the ‘website’) and provide important information about the way we provide our services.\n\nBy accessing the website, you agree to be legally bound by the terms. You are not allowed to use the website if you do not fully agree to the terms.\n\nThe website is owned and operated by Payment Options Pte Ltd, hereinafter Payment Options).The term Payment Options or ‘us’ or ‘we’ refers to the owner of the website.\n\nThe term ‘you’ refers to the user or viewer of our website.',
    DeclerationFirst: '1. DISCLAIMER',
    DeclerationFirstDetails:
      'The website and its contents are provided for general information purposes only and nothing on this website or in its contents is intended to provide legal, data protection compliance or other professional advice. We do not accept any responsibility for any loss which may arise from reliance on information or materials published on this website.\n\nTo the extent permissible by applicable laws, we are not responsible or liable for any matter relating to you or any third parties accessing or using this website and its contents.',
    DeclerationSecond: '2. COPYRIGHT AND TRADEMARKS',
    DeclerationSecondDetails:
      'The website, website content, website code, domain name, and all copyrights, trademarks, corporate names and all other intellectual property or property therein are fully owned by the website operator and/or licensors and/or content providers and are protected by applicable domestic and international intellectual property and other laws.\n\nUnless expressly permitted by the website operator, you shall not copy, capture, reproduce, perform, transfer, sell, license, modify, create derivative works from or based upon, republish, submit, edit, post, transmit, publicly display, frame, distribute, or exploit in whole or in part the website, the website content or website code, or otherwise use the website, website content or website code, in any form or by any means.\n\nThe trademarks or logos included on the site may, however, not be reproduced, published, distributed or used in other ways without the prior written consent of Payment Options.',
    DeclerationThird: '3. LICENSE',
    DeclerationThirdDetails:
      'The website operator grants you in accordance with these terms a non-exclusive, non-transferable, limited right and license to access and use the website and the website content, provided that you comply fully with these terms. You agree not to interfere with or disrupt the website or disobey any legal requirements.',
    DeclerationFourth: '4. APPLICABLE LAW AND JURISDICTION',
    DeclerationFourthDetails:
      'These terms shall be governed by applicable laws.',
    DeclerationFifth: '5. CHANGES',
    DeclerationFifthDetails:
      'Payment Options may, at our sole discretion, change, modify, add or remove any portion of the website, the website content and/or these terms, in whole or in part, at any time. Changes to these terms will be effective when posted. You agree to review these terms periodically to become aware of any changes.',
    DeclerationSixth: '6. WEBSITE NAVIGATIONAL INFORMATION',
    DeclerationSixthDetails:
      'Payment Options uses commonly used information-gathering tools, such as cookies, to collect information as you navigate the Company’s Website. (“Website Navigational Information”). This section describes the types of Website Navigational Information that may be collected on the website and how this information may be used.',
    SixthSubDetailsContainer: {
      SixthSubDetailOne: '6.1 Cookies',
      SixthSubDetailOneDescription:
        'Payment Options uses cookies to make interactions with the website easy and meaningful. When you visit our website, Payment Options servers send a cookie to your computer. Such cookies do not personally identify you. They merely recognize your Web browser. Unless you choose to identify yourself to Payment Options, either by opening an account, or filling out a Web form (such as a “Contact Me”), you remain anonymous to the Company.  Payment Options uses cookies that are session-based and persistent-based. Session cookies exist only during one session. They disappear from your computer when you close your browser software or turn off your computer.\n\n Persistent cookies remain on your computer after you close your browser software or turn off your computer.If you have chosen to identify yourself to Payment Options, the Company uses session cookies containing encrypted information to allow the Company to uniquely identify you. Each time you log into your web account in relation to the Services, a session cookie containing an encrypted, unique identifier that is tied to your web account is placed on your browser. These session cookies allow the Company to uniquely identify you when you are logged into the Services and to process your online transactions and requests. Session cookies are required to use the Services.\n\nPayment Options uses persistent cookies that only we can read and use to identify browsers that have previously visited our website. When you purchase the Services or provide us with personal data, a unique identifier is assigned to you. This unique identifier is associated with a persistent cookie that the Company places on your web browser. We are especially careful about the security and confidentiality of the information stored in persistent cookies. For example, we do not store account numbers or passwords in persistent cookies. If you disable your web browser’s ability to accept cookies, you will be able to navigate our website, but you will not be able to successfully use the Services.\n\nPayment Options may use information from session and persistent cookies in combination with anonymized personal data about the Company’s Customers to provide you with information about the Payment Options and the Services.',
      SixthSubDetailTwo: '6.2 Flash Cookies',
      SixthSubDetailTwoDescription:
        'Payment Options may use local shared objects, also known as flash cookies, to store your preferences or display content based upon what you view on our website to personalize your visit. Third parties with whom Payment Options partners to provide certain features on our website or to display advertising based upon your web browsing activity use flash cookies to collect and store information.',
      SixthSubDetailThree: '6.3 IP Addresses',
      SixthSubDetailThreeDescription:
        'When you visit our Company Website, we collect your Internet Protocol (“IP”) address(es) to track and aggregate non-personal data. For example, Payment Options uses IP addresses to monitor the regions from which Customers and Visitors navigate the Company’s website.',
      SixthSubDetailFour: '6.4 Third Party Cookies',
      SixthSubDetailFourDescription:
        'From time-to-time, Payment Options engages third parties to track and analyze usage and volume statistical information from individuals who visit the Company’s website. The information provided to third parties does not include personal data, but this information may be re-associated with personal data after the Company receives it.',
      SixthSubDetailFive: '6.5 Links to other websites',
      SixthSubDetailFiveDescription:
        'The Company’s websites may contain links to other websites of interest. However, once you have used these links to leave our website, you should note that we do not have any control over such third parties’ websites. Therefore, we cannot be responsible for the protection of the privacy of any personal data which you may provide whilst visiting such third-party websites. You should exercise caution and review the privacy policy(ies) of such third-party websites before disclosing your personal data to such third parties.',
    },
    DeclerationSeven: '7. CONTACT',
    DeclerationSevenOneDetails:
      'For any information regarding the website and services provided by Payment Options please contact us at ',
    DeclerationSevenTwoDetails: '',
    DeclerationEight: '8.LANGUAGE',
    DeclerationEightDetails:
      'In the event of a dispute to this Terms of Use, the English version shall prevail. The English language version of this Terms of Use shall control in all respects and shall prevail in case of any inconsistencies with translated versions.  Nothing in this Terms of Use shall limit your rights under applicable laws.',
  },
  PrivacyPolicyHeading: 'Privacy Policy',
  ResellerAccount: {
    breadcrumbs: {
      Home: 'Home',
      // Partner: 'Partner',
    },
    tabs: {
      Account: 'Partner Account',
      Statements: 'Commission Statements',
    },
    button: {
      CREATE_ACCOUNT: 'Create Account',
    },
    // Heading: 'Partner Account',
    fields: {
      RefferalCode: 'Referral Code',
    },
    columnDefs: {
      Action: 'Action',
      ResellerName: 'Partner Name',
      ResellerNameInEnglish: 'Partner Name (English)',
      ContactPerson: 'Contact Person',
      Email: 'Email Address',
      Date: 'Created Date',
      ReferredMerchants: 'Referred Merchants',
      STATUS: 'Status',
      Country: 'Country',
      Products: 'Products',
    },
    StatusTypes: {
      ACTIVE: 'ACTIVE',
      CLOSED: 'INACTIVE',
    },
    TypeOfThirdParty: {
      EXTSALS: 'External Sales Agent',
      RESELLER: 'Partners',
      REFERRAL: 'Referrers',
      INDIVIDUAL: 'Individual',
      OTHER: 'Others',
    },
  },
  ResellerDetails: {
    breadcrumbs: {
      'Home': 'Home',
      'Partner': 'Partner',
      'Partner Details': 'Partner Details',
    },
    AllDetails: {
      label: 'Partner Details',
      PersonalDetails: {
        'Partner Name': 'Partner Name',
        'Partner Name English': 'Partner Name (English)',
        'Address': 'Address',
        'City': 'City',
        'Country': 'Country',
      },
      ContactDetails: {
        'Contact Details': 'Contact Details',
        'First Name': 'First Name',
        'Middle Name': 'Middle Name',
        'Last Name': 'Last Name',
        'Telephone Number': 'Phone Number',
        'Email': 'Email Address',
      },
      ReferralDetails: {
        'Referral Details': 'Referral Details',
        'Referral Code': 'Referral Code',
        'Referral Link': 'Referral Link',
      },
      ReferredMerchants: {
        'Referral Merchants': 'Referral Merchants',
      },
      ResellerCommissionRates: {
        label: 'Reseller Commission Rates',
        columnDefs: {
          MdrToMerchant: 'MDR TO MERCHANT',
          Commission: 'Commission',
        },
      },
    },
    SendReferralLinkViaEmail: {
      'Create Email': 'CREATE EMAIL',
      'Description Text':
        'Please fill in the form to send your referral link through email',
      'Email Address': 'EMAIL ADDRESS',
      'Company Name': 'COMPANY NAME',
      'Contact Person Name': 'CONTACT PERSON NAME',
      'Message': 'MESSAGE',
      'Referral Link': 'REFERRAL LINK',
      'Send': 'Send',
      'Standard MDR Rate': 'STANDARD MDR RATE',
      'Micro MDR Rate': 'MICRO MDR RATE',
      'Min Value': 'Value must be greater than 0',
      'Max Value': 'Value must be less than or equal to 100',
      'Language': 'SELECT LANGUAGE',
    },
    CreateEmai: 'CREATE EMAIL',
    MERCHANT: 'MERCHANT',
    THIRDPARTY: 'THIRDPARTY',
    'Merchant': 'Merchant',
    'Partner': 'Partner',
    'MerchantRegistration': 'Merchant Registration',
    'PartnerRegistration': 'Partner Registration',
    'Onboarding': "Onboarding"
  },

  Onfido_Message: {
    KYC_INVITE: {
      "Title": "Verify your identity",
      "Greeting": "Hello {{name}},",
      "Description": "To complete onboarding, we need to verify your identity. This takes about a minute using your Singpass account.",
      "Description_For": "To complete onboarding for {{business}}, we need to verify your identity. This takes about a minute using your Singpass account.",
      "Thanks_Title": "Thank you",
      "Thanks_Body": "Your identity has been verified. There is nothing further for you to do.",
      "Review_Title": "Thanks — we'll take it from here",
      "Review_Body": "Your details are being reviewed. Someone will be in touch if anything else is needed.",
      "Error_Title": "We could not complete verification",
      "Invalid": "This verification link is not valid or has expired. Please ask for a new one.",
      "Close_Tab": "You can close this tab.",
      "Privacy_Note": "We only retrieve the details needed to confirm your identity.",
      "Recipient": "Send to",
      "Recipient_Placeholder": "name@company.com",
      "Send": "Send",
      "Invalid_Email": "Enter a valid email address.",
      "Alternate_Note": "This differs from the address on the stakeholder record.",
      "Use_Email": "Email the link instead",
      "Email_Helper": "Send a Singpass verification link to this stakeholder's email address.",
      "Sent": "Verification link sent to {{email}}",
      "Send_Failed": "Could not send the verification link."
    },
    KYC_REVIEW: {
      "Title": "Singpass verification details",
      "Description": "These are the details Singpass returned, compared against what this application already holds.",
      "Field": "Field",
      "On_Record": "On record",
      "From_Singpass": "From Singpass",
      Fields: {
        "nric": "NRIC/FIN",
        "name": "Name",
        "dob": "Date of birth",
        "nationality": "Nationality"
      },
      "Masked_Note": "NRIC/FIN is shown masked. The full value remains on the stakeholder record.",
      "Retrieved_At": "Retrieved",
      "No_Data": "No verification details available for this stakeholder yet.",
      "Not_Returned": "Not returned by Singpass",
      "Load_Failed": "Could not load verification details."
    },
    KYC_METHOD: {
      "Not_Provisioned": "This Singpass account has no Myinfo profile, so we could not retrieve the details to verify. Please use a Myinfo-enabled Singpass account, or verify with Onfido instead.",
      "Description_For": "Choose how {{name}} should complete identity verification.",
      "Or": "or",
      "Singpass_Helper": "Instant. We'll match your Singpass details against this stakeholder's record.",
      "Onfido_Helper": "Upload an identity document and take a selfie. Usually reviewed within minutes.",
      "Onfido_Requirements_Label": "Note:",
      "Onfido_Requirements": "Before starting Onfido, first name, last name, email address, and country of residence must be filled in for this stakeholder.",
      "Title": "How would you like to verify?",
      "Description": "Choose Singpass to verify instantly using your Singpass account, or Onfido to upload identity documents.",
      "Use_Singpass": "Verify with",
      "Use_Onfido": "Verify with Onfido",
      "Starting": "Starting...",
      "Cancel": "Cancel",
      "Singpass_Unavailable": "Singpass verification needs an NRIC/FIN on the stakeholder record.",
      "Review_Message": "Your Singpass details did not match our records. Your KYC is now under review.",
      "Error_Message": "Singpass verification could not be completed. Please try again or verify with Onfido.",
    },
    UPDATE_KYC: {
      "Title_Update_KYC": "UPDATE KYC",
      "POPUP_TEXT": "<p>Click on <strong>&quot;START VERIFICATION &quot;</strong> to Initiate Your KYC</p><p>OR Copy Below Link to Share</p>",
      "VERIFY_YOUR_IDENTITY": "Verify Your Identity",
      "BTN_CANCEL": "CANCEL",
      "BTN_START_KYC": "START KYC",
    },
    KYC_Processing_STATUS: {
      "Thank You": "Thank You",
      "Completed": "Your KYC has been Successfully Completed.",
      "Processing": "Your KYC Verification is Under Process.",
      "Review": "Your KYC Verification is Under Review.",
      "Failed": "Your KYC Verification Failed.",
      "update": "Your computer may take a few seconds to update.",
      "Continue to Stakeholders": "Continue to Stakeholders"
    },
    "Document_List": "Document List",
    "Document_Name": "Document Name",
    "Download": "Download",
    "Document_Type": "Document Type",
    "Document_Side": "Document Side",
    "Uploaded_At": "Uploaded At",
    "Document_Refresh": "Refresh Document List",
    "Complete_Your_KYC": "Complete Your KYC",
    "Retry_Your_KYC": "Retry KYC",
    Prompt_Message: {
      "requiredKYC": "KYC Status should be Completed for all Stakeholders",
      "Tooltip": "KYC Status should be Completed for all Stakeholders",
    },
    KYC_STATUS: {
      "Pending": "Pending",
      "Completed": "Completed",
      "Rejected": "Rejected",
      "Processing": "Processing",
      "Review": "Review",
      "Manual KYC required": "Manual KYC required",
    }
  },

  MFA: {
    "SETUP_DEVICE": "Set up device",
    "SUBMIT_BUTTON": "Submit",
  },
  "RISK_RULES": {
    "Action": "Action",
    "Create Rule": "Create Rule",
    "UpdatedAt": "Updated Date",
    "CreatedAt": "Created Date",
    "Assignments": "Levels",
    "Conditions": "Conditions",
    "IsActive": "Status",
    "RuleType": "Rule Type",
    "Name": "Rule Name",
    "Updated": "Updated",
    "Created": "Created",
    "LevelDASMID": "Level DASMID",
    "LevelMerchant": "Level Merchant",
    "LevelAcquirer": "Level Acquirer",
    "LevelEntity": "Level Entity",
    "Description": "Description",
    "Rule Description": "Rule Description",
    "Duration Unit": "Duration Unit",
    "Duration Value": "Duration Value",
    "Velocity Limit": "Velocity Limit",
    "Timezone": "Timezone",
    "Duration": "Timeframe",
    "Add Condition": "Add Condition",
    "Please Click On Add Button to Add Conditions": "Please Click On Add Button to Add Conditions",
    "Add Level": "Add Level",
    "Please Click On Add Button to Add Assignments": "Please Click On Add Button to Add Assignments",
    "Level Value": "Level Value",
    "Level Type": "Level Type",
    "File Upload": "File Upload",
    "Value": "Value",
    "Field": "Field",
    "Aggregate": "Aggregate",
    "Operator": "Operator",
    "No items": "No items",
    "Whitelist": "Whitelist",
    "Blacklist": "Blacklist",
    "Type to Search": "Type to Search...",
    "Risk Rule Details": "Risk Rule Details",
    "Column_Def": {
      "Assignments": "Assignments",
      "Conditions": "Conditions"
    },
    "Popup_Content": {
      "Confirm Rule Deletion": "Confirm Rule Deletion",
      "Are you sure?": "Are you sure?",
      "Do you really want to delete": "Do you really want to delete",
      "This process can not be undone.": "This process can not be undone."
    }
  },
  "HashCard": {
    "Add Hash Card": "Add Hash Card",
    "Edit Hash Card": "Edit Hash Card",
    "Export to Excel": "Export to Excel",
    "Current Year Only": "Export to Excel (Current Year Only)",
    "Previous Comments": "Previous Comments",
    "Hash Card Details": "Hash Card Details",
    "Column_Def": {
      "Hash Card Number": "Hash Card Number",
      "Status": "Status",
      "Created Date": "Created Date",
      "Created By": "Created By",
      "Updated Date": "Updated Date",
      "Updated By": "Updated By"
    },
    "Form_Fields": {
      "Hash Card Number": "Hash Card Number",
      "Status": "Status",
      "Comments": "Comments",
    },
    'ApprovePopup': {
      'titleAdd': 'ADD HASH CARD',
      'titleEdit': 'UPDATE HASH CARD',
      'heading': 'Are you sure?',
      'contentAdd': 'Are you sure you want to add the Hashcard Number?',
      'contentEdit': 'Are you sure you want to update the Hashcard Status?',
      'button': {
        'cancel': 'Cancel',
        'submit': 'Submit',
      },
      "Validation": {
        "ExactLength": "Hash Card Number must have exactly 32 characters",
        "MaxLength": "Maximum 128 Characters only."
      },
    },

  },
  Transaction_Xray: {
    "Transaction X-Ray": "Transaction X-Ray",
    "API Response": "API Response",
    "Please Select any service for the Api requests and responses": "Please select any service for the Api requests and responses",
    "Request": "Request",
    "Processor": "Processor",
    "Acquirer": "Acquirer "
  },
  User_Settings: {
    "Select File Format": "Select Report Format",
    "default": "default",
    "Select Date Format": "Select Date Format",
    "Select Currency": "Select Currency for Aggregation",
    "No previously selected list found": "No previously selected list found",
    "Column Preference": "Column Preference",
    "Report Preference": "Report Preference",
    "Add Custom Preference List": "Add Custom Preference List",
    "Add Report Preference List": "Add Report Preference List",
    "Preference List error message": "name already exists. Please enter a unique name.",
    "Custom Preference List": "Custom Preference List",
    "Custom Report Preference List": "Select Report Preference List",
    "Edit Column Preference List": "Edit Report Preference List",
    "Do you really want to update the custom report preference list?": "Are you sure you want to update the report preference list?",
    "Add Statement Preference List": "Add Statement Preference List",
    "Add Statement Preference": "Add Statement Preference",
    "Delete Statement Preference List": "Delete Statement Preference List",
    "Edit Statement Preference List": "Edit Statement Preference List",
    "Do you really want to update the statement preference list?": "Are you sure you want to update the statement preference list?",
    "Select Preferred Statement List": "Select Preferred Statement List",
    "Custom Statement Preference List": "Select Statement Preference List",
    "Add Transaction Preference List": "Add Transaction Preference List",
    "Add Transaction Preference": "Add Transaction Preference List",
    "Transaction Preference": "Transaction Preference List",
    "Statement Preference": "Statement Preference List",
    "Select Preferred Transaction List": "Select Preferred Transaction List",
    "Custom Transaction Preference List": "Select Transaction Preference List",
    "Select Preferred List": "Select Preferred List",
    "Select Preferred Report List": "Select Preferred Report List",
    "Enter List Name": "Enter List Name",
    "Delete Preference List": "Delete Preference List",
    "Delete Transaction Preference List": "Delete Transaction Preference List",
    "Delete Report Preference List": "Delete Report Preference List",
    "Edit Transaction Preference List": "Edit Transaction Preference List",
    'Are you sure?': 'Are you sure?',
    "Download Started": "Download Started",
    "Do you really want to delete this record? This process can not be undone": "Do you really want to delete this list? This process can not be undone.",
    "Do you really want to update the transaction preference list?": "Are you sure you want to update the transaction preference list?",
    "Email Notification": "Email Notification",
    "Email Notification Settings": "Email Notification Settings",
    "Email Notification Settings Description": "Select / Deselect Email Notifications for Primary Contact",
    "Default list applied": "Default list applied",
    "Dispute Preference List": "Dispute Preference List",
    "Delete Dispute Preference List": "Delete Dispute Preference List",
    "Edit Dispute Preference List": "Edit Dispute Preference List",
    "Do you really want to update the dispute preference list?": "Are you sure you want to update the dispute preference list?",
    "Custom Dispute Preference List": "Select Dispute Preference List",
    "Add Dispute Preference List": "Add Dispute Preference List",
    "tabs": {
      "Report Format": "Download Report Format",
      "Date Format": "Date Format",
      'Date Report Format': 'Report & Date Format',
      'Email Notification': 'Email Notifications',
      "Report Preference": "Report Preference",
    },
    "notifications": {
      "Chargeback": "Chargeback",
      "Statement": "Statement",
      "Emergency Holiday": "Emergency Holiday",
      "Monthly Public Holiday": "Monthly Public Holiday"
    },
    "dateFormats": {
      "DATE_TIME_AM_PM": "DD MONTH YYYY, hh:MM:SS AM/PM (Example: 21 November 2024, 2:04:28 PM)",
      "DATE_TIME_DMY": "DD MONTH YYYY, HH:MM:SS (Example: 21 November 2024, 14:04:28)",
      "DATE_TIME_YMD": "YYYY/MM/DD HH:MM:SS (Example: 2024/11/21 14:04:28)"
    },
    "fileFormat": {
      "EXCEL": "EXCEL",
      "CSV": "CSV"
    },
    buttons: {
      "Save": "Save",
      "Add": "Add"
    }
  },
  applicationApprovalLevel: {
    "0": "",
    "1": "Read Only",
    "10": "Inputter",
    "20": "Manager",
    "30": "Head of Department",
    "40": "Managing Director",
    "50": "Group Executive",
    "60": "Managing Group Director",
  },
  "DasPay_Receipts": {
    "tx": "tx#",
    "Payment": "Payment Method",
    "Total": "Total",
    "MID": "MID",
    "TID": "TID",
    "Batch": "Batch",
    "Trace": "Trace",
    "RRN": "RRN",
    "ApprovalCode": "Approval Code",
    "AdditionalInformation": "Additional Information",
    "TransactionId": "TRANSACTION ID",
    "STATE": "STATE",
    "DateTime": "DATE TIME",
    "ATC": "ATC",
    "TVR": "TVR",
    "AppName": "APP NAME",
    "TSI": "TSI",
    "AID": "AID",
    "TC": "TC",
    "Notes": "NOTES",
    "TaxRegistrationNo": "TAX REGISTRATION NO",
    "DigitalSignature": "Digital Signature",
    "SignedAt": "Signed at",
    "ShareWithOthers": "Share with others",
    "Email": "Email",
    "Share": "Share",
    "PrintReceipt": "Print Receipt",
    "TransactionType": "Transaction Type",
    TotalItems: 'Total Item(s)',
    TotalServiceFee: 'Total Service Fee',
    AdditionalCharge: 'Additional Charge',
    GST: 'GST',
  },
  "PresetFilter": {
    "Select Preset": "Select Preset",
    "Update": "Update",
    "Delete": "Delete",
    "Save": "Save",
    "Enter Name": "Enter Name",
    "Update Name": "Update Name",
    "Cancel": "Cancel",
    "Add Preset": "Add Preset",
    "Update Preset": "Update Preset",
    "Confirm Delete": "Delete Preset Filter",
    "Are you sure you want to delete?": "Do you really want to delete this preset filter? This process cannot be undone.",
    "Name Already Exists": "Preset filter already exists with same name.",
  },
  "Report Days": "Report Days",
  "Weekly": "Weekly",
  "ScheduleReport": {
    "Add": "Add Schedule Report",
    "Edit": "Edit Schedule Report",
    "Previous Comments": "Previous Comments",
    "Weekdays": {
      "Sunday": "Sunday",
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday"
    },
    "Column_Def": {
      "Name": "Schedule Name",
      "Status": "Status",
      "Report Name": "Report Name",
      "Reporting Timezone": "Report Timezone",
      "Reporting Period": "Report Period",
      "Created By": "Created By",
      "Updated Date": "Updated Date",
      "Updated By": "Updated By",
      "Comments": "Comments",
      "Report Preference": "Report Preference",
    },
    "Form_Fields": {
      "Name": "Schedule Name",
      "Status": "Status",
      "Report Name": "Report Name",
      "Reporting Timezone": "Report Timezone",
      "Reporting Period": "Report Period",
      "Reporting Preference": "Report Preference",
      "Preset Filter": "Preset Filter",
      "Include Sensitive Columns": "Include Sensitive Columns",
      "Include Whitelist Transactions": "Include Whitelist Transactions",
      "Report Format": "Report Format",
      "Reporting Time": "Report Time",
      "Report Day": "Report Day",
      "Report Monthly Date": "Month Date",
      "Comments": "Comments",
    },
    "ReportName": {
      "Transactions": "Transactions",
    },
    "ReportingPeriod":{
      "Today":"Today",
      "Yesterday":"Yesterday",
      "Weekly":"Settlement Weekly",
      "Month to Date":"Month to Date",
      "Month Start to Yesterday":"Month Start to Yesterday",
      "Previous_Month":"Previous_Month",
      "Last 30 Days":"Last 30 Days",
      "Last 7 Days":"Last 7 Days",
      "Years to Date":"Years to Date"
    },
    "Validation":
    {
      "DuplicateName": "Schedule report with same name already created. Please provide a different name."
    }
  },
};
export default common;
